export default {
  locale: 'it',
  messages: {
    accountMy: 'Il mio account',
    actions: 'Azioni',
    add: 'Aggiungi',
    addressAddNew: 'Aggiungi un nuovo indirizzo',
    addressCity: 'Città',
    addressCountries: 'Paesi',
    addressCountry: 'Paese',
    addressDeleteConfirmTitle: 'Elimina un indirizzo',
    addressDeleteConfirmMessage: 'Vuoi davvero eliminare questo indirizzo?',
    addressDeleteSuccess: 'Indirizzo eliminato con successo!',
    addressEdit: 'Modifica indirizzo',
    addressFlags: 'Bandiere',
    addressInvoice: 'Indirizzo di fatturazione',
    addressInvoiceDifferentAsShippingLabel: 'I dati di fatturazione sono diversi dall\'indirizzo di spedizione?',
    addressInvoiceSelectionTitle: 'Seleziona il tuo indirizzo di fatturazione',
    addressInvoiceUsedFor: 'Utilizzato per la fattura',
    addressInvoiceUse: 'Usa per la fattura',
    addressLabel: 'Nome dell\'indirizzo (es: Casa, Ufficio)',
    addressLegalInformation: 'Informazioni legali',
    addressMy: 'I miei indirizzi',
    addressName: 'Nome e cognome del destinatario',
    addressNoItems: 'Non hai ancora salvato alcun indirizzo!',
    addressPhone: 'Telefono (necessario per la consegna)',
    addressPostalCode: 'Codice postale',
    addressRegion: 'Provincia',
    addressShipping: 'Indirizzo di spedizione',
    addressShippingSelectionTitle: 'Seleziona il tuo indirizzo di spedizione',
    addressStreet1: 'Indirizzo',
    addressStreetNumberHint: 'Ricorda il numero civico: senza di esso il corriere spesso non trova l\'indirizzo.',
    addressPostalCodeInvalid: 'Questo codice postale non corrisponde al paese selezionato.',
    addressPhoneInvalid: 'Questo numero sembra errato. Il corriere lo usa per contattarti.',
    addressPhoneMobileHint: 'Consigliamo un cellulare: il corriere invia l\'avviso di consegna via SMS.',
    addressIssueTitle: 'Questo indirizzo deve essere completato prima della spedizione',
    addressIssueIncomplete: 'Mancano alcuni campi obbligatori.',
    addressIssuePostalCode: 'Controlla il codice postale per il paese selezionato.',
    addressIssuePhone: 'Serve un numero di telefono raggiungibile: il corriere ti chiama o invia l\'avviso di consegna.',
    addressIssueRegion: 'Seleziona la provincia richiesta dal corriere.',
    addressIssueTaxId: 'La dogana richiede un codice fiscale per questa destinazione.',
    addressIssueComplete: 'Completa questo indirizzo',
    addressStreet2: 'Info aggiuntive (appartamento, scala, citofono...)',
    administrationTitle: 'Amministrazione',
    affiliationComment: 'Commento',
    affiliationCommission: 'Commissione',
    affiliationCommissionMultiplePendingAlert: 'Questa lista è una stima: Gli ordini e le commissioni non sono ancora consolidati!',
    affiliationCommissionPendingAlert: 'Questo ordine è in attesa di convalida',
    affiliationDeleteConfirmMessage: 'Vuoi davvero eliminare questa affiliazione?',
    affiliationInvoiceTotalTitle: 'Totale da incassare (IVA incl.)',
    affiliationKey: 'Chiave di affiliazione',
    affiliationLegalApplyVAT: 'Applicare l\'IVA?',
    affiliationLegalInformations: 'Informazioni legali (fatturazione, P. IVA...)',
    affiliationMy: 'Le mie affiliazioni',
    affiliationOptionValidityDays: 'Validità del link di affiliazione (giorni)',
    affiliationSince: 'Membro dal',
    affiliationViewResultsMy: 'Vedi i ricavi di affiliazione',
    affiliations: 'Affiliazioni',
    alertContactError: 'Impossibile inviare il tuo messaggio! Riprova, per favore...',
    alertContactSuccess: 'Ricevuto!',
    alertConversationNoExists: 'Questa chat non esiste!',
    alertFetchApiError: 'Il server è attualmente fuori servizio...',
    alertFormRequiredFieldsError: 'Compila tutti i campi obbligatori!',
    alertGenericError: 'Si è verificato un errore! Riprova più tardi...',
    alertInstitutionAlreadyExists: 'Questa istituzione esiste già!',
    alertJsonParseError: 'Il server ha restituito una risposta non valida...',
    alertOrderValid: 'Il tuo ordine è pronto per la preparazione!',
    alertUnauthorized: 'La tua sessione è scaduta! Accedi di nuovo, per favore.',
    alertUserAlreadyExists: 'Esiste già un account con questa email!',
    alertUserRegisterSuccess: 'Ti diamo il benvenuto!',
    app404ErrorText: 'Non riusciamo a trovare quello che cerchi! Torna alla home page o al tuo account.',
    app404ErrorTitle: 'Strada sbagliata...',
    appAccessButton: 'Accedi a {app}',
    appAgreementAcceptButton: 'Leggi le condizioni generali d\'uso',
    appAgreementAcceptHelp: 'Puoi leggere le condizioni cliccando su questo link',
    appAgreementAcceptClickHint: 'Clicca qui per spuntare e accettare',
    appAgreementAcceptLabel: 'Ho letto e accetto le condizioni generali',
    appApplication: 'Applicazione',
    appBackHomeButton: 'Torna alla home',
    appBackHomeTitle: 'Ti sei perso...',
    appBugErrorText: 'Si è verificato un problema... CI DISPIACE! Clicca sul link qui sotto per ricaricare questa pagina...',
    appConditionsAcceptTitle: 'Condizioni generali d\'uso',
    appConditionsCheckError: 'Ti preghiamo di confermare la lettura delle condizioni generali d\'uso!',
    appConditionsCheckLabel: 'Ho letto e accetto le condizioni generali d\'uso',
    appConditionsCheckSuccess: 'Ricevuto!',
    appConditionsUpdateDate: 'Aggiornato il {date}',
    appConfig: 'Config',
    appConfiguration: 'Configurazione',
    appCookieConsentPrivacyLink: 'Consulta la nostra privacy policy',
    appCookieConsentText: 'Continuando a navigare su questo sito, accetti l\'utilizzo dei cookie per il corretto funzionamento del servizio e per finalità statistiche. Nessun dato personale verrà condiviso senza il tuo preventivo consenso.',
    appCreateIndexButton: 'Crea l\'indice del database',
    appDataPrivacyCheckButton: 'Leggi la nostra politica sulla protezione dei dati',
    appDatabase: 'Database',
    appErrorAlertText: 'È successo qualcosa di inaspettato... Niente panico! Contattaci e risolveremo il problema il prima possibile.',
    appErrorAlertTitle: 'Si è verificato un errore!',
    appForceUpdateApp: 'Forza l\'aggiornamento dell\'App',
    appForceUpdateAppWeb: 'Forza l\'aggiornamento della Web App',
    appHome: 'Home',
    appMaintenanceModeText: 'Attendi un momento e riprova tra poco...',
    appMaintenanceModeTitle: 'Siamo in manutenzione',
    appProcessLaunch: 'Processo di lancio',
    appQuestionLink: 'Hai domande?',
    appRewiewsHeaderText: 'Realizzato in Francia 🇫🇷 con Amore ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 recensioni su Trustpilot',
    appShopOrderHistory: 'Tracciamento dell\'ordine',
    appStart: 'Crea il tuo libro',
    appVersion: 'Versione',
    appVersionCurrent: 'Versione attuale dell\'app: {version}',
    appWebsiteAboutUs: 'La nostra storia',
    appWebsiteBlog: 'Blog',
    appWebsiteBook: 'Il libro',
    appWebsiteConversationAndroid: 'Stampa SMS da Android',
    appWebsiteConversationInstagram: 'Stampa messaggi Instagram',
    appWebsiteConversationIos: 'Stampa iMessage/SMS da iPhone',
    appWebsiteConversationMessenger: 'Stampa messaggi Messenger',
    appWebsiteConversationWhatsapp: 'Stampa messaggi WhatsApp',
    appWebsiteConversations: 'Scegli la tua messaggistica',
    appWebsiteFaq: 'FAQ',
    appFooterQuestion: 'Hai una domanda?',
    appFooterTerms: 'Condizioni d\'uso',
    appWebsitePrices: 'Tariffe',
    appWelcomeTitle: 'Benvenuto su {name}',
    apply: 'Applica',
    back: 'Indietro',
    by: 'da',
    cancel: 'Annulla',
    cartAddTo: 'Aggiungi al carrello',
    cartAuthInfo: 'Inserisci la tua email per continuare...',
    cartContinuePurchase: 'Continua lo shopping',
    cartEmptyError: 'Il tuo carrello è vuoto...',
    cartItemsRemoveAll: 'Rimuovi tutto',
    cartMy: 'Il mio carrello',
    cartMyEdit: 'Modifica il mio carrello',
    cartNextStepButton: 'Vai al passaggio successivo',
    cartNoItems: 'Non ci sono articoli nel tuo carrello.',
    cartNote: 'Nota',
    cartProgression: 'Avanzamento del carrello',
    cartSalesConditionsAccept: 'Confermando l\'ordine, accetti le nostre condizioni di vendita.',
    cartSee: 'Vedi il mio carrello',
    cartShipping: 'Spedizione',
    cartShippingFeeError: 'Non possiamo spedire a questo indirizzo! Inserisci un indirizzo diverso, per favore.',
    cartStepConfirmationTitle: 'Conferma',
    cartStepInvoiceTitle: 'Fatturazione',
    cartStepPaymentTitle: 'Pagamento',
    cartStepPreviewTitle: 'Carrello',
    cartStepShippingTitle: 'Spedizione',
    cartTotalShipping: 'Spese di spedizione',
    cartTotalSubTotal: 'Subtotale',
    cartTotalTax: 'IVA',
    cartTotalTotal: 'Totale',
    cartValidButton: 'Conferma il mio ordine',
    checkoutEyebrow: 'Il tuo ordine',
    checkoutStepUpsellTitle: 'Una copia, o due?',
    checkoutStepUpsellTitleGroup: 'Una copia, due? O di più?',
    checkoutStepUpsellHint: 'Tienine una, regalane una a una persona cara, o entrambe.',
    checkoutStepUpsellHintGroup: 'Una per ciascuno: sconto dalla seconda copia.',
    checkoutStepShippingTitle: 'Dove ricevere il tuo libro?',
    checkoutStepShippingHint: 'Lo stampiamo con cura e lo spediamo in tutto il mondo.',
    checkoutStepInvoiceTitle: 'I tuoi dati',
    checkoutStepInvoiceHint: 'Per la tua fattura e il tracciamento dell\'ordine.',
    checkoutStepPaymentTitle: 'Paga in tutta sicurezza',
    checkoutStepPaymentHint: 'Carta, Apple Pay, Google Pay: pagamento crittografato.',
    checkoutPdfReadyTitle: 'Il tuo eBook è pronto',
    checkoutPdfReadyHint: 'Nessuna spedizione necessaria, finalizza il tuo ordine.',
    checkoutSummaryEyebrow: 'Riepilogo',
    cartReassuranceSecure: 'Pagamento sicuro',
    cartReassuranceReturn: 'Soddisfatti o rimborsati',
    cartReassuranceSupport: 'Assistenza clienti',
    checkoutPromoEyebrow: 'Codice promozionale',
    checkoutGiftEyebrow: 'Carta regalo',
    checkoutGiftCodeLabel: 'Codice regalo',
    checkoutGiftCodePlaceholder: 'Inserisci il tuo codice regalo',
    checkoutGiftCodeHint: 'Hai ricevuto una carta regalo? Inserisci il tuo codice qui.',
    checkoutGiftToggle: 'Hai una carta regalo?',
    checkoutAddCopy: 'Aggiungi una copia',
    checkoutSecondCopyKicker: 'Per te, o da regalare',
    checkoutSecondCopyKickerGroup: 'Uno per ciascuno',
    checkoutSecondCopyTitle: 'La copia in più, a metà prezzo',
    checkoutSecondCopyTitlePercent: 'La copia in più',
    checkoutSecondCopyFor: 'questa copia',
    checkoutSecondCopyForGroup: 'la 2ª',
    checkoutSecondCopyChip: '2ª a metà prezzo',
    checkoutSecondCopyChipPercent: '2ª al −{percent} %',
    checkoutSecondCopySet: 'Tutti i {count} volumi, insieme',
    checkoutSecondCopyPerBook: 'ogni libro',
    checkoutSecondCopySetPrice: '{price} per tutti i {count} volumi',
    checkoutExtraBooksChip: 'libri in più a metà prezzo',
    checkoutExtraBooksChipPercent: 'libri in più al −{percent} %',
    checkoutGroupQtyHint: 'Anche la terza: ogni libro in più, al −{percent} %.',
    productExtraCopyRate: 'Libri in più, in % del prezzo di un libro',
    productExtraCopyRateHelp: 'Ogni libro oltre la prima copia vale questa percentuale del prezzo di un libro. Vuoto: 50 %. 0: scaglioni quantità.',
    checkoutGroupPicksLabel: 'Copie',
    checkoutGroupAddSecond: '2ª',
    checkoutGroupAddThird: '3',
    checkoutGroupAddSecondAria: 'Aggiungi la seconda copia a metà prezzo',
    checkoutGroupAddThirdAria: 'Passa a tre copie',
    checkoutQtyGroupHint: 'Uno per ciascuno: lo sconto parte dalla seconda copia.',
    checkoutQtyPdfSingle: '1 eBook',
    checkoutQtyMoreAriaLabel: 'Altra quantità',
    checkoutQtyVolumeBreakdown: '{copies} copie × {volumes} volumi = {total} libri',
    checkoutOfferBookCount: '{count, plural, one {# libro} other {# libri}}',
    checkoutUpsellTwoHint: 'Ideale da regalare: aggiungi una seconda copia, lo sconto si applica automaticamente.',
    checkoutEmptyTitle: 'Nessun ordine in corso',
    checkoutEmptyHint: 'Torna al tuo libro per scegliere la tua edizione.',
    checkoutEmptyCta: 'Vedi le mie conversazioni',
    checkoutBookAsideEyebrow: 'Il tuo libro',
    checkoutBookAsideEyebrowPlural: 'I tuoi libri',
    checkoutBookAsideVolume: 'volume',
    checkoutBookAsideVolumes: 'volumi',
    checkoutBookAsideShelfLabel: 'I {count} volumi del tuo ordine',
    checkoutBookAsideEbook: 'eBook',
    checkoutBookAsidePaper: 'Libro cartaceo',
    checkToggler: 'Seleziona/Deseleziona tutto',
    choose: 'Scegli',
    close: 'Chiudi',
    cmsDeleteConfirmTitle: 'Elimina il contenuto',
    cmsDeleteConfirmMessage: 'Vuoi davvero eliminare questo contenuto?',
    companyShippingEdit: 'Modifica trasporto',
    conditions: 'Condizioni',
    configMissingKeyAlert: 'Manca la chiave di configurazione!',
    configuration: 'Configurazione',
    confirm: 'Conferma',
    confirmMessage: 'Conferma la tua azione.',
    confirmTitle: 'Confermi?',
    contactButton: 'Contattaci',
    contactMessage: 'Messaggio',
    contactPageButton: 'Invia',
    contactPageText1: 'Hai bisogno di aiuto o informazioni? Siamo qui per te!',
    contactPageTitle: 'Contattaci',
    contactSend: 'Invia',
    continue: 'Continua',
    conversationActionContinue: 'Continua',
    conversationActionRestart: 'Ricomincia',
    conversationAddTitle: 'Aggiungi una chat',
    conversationAdminDeleteConfirmTitle: 'Elimina la chat',
    conversationAdminDeleteConfirmMessage: 'Questa chat e tutti i suoi media verranno eliminati definitivamente. Questa azione è irreversibile.',
    conversationArchiveError: 'Non riusciamo a leggere il tuo archivio! Contattaci per risolvere il problema...',
    conversationBookOrderTypeBook: 'Libro cartaceo + eBook in regalo',
    conversationBookOrderTypePdf: 'Solo eBook',
    conversationBookPreview: 'Anteprima',
    conversationBookPreviewSelected: 'Anteprima del libro n°{number}',
    conversationBookSelector: 'Seleziona il libro da modificare',
    conversationBookTypeLabelBook: 'Cartaceo + Ebook',
    conversationBookTypeLabelPdf: 'Solo Ebook',
    conversationBooks: 'Libri',
    conversationCollectorArchiveSelectButton: 'Carica un archivio',
    conversationCollectorInitWaiting: 'Stiamo preparando i tuoi dati... Attendi un istante',
    conversationCollectorUseArchive: 'Carica un backup (archivio .zip)',
        conversationCoverBookEdit: 'Personalizza la copertina',
    conversationCoverBookReset: 'Ripristina la copertina di questo libro',
    conversationCoverApplyToAllBooks: 'Applica questa copertina a tutti i tomi',
    conversationCoverAutoAppliedToAllBooks: 'Copertina applicata agli altri tomi.',
    conversationCoverApplyToAllBooksTitle: 'Applicare questa copertina a tutti i tomi?',
    conversationCoverApplyToAllBooksMessage: 'Scegli gli elementi da applicare a tutti gli altri tomi.',
    conversationCoverApplyOptionColor: 'Colore',
    conversationCoverApplyOptionPhoto: 'Foto',
    conversationCoverApplyOptionTitle: 'Titolo',
    conversationCoverApplyOptionSubtitle: 'Sottotitolo',
    conversationCoverBookSwitchAlertMessage: 'Verranno salvate solo le informazioni di copertina per questo specifico libro.',
    conversationCoverBookSwitchAlertTitle: 'Vuoi salvare la copertina per questo libro?',
        conversationCoverColorEditTitle: 'Scegli la tua copertina',
        conversationCoverLuxEyebrow: 'La tua copertina',
        conversationCoverLuxHint: 'Scegli il modello e il colore, poi personalizza la copertina.',
        conversationParticipantsLuxEyebrow: 'La tua conversazione',
        conversationParticipantsLuxHint: 'Modifica nomi, colori delle bolle e posizione sinistra/destra per ogni partecipante.',
        conversationParticipantsLuxSavePreview: 'Salva · torna all’anteprima',
        conversationParticipantsLuxSaved: 'Salvato',
        conversationParticipantsSameSideHint: 'Più partecipanti sono sullo stesso lato. Controlla la posizione sinistra/destra.',
        conversationParticipantColorBlushClair: 'Blush chiaro',
        conversationParticipantColorCielClair: 'Cielo chiaro',
        conversationParticipantColorLavandeClaire: 'Lavanda chiara',
        conversationParticipantColorPruneClaire: 'Prugna chiara',
        conversationParticipantColorPecheClaire: 'Pesca chiara',
        conversationParticipantColorSaugeClair: 'Salvia chiara',
        conversationParticipantColorMiel: 'Miele',
        conversationParticipantColorPerle: 'Perla',
        conversationParticipantNameError: 'Il nome è troppo lungo (max. {max} caratteri)',
        conversationParticipantPositionLeft: 'Sinistra',
        conversationParticipantPositionRight: 'Destra',
        conversationDatesLuxEyebrow: 'La tua storia',
        conversationDatesLuxHint: 'Scegli la data di inizio e di fine del libro. Clicca su un messaggio per affinare la selezione.',
        conversationDatesLuxNextEnd: 'Data di fine',
        conversationDatesLuxBackStart: 'Data di inizio',
        conversationDatesLuxSavePreview: 'Salva · torna all’anteprima',
        conversationDatesPresetsLabel: 'Selezione rapida del periodo',
        conversationDatesPreset_all: 'Intera conversazione',
        conversationDatesPreset_year: 'Ultimo anno',
        conversationDatesPreset_sixMonths: 'Ultimi 6 mesi',
        conversationDatesSelectionCount: '{count, number} {count, plural, one {messaggio} other {messaggi}}',
        conversationDatesSelectionPeriod: 'dal {start} al {end}',
        conversationDatesStoryDuration: 'Questa selezione copre {duration}',
        conversationDatesStartCaption: 'Il tuo primo messaggio',
        conversationDatesEndCaption: 'Il tuo ultimo messaggio',
        conversationDatesBookMessages: '{messages, number} {messages, plural, one {messaggio} other {messaggi}}, {photos, number} {photos, plural, one {foto} other {foto}} e {medias, number} {medias, plural, one {media} other {media}} nella tua selezione',
        conversationDateSelectionEmpty: 'Nessun messaggio in questo periodo. Amplia la selezione.',
        conversationMessagesLuxEyebrow: 'Il tuo libro',
        conversationMessagesLuxHint: 'Cerca, nascondi o modifica i messaggi. Le tue modifiche si applicano alla tua selezione.',
        conversationMessagesLuxSavePreview: 'Salva · torna all’anteprima',
        conversationMessagesLuxBackPreview: 'Vedi l’anteprima',
        conversationMessagesLuxCount: '{messages, number} {messages, plural, one {messaggio} other {messaggi}}, {photos, number} {photos, plural, one {foto} other {foto}} e {medias, number} {medias, plural, one {media} other {media}} nella tua selezione',
        conversationMessagesFilterResults: '{count, number} {count, plural, one {risultato} other {risultati}}',
        conversationMessagesOnlyHidden: 'Solo nascosti',
        conversationMessagesResetFilters: 'Reimposta i filtri',
        conversationMessagesShowHidden: 'Mostra i messaggi nascosti',
        conversationMessagesResetChanges: 'Annulla tutte le modifiche',
        conversationMessagesResetChangesButton: 'Annulla tutto',
        conversationMessagesResetChangesConfirm: 'La conversazione verrà ripristinata al suo stato originale importato. Tutte le tue modifiche (messaggi nascosti, modificati o aggiunti) andranno perse definitivamente. Continuare?',
        conversationMediaTypePhotos: 'Foto',
        conversationMediaTypeVideos: 'Video',
        conversationMediaTypeAudios: 'Audio',
        conversationMediaTypeLinks: 'Link',
        conversationMediaTypeOther: 'Altri',
        conversationMessagesToolSearch: 'Cerca',
        conversationMessagesToolMedias: 'Media',
        conversationMessagesToolDates: 'Date',
        conversationMessagesToolHidePeriod: 'Nascondi un periodo',
        conversationMessagesToolHidden: 'Visualizzazione',
        conversationMessagesToolReset: 'Modifiche',
        conversationMessagesToolResetNone: 'Nessuna',
        conversationMessagesToolResetCount: '{count, number} {count, plural, one {modifica} other {modifiche}}',
        conversationMessagesHiddenViewHint: 'Scegli quali messaggi compaiono nell’elenco qui sotto.',
        conversationMessagesHiddenViewAll: 'Tutti',
        conversationMessagesHiddenViewVisible: 'Solo visibili',
        conversationMessagesHiddenViewHidden: 'Solo nascosti',
        conversationMessagesResetChangesHint: 'Ripristina la conversazione al suo stato originale importato. Tutte le tue modifiche (messaggi nascosti, modificati o aggiunti) andranno perse.',
        conversationMessagesToolSearchNone: 'Nessuna',
        conversationMessagesToolMediasAll: 'Tutti i messaggi',
        conversationMessagesToolDatesAll: 'Tutto il periodo',
        conversationMessagesToolHidePeriodNone: 'Nessun periodo',
        conversationMessagesToolHiddenShown: 'Mostrati',
        conversationMessagesToolHiddenMasked: 'Nascosti',
        conversationMessagesBestofCuratedHint: 'Il tuo Best Of è già composto: è pieno fino al numero massimo di pagine. Puoi nascondere messaggi e mostrarne altri di nuovo, purché il libro non si allunghi.',
        conversationMessagesBestofFullError: 'Il tuo Best Of è già completo. Per mostrare questi messaggi, nascondine prima circa {pages, number} {pages, plural, one {pagina} other {pagine}} altrove.',
        conversationMessagesHidePeriodHint: 'Nascondi (o mostra di nuovo) tutti i messaggi tra due date in una sola volta.',
        conversationMessagesHidePeriodFrom: 'Dal',
        conversationMessagesHidePeriodTo: 'Al',
        conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {messaggio} other {messaggi}} in questo periodo ({visible} visibili, {hidden} nascosti)',
        conversationMessagesHidePeriodConfirmHide: 'Nascondere {count, number} {count, plural, one {messaggio} other {messaggi}} di questo periodo?',
        conversationMessagesHidePeriodConfirmShow: 'Mostrare di nuovo {count, number} {count, plural, one {messaggio} other {messaggi}} di questo periodo?',
        conversationMessagesHidePeriodHide: 'Nascondi questo periodo',
        conversationMessagesHidePeriodShow: 'Mostra di nuovo questo periodo',
        conversationMessagesHidePeriodItem: 'Periodo {index}',
        conversationMessagesHidePeriodAdd: 'Aggiungi un periodo',
        conversationMessagesHidePeriodInvalid: 'La data di fine deve essere successiva alla data di inizio.',
        conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {periodo} other {periodi}}',
        conversationMessagesSearchPlaceholder: 'Cerca una parola, un nome…',
        conversationCoverResumeLuxEyebrow: 'Prefazione',
        conversationCoverResumeLuxHint: 'Facoltativo: questo testo viene stampato sulla controguardia.',
        conversationCoverBookNumber: 'Volume {number}',
        conversationCoverFooterPrefaceGuide: 'Torna all’anteprima per saltare la prefazione, o continua per scriverla (facoltativa, sulla controguardia).',
        conversationCoverFooterNextPreface: 'Prefazione (facoltativa)',
        conversationCoverFooterSkipPreface: 'Salta prefazione · torna all’anteprima',
        conversationCoverFooterBackToCover: 'Torna alla copertina',
        conversationCoverFooterFinishPreview: 'Fine · torna all’anteprima',
        conversationCoverFooterGoPreview: 'Torna all’anteprima',
    conversationCoverEditionTypeTitle: 'Tipo di edizione del libro',
    conversationCoverEditionTypeBookHelp: 'In collezione completa, personalizza la copertina di ogni volume.',
    conversationCoverColorSelectorHelp: 'Seleziona il colore della copertina',
    conversationCoverStyleSelectorHelp: 'Scegli il modello di copertina',
    conversationCoverStylePhoto: 'Polaroid',
    conversationCoverStyleIncipit: 'Primo messaggio',
    conversationCoverPickMessageTitle: 'Scegli un messaggio',
    conversationCoverEditQuote: 'Modifica la frase',
    conversationCoverPickMessageHint: 'Compare in grande in copertina.',
    conversationCoverPickMessageSearch: 'Cerca un messaggio',
    conversationCoverPickMessageEmpty: 'Nessun messaggio corrisponde.',
    conversationCoverAddQuote: 'Aggiungi una frase',
    conversationCoverHourLabel: 'Ora',
    conversationCoverDateLabel: 'Data',
    conversationCoverGroupNameLabel: 'Nome del gruppo',
    conversationCoverSpanLabel: 'Date del primo e dell’ultimo messaggio',
    conversationCoverApplyOptionStyle: 'Modello',
    conversationCoverApplyOptionQuote: 'Frase',
    conversationCoverDragNDropFiles: 'Trascina e rilascia un\'immagine qui',
    conversationCoverTapToSelectPhoto: 'Tocca per scegliere una foto',
    conversationCoverOpenFinder: 'Seleziona un\'immagine',
    conversationCoverPhotoSelectorTitle: 'Scegli una foto',
    conversationCoverPhotoEditHint: 'Clicca per cambiare la foto',
    conversationCoverPhotoChoose: 'Clicca per scegliere una foto',
    conversationPreviewSwipeHint: 'Scorri per girare le pagine',
    conversationPreviewOpenBookHint: 'Scorri la copertina per aprire il libro',
    conversationPreviewDiscoverBook: 'Scopri il mio libro',
    conversationPreviewVolumesLabel: 'La tua collezione: {count} libri',
    conversationPreviewVolumesHint: 'Tocca una copertina per aprire quel tomo.',
    conversationCoverResumeEditTitle: 'Scrivi una dedica o prefazione (opzionale)',
    conversationCoverResumeError: 'Prefazione troppo lunga per una pagina: accorcia il testo o riduci gli a capo.',
    conversationCoverResumeNearLimit: 'Limite di una pagina quasi raggiunto ({lines}/{max} righe).',
    conversationCoverResumeHelp: 'Questa prefazione sarà stampata nella seconda di copertina del tuo libro.',
    conversationCoverResumePlaceholder: 'Scrivi qualche parola per introdurre la tua storia',
    conversationCoverResumeReset: 'Reimposta la prefazione di questo libro',
    conversationCoverTitleError: 'Titolo troppo lungo (max: {max} caratteri)',
    conversationCoverTitleHelp: 'Clicca per modificare il titolo del libro',
    conversationCoverTitlePlaceholder: 'Scrivi un titolo...',
    conversationCoverDefaultTitleTwoNames: '{name1} e {name2}',
    conversationCoverDefaultTitleGroup: 'Il nostro gruppo',
    conversationCoverDefaultTitleSingle: 'I miei messaggi',
	conversationCoverWaitingForCustomization: 'Potrai personalizzare la copertina del tuo libro nel prossimo passaggio...',
    conversationCreateInfoText: 'Crea un nuovo libro di messaggi cliccando sulle icone qui',
    conversationCreateMyBookTitle: 'Creo il mio libro',
    conversationCreateTitle: 'Crea un libro',
    conversationDateCreation: 'Data di creazione',
    conversationDateDownloadedInfo: 'Il libro è stato scaricato il {downloaded}',
    conversationDateEnd: 'Fine della chat',
    conversationDateEndInfo: 'Il libro termina il {end}',
    conversationDateEndLabel: 'Seleziona la data di fine',
    conversationDateEndMessageSelection: 'Termina il libro qui',
    conversationDateGeneratedInfo: 'Il libro è stato generato il {generated}',
    conversationDateRange: 'Dal {start} al {end}',
    conversationDeleteConfirmation: 'La chat è stata eliminata!',
    conversationDateSelectionAlert: 'Sembra che la tua chat si sia danneggiata durante il trasferimento. Riprova rimanendo sulla pagina e assicurandoti di avere una buona connessione internet.',
    conversationDateSimulatedInfo: 'Il libro è stato visualizzato in anteprima il {simulated}',
    conversationDateStart: 'Inizio della chat',
    conversationDateStartInfo: 'Il libro inizia il {start}',
    conversationDateStartLabel: 'Seleziona la data di inizio',
    conversationDateStartMessageSelection: 'Inizia il libro qui',
    conversationDatesEditTitle: 'Selezione delle date',
    conversationPreviewPrefaceOptionalBadge: 'Facoltativo',
    conversationPreviewPrefaceEmptyTitle: 'Una prefazione, se vuoi',
    conversationPreviewPrefaceEmptyText: 'Qualche parola per aprire il libro. Puoi saltare e tornare quando vuoi.',
    conversationPreviewPrefaceEmptyButton: 'Aggiungi una prefazione',
    conversationPreviewEndCta: 'Ordina ora',
    conversationPreviewEndBodyPaused: 'Convalida le modifiche. La versione digitale ti arriva per email subito dopo, così puoi controllarla.',
    conversationPreviewEndCtaPaused: 'Convalida le mie modifiche',
    conversationDemoAlert: 'Ora potrai scoprire le prime pagine del tuo libro.<br></br>Una volta effettuato l\'ordine, riceverai la versione completa da rivedere prima della stampa.',
    conversationDemoEndAlert: 'Potrai scoprire il resto dei tuoi messaggi dopo aver confermato l\'acquisto.',
    conversationPreviewEndTitle: 'Il resto ti aspetta',
    conversationPreviewEndBody: 'Il resto dei messaggi ti aspetta. Ordina per vedere il libro per intero.',
    conversationPreviewDemoBadge: 'MonLivreSMS',
    conversationPreviewPrefaceEmptyTitle: 'La tua prefazione (facoltativa)',
    conversationPreviewPrefaceOptionalBadge: 'Facoltativo',
    conversationPreviewPrefaceEmptyText: 'Qualche parola per aprire il libro. Puoi saltare e tornare quando vuoi.',
    conversationPreviewPrefaceEmptyButton: 'Scrivere la mia prefazione',
    conversationPreviewPrefaceEditButton: 'Modifica prefazione',

    conversationDisclaimerSubtitle: 'Scegli il formato per accedere al nostro laboratorio di personalizzazione.',
    conversationDisclaimerTitle: `{count} {count, plural,
      =0 {messaggio}
      =1 {messaggio}
      other {messaggi}
    }: una storia che merita di essere letta`,
    conversationDisclaimerSavings: 'Risparmi {value}',
    conversationDisclaimerEBookIncluded: 'Edizione Ebook inclusa',
    conversationDisclaimerGenerating: 'Generazione del tuo libro in corso...',

    conversationDisclaimerPlanSingleTitle: 'Il Volume 1',
    conversationDisclaimerPlanSingleDescription: "L'Essenziale",
    conversationDisclaimerPlanSingleButtonText: 'Crea il mio libro',
    conversationDisclaimerPlanSingleFeaturePages: 'Il libro a tua scelta (400 pagine) consegnato',
    conversationDisclaimerPlanSingleFeatureQuality: '',
    conversationDisclaimerPlanSingleFeatureEvolutive: 'Evolutivo: completa la collezione in seguito',
    conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Carta Premium',
    conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Stampa su Carta Premium',
    conversationDisclaimerPlanSingleFeaturePdfIncluded: 'Versione PDF inclusa (Valore: {price})',
    conversationDisclaimerPlanSingleFeatureWorkshop: 'Personalizzazione completa in regalo',
    conversationDisclaimerPlanSingleFeatureMedia: 'Foto, Video e Audio inclusi',

    conversationDisclaimerPlanCollectionTitle: 'La Collezione Completa',
    conversationDisclaimerPlanCollectionDescription: 'L\'Integrale',
    conversationDisclaimerPlanCollectionButtonText: 'Custodire tutta la nostra storia',
    conversationDisclaimerPlanCollectionBadge: 'OFFERTA PACCHETTO -{percentage}%',
    conversationDisclaimerPlanCollectionFeatureBox: 'I tuoi {count} libri stampati e consegnati',
    conversationDisclaimerPlanCollectionFeatureDiscount: 'Tariffa Collezione -{percentage}% (-{amount} inclusi)',
    conversationDisclaimerPlanCollectionFeatureDigital: 'Edizione digitale in regalo',
    conversationDisclaimerPlanCollectionFeatureWorkshop: 'Personalizzazione completa in regalo',
    conversationDisclaimerPlanCollectionFeatureMedia: 'Foto, Video e Audio inclusi',

    conversationDisclaimerPlanEbookTitle: "L'Edizione Ebook",
    conversationDisclaimerPlanEbookDescription: 'Il Formato Digitale',
    conversationDisclaimerPlanEbookButtonText: 'Salva in PDF',
    conversationDisclaimerPlanEbookFeaturePdf: 'PDF Alta Definizione immediato',
    conversationDisclaimerPlanEbookFeatureShare: 'Facile da condividere',
    conversationDisclaimerPlanEbookFeatureMessages: 'La totalità dei tuoi {count} messaggi',
    conversationDisclaimerPlanEbookFeatureMedia: 'Foto, Video e Audio inclusi',

    conversationDisclaimerReassuranceGuaranteeTitle: 'Garanzia Soddisfatti o Rimborsati',
    conversationDisclaimerReassuranceGuaranteeDescription: 'Rimborso garantito su richiesta fino alla convalida finale.',
    conversationDisclaimerReassuranceCustomTitle: 'Personalizzazione Libera',
    conversationDisclaimerReassuranceCustomDescription: 'Modifica la tua copertina e i messaggi dopo il pagamento',
    conversationDisclaimerReassuranceSecureTitle: 'Pagamento 100% Sicuro',
    conversationDisclaimerReassuranceSecureDescription: 'Carta di credito, Apple Pay, Google Pay',
    conversationDisclaimerReassuranceDeliveryTitle: 'Consegna Rapida',
    conversationDisclaimerReassuranceDeliveryDescription: 'Consegna a domicilio in 5 giorni lavorativi',

    conversationDisclaimerReviewSuffix: 'su +{count} libri stampati',

    conversationDowloadUnableAlert: 'Non puoi più scaricare i libri di questa chat... Contattaci per risolvere il problema.',
    conversationDownloadDeadlineInfo: 'Puoi scaricare i tuoi file fino al {date}',
    conversationDownloadLink: 'Scarica il mio libro N°{index}',
    conversationDownloadFileCoverLink: 'Scarica la copertina {name}',
    conversationDownloadFileSourceLink: 'Scarica il file sorgente {name}',
    conversationDownloadPdfButton: 'Scarica l\'E-book',
    conversationDownloadPdfWaitingMessage: 'Attendi 5 minuti per scaricare di nuovo',
    conversationEditStart: 'Modifica il libro',
    conversationEditSuccess: 'La chat è stata modificata!',
    'conversationFormatLabelA4-1': 'Cronache dei tuoi ricordi',
    'conversationFormatLabelA4-2': '(album A4)',
    'conversationFormatLabelA5-1': 'Il piccolo tesoro',
    'conversationFormatLabelA5-2': '(formato A5)',
    conversationGeneratedSuccess: 'Congratulazioni! <br></br> La tua chat è stata generata con successo!',
        conversationGenerationAlert: 'Stiamo componendo il tuo libro…',
        conversationGenerationAlert2: 'Resta con noi, ci vorrà solo un momento.',
        conversationGenerationFailed: 'La composizione del tuo libro si è interrotta.',
        conversationGenerationFailedHint: 'I tuoi messaggi sono al sicuro. Riprova e, se succede di nuovo, scrivici: lo verifichiamo insieme.',
        conversationGenerationRetry: 'Riprova',
    conversationHelpBooksText: 'Passa da un libro all\'altro per modificare le informazioni specifiche di ciascuno',
    conversationHelpBooksTitle: 'Selezione del libro',
    conversationHelpCoverColorText: 'Puoi cambiare il colore di sfondo della copertina cliccando sul cerchio.',
    conversationHelpCoverColorTitle: 'Colore della copertina',
    conversationHelpCoverImageText: 'Puoi trascinare qualsiasi immagine in questo spazio per aggiungerla alla tua copertina.',
    conversationHelpCoverImageTitle: 'Immagine di copertina',
    conversationHelpCoverTitleText: 'Clicca sul titolo per modificarlo! Hai 2 righe a disposizione: Titolo e Sottotitolo.',
    conversationHelpCoverTitleTitle: 'Titolo della copertina',
    conversationHelpDatePreviewText: 'Seleziona la data di inizio del tuo racconto.',
    conversationHelpDatePreviewTitle: 'Data',
    conversationHelpDateSelectorText: 'Cambiando la data, i tuoi primi e ultimi messaggi verranno mostrati qui!',
    conversationHelpDateSelectorTitle: 'Anteprima del messaggio',
    conversationHelpParticipantColorText: 'Puoi cambiare il colore delle bolle di ciascun partecipante per dare un tocco unico.',
    conversationHelpParticipantColorTitle: 'Colore dei partecipanti',
    conversationHelpParticipantNameText: 'Modifica il nome del partecipante come preferisci!',
    conversationHelpParticipantNameTitle: 'Nome del partecipante',
    conversationHelpParticipantPositionText: 'Scegli se preferisci mostrare i messaggi di questo partecipante a sinistra o a destra.',
    conversationHelpParticipantPositionTitle: 'Posizione del partecipante',
	conversationHelpMessagesToolsTitle: 'Strumenti',
	conversationHelpMessagesToolsText: 'Tocca una scheda per cercare, filtrare per media o date, o nascondere messaggi.',
	conversationHelpMessagesSearchTitle: 'Ricerca',
	conversationHelpMessagesSearchText: 'Digita una parola o un nome per trovare rapidamente un messaggio.',
	conversationHelpMessagesMediasTitle: 'Media',
	conversationHelpMessagesMediasText: 'Filtra i messaggi che contengono foto, video, audio o link.',
	conversationHelpMessagesDatesTitle: 'Date',
	conversationHelpMessagesDatesText: 'Tieni solo i messaggi tra due date per concentrarti su una parte della conversazione.',
	conversationHelpMessagesHidePeriodTitle: 'Nascondi un periodo',
	conversationHelpMessagesHidePeriodText: 'Scegli due date per nascondere (o mostrare di nuovo) un intero periodo in un colpo solo.',
	conversationHelpMessagesHiddenTitle: 'Visualizzazione',
	conversationHelpMessagesHiddenText: 'Mostra tutti i messaggi, solo quelli visibili o solo quelli nascosti.',
	conversationHelpMessagesListTitle: 'Modifica un messaggio',
	conversationHelpMessagesListText: 'Su ogni bolle: selezionare, nascondere, modificare il testo o inserirne uno nuovo.',
	conversationHelpMessagesFooterTitle: 'Torna all\'anteprima',
	conversationHelpMessagesFooterText: 'Quando hai finito, torna all\'anteprima per vedere il tuo libro aggiornato.',
    conversationHelpPreviewBookCoverText: 'Dagli una copertina unica. Clicca per personalizzarla.',
    conversationHelpPreviewBookCoverTitle: 'Copertina del libro',
    conversationHelpPreviewBookPreviewText: 'Visualizza l\'anteprima di un volume specifico cliccando qui!',
    conversationHelpPreviewBookPreviewTitle: 'Anteprima del libro',
    conversationHelpPreviewBookSelectorText: 'Scegli i volumi che desideri stampare.',
    conversationHelpPreviewBookSelectorTitle: 'Selettore dei libri',
    conversationHelpPreviewBookSplitText: 'Selezionando questa casella, tutti i tuoi libri avranno lo stesso numero di pagine per una collezione uniforme.',
    conversationHelpPreviewBookSplitTitle: 'Pagine del libro',
        conversationHelpPreviewCopyText: 'Ordina più copie: per te o da regalare. Sconto a partire dalla 2ª copia.',
        conversationHelpPreviewCopyTitle: 'Regalare una copia',
        conversationHelpPreviewFormatText: 'Libro cartaceo o eBook digitale: scegli ciò che ti assomiglia di più.',
        conversationHelpPreviewFormatTitle: 'Formato',
        conversationHelpPreviewRenderText: 'Ecco il tuo libro. Personalizza la copertina direttamente sopra, poi sfoglia le pagine.',
        conversationHelpPreviewRenderTitle: 'Il tuo libro',
	conversationHelpPreviewMessagesText: 'Tocca questa scheda per modificare il contenuto dei messaggi.',
	conversationHelpPreviewMessagesTitle: 'Messaggi',
	conversationHelpPreviewDatesText: 'Tocca questa scheda per scegliere le date di inizio e fine del tuo libro.',
	conversationHelpPreviewDatesTitle: 'Date',
	conversationHelpPreviewParticipantsText: 'Tocca questa scheda per cambiare i nomi e l\'aspetto dei partecipanti.',
	conversationHelpPreviewParticipantsTitle: 'Partecipanti',
	conversationHelpPreviewCoverTitleText: 'Clicca sul titolo o sul sottotitolo per modificarli.',
	conversationHelpPreviewCoverTitleTitle: 'Titolo e sottotitolo',
	conversationHelpPreviewVolumesTitle: 'Più volumi',
	conversationHelpPreviewVolumesText: 'La tua conversazione occupa più libri. Tocca un numero per cambiare volume e personalizzare ogni copertina.',
	conversationHelpPreviewCoverImageText: 'Tocca l\'area foto per aggiungere o cambiare l\'immagine di copertina.',
	conversationHelpPreviewCoverImageTitle: 'Foto',
	conversationHelpPreviewCoverColorText: 'Tocca una pastiglia per cambiare il colore di sfondo della copertina.',
	conversationHelpPreviewCoverColorTitle: 'Colore',
        conversationHelpPreviewValidText: 'Quando tutto è pronto, conferma. L\'eBook arriva via e-mail, il libro a casa.',
        conversationHelpPreviewValidTitle: 'Pronti!',

    conversationHighlightStartDateTitle: 'Il primo messaggio',
    conversationHighlightStartDateDescription: 'Quel giorno è partito il primo messaggio. Da lì è nato tutto il resto.',
    conversationHighlightDurationTitle: 'Insieme dal',
    conversationHighlightDurationDescription: 'Tutti questi giorni insieme, da quel primo messaggio.',
    conversationHighlightMessagesCountTitle: 'Messaggi',
    conversationHighlightMessagesCountDescription: 'Tutti questi messaggi, scambiati dal {date}.',
    conversationHighlightImagesCountTitle: 'Foto',
    conversationHighlightImagesCountDescription: 'Queste foto, salvate dalle nostre chat.',
    conversationHighlightMediasCountTitle: 'Video e vocali',
    conversationHighlightMediasCountDescription: 'Per riascoltare una voce e rivedere quel momento.',
    conversationHighlightSpecialDayMessagesCountTitle: 'In un solo giorno',
    conversationHighlightSpecialDayMessagesCountDescription: 'Il nostro record: tutti questi messaggi in un solo giorno.',
    conversationHighlightSpecialDayTitle: 'Quel giorno',
    conversationHighlightSpecialDayDescription: 'Il giorno in cui ci siamo scritti di più.',
    conversationHighlightCharsCountReferenceDiffTitle: 'Romeo e Giulietta',
    conversationHighlightCharsCountReferenceDiffDescription: 'Il testo di Romeo e Giulietta, tante volte.',
    conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} volte',
    conversationHighlightTypingDurationTitle: 'Scrittura',
    conversationHighlightTypingDurationDescription: 'Tante ore passate a scriverci.',
    conversationHighlightUnitDays: '{count, plural, one {giorno} other {giorni}}',
    conversationHighlightUnitMessages: '{count, plural, one {messaggio} other {messaggi}}',
    conversationHighlightUnitHours: '{count, plural, one {ora} other {ore}}',
    conversationHighlightUnitTimes: 'volte',

    conversationHighlightBadge: 'In poche cifre',
    conversationHighlightStoryKicker: 'La tua storia',
    conversationHighlightsMomentsCount: '{count, plural, one {# immagine da scaricare} other {# immagini da scaricare}}',
    conversationHighlightShareFormat: 'Formato story',
    conversationHighlightsCardFooter: 'Alcune storie meritano un libro',
    conversationHighlightShareButton: 'Scarica',
    conversationHighlightShareButtonAlt: 'Vedi le statistiche della conversazione',
    conversationHighlightSubtitle: 'I numeri di quello che vi siete detti.',
    conversationHighlightTitle1: 'I tuoi messaggi',
    conversationHighlightTitle2: 'in qualche cifra',
    conversationHighlightOpenStoryButton: 'Apri questa story',
    conversationHighlightsAtGlanceEyebrow: 'A colpo d\'occhio',
    conversationHighlightsAtGlanceTitle: 'La portata della vostra storia',
    conversationHighlightsNoAiNote: 'Queste statistiche vengono calcolate automaticamente, senza IA.',
    conversationHighlightsKpiMessages: 'messaggi',
    conversationHighlightsKpiWords: 'parole scritte',
    conversationHighlightsKpiActiveDays: 'giorni attivi',
    conversationHighlightsKpiStreak: 'giorni di fila',
    conversationHighlightsRhythmEyebrow: 'Il vostro ritmo',
    conversationHighlightsRhythmTitle: 'Quando i vostri messaggi prendono vita',
    conversationHighlightsTopHour: 'La vostra ora',
    conversationHighlightsTopWeekday: 'Il vostro giorno',
    conversationHighlightsNightMessages: 'Messaggi notturni',
    conversationHighlightsChartMonths: 'Tutti i mesi, dal primo all’ultimo messaggio',
    conversationHighlightsChartYears: 'Tutti gli anni, dal primo all’ultimo messaggio',
    conversationHighlightsLessThanOneMinute: 'meno di 1 min',
    conversationHighlightsSpanLessThanMonth: 'Meno di un mese',
    conversationHighlightsSpanYears: '{count, plural, one {# anno} other {# anni}}',
    conversationHighlightsSpanMonths: '{count, plural, one {# mese} other {# mesi}}',
    conversationHighlightsSpanYearsMonths: '{years, plural, one {# anno} other {# anni}} e {months, plural, one {# mese} other {# mesi}}',
    conversationHighlightsSpanLabel: 'Dal primo all’ultimo messaggio',
    conversationHighlightsBusiestDayLabel: 'Giorno più vivace',
    conversationHighlightsPhotosLabel: 'Foto',
    conversationHighlightsMediasLabel: 'Video e vocali',
    conversationHighlightsBookPagesLabel: 'Il vostro libro',
    conversationHighlightsBookPagesPrefix: 'circa',
    conversationHighlightsBookPagesUnit: '{count, plural, one {pagina} other {pagine}}',
    conversationHighlightsBookPagesNote: 'Stima a partire dai messaggi e dalle foto.',
    conversationHighlightsWritingHours: 'Circa {count, plural, one {# ora a scrivervi} other {# ore a scrivervi}}.',
    conversationHighlightsRomeo: 'Tanto testo quanto {count} volte Romeo e Giulietta.',
    conversationHighlightsDayClockPeak: 'Più spesso tra le {start} e le {end}',
    conversationHighlightsLessThanOnePercent: '< 1 %',
    conversationHighlightsWritesLonger: '{name} scrive i messaggi più lunghi.',
    conversationHighlightsStartsMore: '{name} apre più spesso la conversazione.',
    conversationHighlightsWordsPerMessage: '{count} parole / messaggio',
    conversationHighlightsStartsShare: '{percent} % degli inizi',
    conversationHighlightsMedianReply: 'Tempo mediano di risposta',
    conversationHighlightsBalanceEyebrow: 'Il vostro equilibrio',
    conversationHighlightsBalanceTitle: 'Ognuno ha il proprio modo di esserci',
    conversationHighlightsWordsShort: 'parole',
    conversationHighlightsStartsShort: 'inizi',
    conversationHighlightsBalanceNote: 'Una percentuale descrive un ritmo, mai l\'importanza di una persona.',
    conversationHighlightsRecordsEyebrow: 'I vostri record',
    conversationHighlightsRecordsTitle: 'I momenti che spiccano',
    conversationHighlightsLongestSession: 'Conversazione più lunga',
    conversationHighlightsIntenseQuarter: 'I 15 minuti più intensi',
    conversationHighlightsQuestions: 'Messaggi teneri',
    conversationHighlightsSignsOfInterest: 'cuori, baci o «ti amo»',
    conversationHighlightsLaughs: 'Messaggi con risate',
    conversationHighlightsSharedSmiles: 'sorrisi condivisi',
    conversationHighlightsFavoriteEmojis: 'Le vostre emoji preferite',
    conversationHighlightsStoriesEyebrow: 'Da conservare',
    conversationHighlightsStoriesTitle: 'Le vostre cartoline dei ricordi',
    conversationHighlightsStoriesText: 'Apri una cartolina, poi scaricala in formato story.',
    conversationHighlightsDeepEyebrow: 'E dopo i numeri?',
    conversationHighlightsDeepTitle: 'Ti piacerebbe approfondire la vostra storia?',
    conversationHighlightsDeepText: 'Dicci se un giorno vorresti andare oltre. Per il momento non verrà analizzato nient\'altro.',
    conversationHighlightsDeepThanks: 'Grazie, abbiamo registrato il tuo interesse',
    conversationHighlightsDeepButton: 'Sì, mi interesserebbe',
    conversationHighlightsDeepNotice: 'Ti avviseremo appena sarà previsto.',
    conversationHighlightsDeepNoticeClose: 'D’accordo',
    conversationHighlightsPrintBook: 'Voglio stampare il mio libro',
    conversationHighlightsPrintNow: 'Lo stampo adesso',

    conversationImagesCount: `{count} {count, plural,
      =0 {foto}
      =1 {foto}
      other {foto}
    }`,

    conversationImportFileNotSupportedError: 'Il tuo file non è valido! Per favore, seleziona un file compresso valido (.zip)',
    conversationImportFileSummary: 'Il tuo nome è {name} e hai {count} chat in questo archivio.',
    conversationImportFileTooBigError: 'Il tuo file è troppo pesante! (più di 4GB). Contattaci per risolvere questo problema.',
    conversationImportProviderNext: 'Trasferisci la mia chat',
    conversationImportTutorialGoNext: 'Vedi il seguito',
    conversationImportTutorialStep: 'Passo n°{step}',
    conversationImportDetailToggle: 'Vedi la guida dettagliata con screenshot',
    conversationImportDetailCardTitle: 'Prima volta?',
    conversationImportDetailCardSubtitle: 'Guida illustrata passo dopo passo ({count} passaggi con screenshot)',
    conversationImportDetailCardAction: 'Apri la guida',
    conversationImportDetailTitle: 'Guida dettagliata passo dopo passo',
    conversationImportDetailStepOf: 'Passo {current} di {total}',
    conversationImportDetailPrev: 'Precedente',
    conversationImportDetailNext: 'Avanti',
    conversationImportDetailClose: 'Chiudi',
    conversationImportSelectionSummary: `Chat selezionata: {name} (contiene {count} {count, plural,
        =0 {messaggio}
        =1 {messaggio}
        other {messaggi}
      })`,
    conversationImportSelectionSummary2: 'Chat selezionata: {name}',
    conversationImportSelectionText: 'Scrivi il nome del tuo amico...',
    conversationImportSelectionTitle: 'Seleziona la chat',
    conversationImportStepCreation: 'Creazione della conversazione',
    conversationImportStepExtraction: 'Recupero dei dati',
    conversationImportStepFinal: 'Ultimi dettagli...',
    conversationImportStepImages: 'Salvataggio delle tue immagini',
    conversationImportStepMessages: 'Salvataggio dei tuoi messaggi',
    conversationImportSuccess: 'Congratulazioni! <br></br>La tua chat è stata importata con successo!',
    conversationImportValidationWaiting: 'Convalida in corso...',
    conversationMediaAudioOpusWarning: 'Se non riesci a riprodurre questo file audio, usa un altro browser compatibile (come Google Chrome)',
    conversationMediasCount: `{count} {count, plural,
      =0 {file multimediale}
      =1 {file multimediale}
      other {file multimediali}
    }`,
    conversationMerge: 'Unisci le chat',
    conversationMergeInfo: 'Seleziona le chat che desideri unire e poi clicca sul pulsante situato sotto la lista:',
    conversationMergeRequestSuccess: 'Le chat verranno unite presto! Riceverai un\'email al termine dell\'operazione.',
    conversationMergeHintEyebrow: 'Da sapere',
    conversationMergeHintTitle: 'Raggruppare in un\'unica conversazione',
    conversationMergeHintSingle: 'Più fili di chat? Importa ogni conversazione con +, poi uniscile in un\'unica conversazione.',
    conversationMergeHintReady: 'Puoi unire le tue conversazioni in un\'unica conversazione cronologica.',
    conversationMessages: 'Messaggi',
    conversationMessagesCount: `{count} {count, plural,
      =0 {messaggio}
      =1 {messaggio}
      other {messaggi}
    }`,
    conversationMessagesCount2: `{count, plural,
      =0 {messaggio}
      =1 {messaggio}
      other {messaggi}
    }`,
    conversationMessagesImagesCount: `{count} {count, plural,
      =0 {immagine}
      =1 {immagine}
      other {immagini}
    }`,
    conversationMessagesImagesCount2: `{count, plural,
      =0 {immagine}
      =1 {immagine}
      other {immagini}
    }`,
    conversationMessagesLoadingAlert: 'Recuperando la magia dei tuoi messaggi...',
    conversationMessagesMediasCount: `{count} {count, plural,
      =0 {file multimediale}
      =1 {file multimediale}
      other {file multimediali}
    }`,
    conversationMessagesMediasCount2: `{count, plural,
      =0 {file multimediale}
      =1 {file multimediale}
      other {file multimediali}
    }`,
    conversationNoData: 'Non hai ancora importato alcuna conversazione!',
    conversationOptionWithImagesHelp1: 'Attualmente, i tuoi libri verranno stampati CON le tue immagini o foto',
    conversationOptionWithImagesHelp2: 'Attualmente, i tuoi libri verranno stampati SENZA le tue immagini o foto',
    conversationOptionWithImagesHelp3: 'A seconda della quantità di foto, il trasferimento della chat potrebbe rallentare. Per favore, resta su questa pagina durante il caricamento, potrebbe richiedere fino a 10 minuti. Se continui ad avere difficoltà, inviaci il tuo archivio tramite www.fromsmash.com all\'indirizzo hello@monlivresms.com indicando il nome del contatto o del gruppo, e troveremo una soluzione.',
    conversationOptionWithImagesLabel: 'Desideri includere le immagini della chat?',
    conversationOptionWithMediaHelp: 'Potrai riscoprire i tuoi video, audio e GIF grazie ai codici QR stampati nel tuo libro. Ti regaliamo l\'archiviazione sicura dei tuoi dati per 10 anni.',
    conversationOptionWithMediasLabel: 'Desideri includere i video, gli audio e le GIF della chat?',
    conversationOrder: 'Ordine',
    conversationOrderButton: 'Ordina ora',
    conversationOrderButtonWithPrice: 'Ordina · {price}',
    conversationOrderButtonWithPriceVolumes: 'Ordina i miei {count} libri · {price}',
    conversationOrderDiscountLabel: '¡-{discount}% di sconto su questa chat ordinando {threshold} copie o più!',
    conversationOrderQuantity: 'Numero di copie',
    conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {volume}
			other {volumi}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: sconto del {discount} % incluso}
		}`,
    conversationOrderSummary2: `Il tuo ordine include {bookCount} {bookCount, plural,
          =0 {libro}
          =1 {libro}
          other {libri}
        } e {pdfCount} {pdfCount, plural,
          =0 {eBook}
          =1 {eBook}
          other {eBooks}
        } {freeCount, plural,
          =0 {}
          =1 {+1 eBook gratis}
          other {+{freeCount} eBook gratis}
        } per {pdfTotal}`,
        conversationOrderSummaryBestof: '1 libro Best Of · {bestofTotal}',
        conversationOrderSummaryPdf: '1 eBook completo · {pdfTotal}',
    conversationParticipantColorHelp: 'Clicca qui per cambiare il colore della bolla',
    conversationParticipantNameHelp: 'Clicca qui per modificare il nome del partecipante',
    conversationParticipantPositionHelp: 'Clicca per modificare la posizione del partecipante (a destra o a sinistra)',
    conversationParticipants: 'Partecipanti',
    conversationParticipantsEditTitle: 'Modifica dei partecipanti',
    conversationPauseButton: 'Metti in pausa il mio ordine',
    conversationPauseConfirmText: 'La generazione dei tuoi libri verrà messa in pausa. Potrai riprenderla in qualsiasi momento.',
    conversationPreviewBookNumber: `{index}{index, plural,
          =0 {}
          =1 {°}
          other {°}
      } volume`,
    conversationPreviewBestofHelpButton: 'Come funziona la selezione?',
    conversationPreviewBestofHelpText: 'La nostra formula analizza ogni momento della tua conversazione: la frequenza dei messaggi, la qualità del dialogo (un vero scambio o un monologo?), la ricchezza dei contenuti (foto, testo, emoji). I primi e gli ultimi messaggi sono sempre preservati. Solo i momenti che hanno davvero contato entrano nel libro. I tuoi messaggi rimangono privati: la nostra formula non ne legge mai il contenuto, analizza solo la struttura dei tuoi scambi.',
    conversationPreviewBookSelection: 'Selezione dei volumi',
    conversationPreviewBooksSelectAllBooks: 'Seleziona tutti i libri fisici',
    conversationPreviewBooksSelectAllEBooks: 'Seleziona tutti gli eBook',
    conversationPreviewBooksUnselectAll: 'Deseleziona tutto',
        conversationPreviewBrowserWarning: 'Il tuo browser potrebbe rallentare la visualizzazione. Per un’esperienza ottimale, ti consigliamo Google Chrome.',
    conversationPreviewFormatSelection: 'Selezione del formato',
    conversationPreviewPagesDivideEquallyLabel: 'Desideri dividere le pagine in modo equo tra i volumi?',
    conversationPreviewPagesSetMaxBookPagesLabel: 'Preferisci che i tuoi libri abbiano un massimo di {max} pagine?',
        conversationPreviewTitle: 'La tua storia, in un libro.',
        conversationPreviewSubtitle: 'Personalizza copertina, nomi, date e messaggi prima di scegliere la tua edizione.',
        conversationPreviewHeroTitle: 'Le tue parole, rilegate per sempre.',
        conversationPreviewBookCaption: 'Sfoglia le pagine per scoprire il tuo libro.',
        conversationPreviewCustomizeEyebrow: 'A tua immagine',
        conversationPreviewEditionEyebrow: 'La tua edizione',
        conversationPreviewPricePerVolume: '{price}/volume',
    conversationPreviewCollectionPriceNote: '{count} tomi · {price}/tomo',
    conversationPreviewCollectionUntilLabel: 'Quali volumi',
    conversationPreviewCollectionUntilAll: 'Dal primo volume all\'ultimo',
    conversationPreviewCollectionUntilOpen: 'Scegli',
    conversationPreviewCollectionUntilClose: 'Chiudi',
    conversationPreviewCollectionUntilPartial: '{count, plural, one {Il primo volume} other {I primi {count} volumi}}',
    conversationPreviewCollectionUntilSuffix: '{count, plural, one {L\'ultimo volume} other {Gli ultimi {count} volumi}}',
    conversationPreviewCollectionUntilSingle: 'Il volume {number}',
    conversationPreviewCollectionUntilWindow: 'Dal volume {from} al volume {to}',
    conversationPreviewCollectionUntilPeriod: 'Dal {start} al {end}',
    conversationPreviewCollectionUntilHint: 'Gli altri volumi restano nella conversazione, per un altro ordine.',
    conversationPreviewCollectionUntilAriaStart: 'Primo volume da stampare',
    conversationPreviewCollectionUntilAriaEnd: 'Ultimo volume da stampare',
    conversationPreviewTypeBookTaglinePartial: '{count, plural, one {Il primo volume della tua conversazione.} other {I primi {count} volumi della tua conversazione.}}',
    conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {L\'ultimo volume della tua conversazione.} other {Gli ultimi {count} volumi della tua conversazione.}}',
    conversationPreviewTypeBookTaglineWindowSingle: 'Il volume {number} della tua conversazione.',
    conversationPreviewTypeBookTaglineWindow: 'I volumi dal {from} al {to} della tua conversazione.',
    conversationPreviewStickyCollectionVolumes: 'Collezione · {count} tomi',
        conversationPreviewSocialProofCount: '{count}+ recensioni',
        conversationPreviewSocialProofAria: 'Valutato {rating} su 5 su Trustpilot, su oltre {count} recensioni',
        conversationPreviewCustomizeTitle: 'Personalizza il mio libro',
        conversationPreviewCustomizeHint: 'Tocca una scheda per modificare.',
        conversationPreviewCardsHintTitle: 'Nomi, date, messaggi',
        conversationPreviewCardsHintText: 'Qui cambi i nomi, il periodo e i messaggi.',
        conversationPreviewCustomizeTopics: 'Copertina · nomi · date · messaggi',
        conversationPreviewEditionTitle: 'Scegli la tua edizione',
        conversationPreviewEditionHint: 'Confronta le opzioni e scegli quella giusta per te.',
        conversationPreviewPausedEyebrow: 'Ordine in pausa',
        conversationPreviewPausedTitle: 'Le tue modifiche sono pronte?',
        conversationPreviewPausedHint: 'Il tuo ordine è in pausa. Modifica il libro e conferma per riprendere la produzione.',
        conversationPreviewPausedScrollHint: 'Convalida le mie modifiche',
        conversationPreviewMissingMediasBanner: 'Alcuni contenuti multimediali (foto, file) della tua conversazione risultano mancanti o non è stato possibile recuperarli. Verifica i tuoi messaggi prima di convalidare.',
        conversationPreviewMissingMediasCta: 'Completa i media',
        bookMissingPhotoLabel: 'Foto non disponibile',
        conversationMissingMediasBadge: 'Media mancanti',
        conversationMissingMediasCta: 'Completa i media',
        conversationResumeWithoutMediasButton: 'Continua senza queste foto',
        conversationResumeMissingMediasConfirmText: 'Alcune foto mancano ancora. Il libro andrà in stampa senza di esse. Completa i media se puoi.',
        orderMissingMediasAlert: 'Mancano foto in una conversazione di questo ordine. Completale così la produzione può riprendere.',
        missingMediasRecoveryAddPhoto: 'Aggiungi una foto',
        missingMediasRecoveryArchiveCta: 'Carica il file di esportazione',
        missingMediasRecoveryArchiveError: 'Impossibile leggere questo file. Verifica che sia l’esportazione della tua messaggistica.',
        missingMediasRecoveryArchiveHelp: 'Carica di nuovo l’esportazione {provider} (zip). Verranno aggiunte solo le foto mancanti: messaggi e modifiche restano invariati.',
        missingMediasRecoveryArchiveTitle: 'Completa con una nuova esportazione',
        missingMediasRecoveryArchiveWorking: 'Ricerca delle foto mancanti nel file…',
        missingMediasRecoveryContact: 'Scrivici',
        missingMediasRecoveryEmpty: 'Nessun media mancante rilevato al momento.',
        missingMediasRecoveryError: 'Si è verificato un errore. Riprova o contattaci.',
        missingMediasRecoveryFirstDate: 'Primo media mancante: {date}.',
        missingMediasRecoveryIgnore: 'Ignora',
        missingMediasRecoveryIntro: '{count, plural, one {Manca # foto} other {Mancano # foto}} nel tuo libro. Puoi ricaricare l’esportazione o gestire ogni media qui sotto.',
        missingMediasRecoveryListTitle: 'Gestisci media per media',
        missingMediasRecoveryNoMatch: 'Nessun file corrispondente ai media mancanti è stato trovato.',
        missingMediasRecoveryRecommended: 'Consigliato',
        missingMediasRecoveryRescan: 'Ricontrolla',
        missingMediasRecoveryResolved: 'Tutti i media mancanti sono stati gestiti. Il tuo libro torna in produzione.',
        missingMediasRecoverySuccessEyebrow: 'Tutto a posto',
        missingMediasRecoverySuccessTitle: 'Bravo, le tue foto sono complete',
        missingMediasRecoverySuccessText: 'Tutti i media mancanti sono stati gestiti. Il tuo libro torna in produzione.',
        missingMediasRecoverySuccessCta: 'Torna all\'anteprima',
        conversationMissingMediasFixedSuccess: 'Bravo: tutti i media mancanti sono completi. Il tuo libro torna in produzione.',
        conversationMissingMediasFixedHint: 'Non devi fare altro: la produzione riparte automaticamente.',
        missingMediasRecoverySmsStepAndroid: 'Su Android: riapri l’app MonLivreSMS e reinvia la conversazione.',
        missingMediasRecoverySmsStepBackup: 'Crea un nuovo backup locale non crittografato (Mac/PC), poi rilancia il nostro software per reinviarci i media di questa conversazione.',
        missingMediasRecoverySmsStepIcloud: 'Su iPhone: apri la conversazione in Messaggi, tocca il contatto, scorri e scarica le foto iCloud.',
        missingMediasRecoverySmsTitle: 'Trasferimento SMS / iPhone',
        missingMediasRecoveryTitle: 'Media mancanti ({count})',
        conversationPreviewEditionMetaLabel: 'Dettagli dell\'edizione',
        conversationPreviewBestofLearnMore: 'Come funziona la selezione Best-Of',
        conversationPreviewBestofHint: 'Anteprima illustrativa del Best Of: la selezione dei tuoi messaggi migliori avviene dopo l\'ordine, in fase di generazione del PDF.',
        conversationPreviewBestofHintDismiss: 'Chiudi',
        conversationPreviewBestofHintLearnMore: 'Scopri di più',
        conversationPreviewBestofPriceNote: 'Selezione dopo l\'ordine',
        conversationPreviewTypeBestofTaglineCompare: 'Alternativa più leggera: i tuoi momenti migliori in 1 volume.',
        conversationPreviewMetaEbook: 'eBook in omaggio',
        conversationPreviewMetaVolume: '{count} volume',
        conversationPreviewMetaVolumes: '{count} volumi',
        conversationPreviewMetaPages: '{pages} pagine',
        conversationPreviewMetaMessages: '{count} messaggi',
        conversationPreviewMetaBestofPages: '~400 pagine',
        conversationPreviewMetaBestofSelection: 'Selezione intelligente',
        conversationPreviewMetaPdfInstant: 'PDF subito',
        conversationPreviewMetaPdfCredit: 'Credito sul libro',
        conversationPreviewPdfPriceNote: 'Scalato se passi al libro',
        conversationPreviewPdfLearnMore: 'Come funziona?',
        conversationPreviewPdfHelpText: 'Paghi {ebookPrice} e ricevi il PDF. Se più tardi ordini il libro stampato a {bookPrice}, questi {ebookPrice} vengono scalati: restano {remainingPrice}. Il credito resta sul tuo account.',
        conversationPreviewReassurancePdfCredit: 'Questi {price} saranno scalati se passi al libro',
        conversationPreviewStickyPdfCredit: 'Credito di {price} se passi al libro',
        conversationPreviewEbookCreditBanner: 'Hai {amount} di credito su questa conversazione. Saranno scalati automaticamente se ordini il libro stampato.',
        conversationPreviewEbookCreditOrderHint: '{credit} di credito scalati · prezzo di listino {fullPrice}',
        conversationPreviewStickyEbookCredit: '{credit} di credito applicati',
        paymentMethodEbookCreditHint: 'Credito ebook sul libro stampato',
        cartTotalsEbookCredit: 'Credito ebook',
        cartTotalsCredit: 'Credito',
        conversationOrderButtonEbook: 'Ricevi il mio PDF',
        conversationOrderButtonEbookWithPrice: 'Ricevi il mio PDF · {price}',
        conversationPreviewTypeBookTaglineSingle: 'La tua storia completa, pagina dopo pagina.',
        conversationPreviewTypeBookTaglineMulti: 'La tua conversazione intera in {count} libri stampati.',
        conversationPreviewHeroHeading: 'Anteprima del libro',
        conversationPreviewHelpTourButton: 'Mostra guida della pagina',
        conversationPreviewCardLabelCover: 'Copertina',
        conversationPreviewCardLabelParticipants: 'Partecipanti',
        conversationPreviewCardLabelDates: 'Date',
        conversationPreviewCardLabelMessages: 'Messaggi',
	conversationPreviewZoneDone: 'Già esplorato',
	conversationPreviewZoneHintCover: 'Colore, foto, titolo, prefazione',
	conversationPreviewZoneHintParticipants: 'Nomi e colori dei fumetti',
	conversationPreviewZoneHintDates: 'Periodo coperto dal libro',
	conversationPreviewZoneHintMessages: 'Nascondi o correggi i messaggi',
        conversationHelpPreviewCustomizeTitle: 'Nomi, date e messaggi',
        conversationHelpPreviewCustomizeText: 'Tocca una scheda per modificare nomi, date o messaggi.',
        conversationBookNavPrev: 'Pagina precedente',
        conversationBookNavNext: 'Pagina successiva',
        conversationBookBackToCover: 'Torna alla copertina',
        conversationPreviewTypeBookPagesHint: ' · {pages} pagine',
        conversationPreviewTypeBookMessagesHint: ' · {count} messaggi',
        conversationOrderTotal: 'Totale',
        conversationPreviewTypeBestofDescription: '400 pagine, i tuoi scambi migliori. eBook in omaggio.',
        conversationPreviewTypeBestofTitle: 'Best Of',
        conversationPreviewTypeBookDescription: '{count} volume · Storia completa. eBook in omaggio.',
        conversationPreviewTypeBookDescriptionWithPrice: '{count} volumi · {unitBreakdown} · Collezione integrale. eBook in omaggio.',
        conversationPreviewReassuranceShipping: 'Spedizione gratuita in tutto il mondo',
        conversationPreviewExpressDeliveryLead: 'Consegna express {where} dal',
        conversationPreviewExpressDeliveryDate: '{date}',
        conversationPreviewTypeBookTitle: 'Collezione completa',
        conversationPreviewTypeHighlight: 'Consigliato',
        conversationPreviewTypePdfDescription: 'Conserva la tua conversazione in PDF. Questo importo vale per il libro, se lo vorrai più tardi.',
        conversationPreviewTypePdfTitle: 'Digitale',
        conversationPreviewTypeSelectionTitle: 'Scegli il tuo formato',
    conversationProgress: 'Progresso',
    conversationProviderButton: 'Accedi alle impostazioni',
    conversationProviderType: 'Tipo',
    conversationRemoveButton: 'Elimina la chat',
    conversationRemoveConfirmText: 'Eliminando la tua chat, i tuoi file multimediali verranno cancellati dai nostri server e non potranno essere recuperati. Confermi?',
    conversationRemoveConfirmTitle: 'Elimina la chat',
    conversationRemoveFlagConfirmMessage: 'Vuoi rimuovere questo contrassegno dalla chat?',
    conversationRemoveSuccess: 'Chat eliminata con successo!',
    conversationRestartProcess: 'Riavvia',
    conversationResumeButton: 'Convalida e stampa',
    conversationResumeConfirmText: 'La tua chat sarà contrassegnata come "verificata" e passerà presto alla fase di generazione e stampa.',
    conversationValidateModificationsButton: 'Convalida le mie modifiche',
    conversationValidateModificationsConfirmTitle: 'Convalidare le modifiche?',
    conversationValidateModificationsConfirmBook: 'Il tuo libro tornerà in produzione con le tue modifiche.',
    conversationValidateModificationsConfirmEbook: 'Il tuo eBook verrà rigenerato con le tue modifiche e ti verrà nuovamente inviato via email.',
    conversationValidateModificationsConfirmMissingMedias: 'Alcuni contenuti multimediali della tua conversazione risultano mancanti. Verificali prima di convalidare: il tuo libro andrà in produzione con le modifiche attuali.',
    conversationValidateModificationsSuccessBook: 'Le tue modifiche sono state salvate. Il tuo libro torna in produzione.',
    conversationValidateModificationsSuccessEbook: 'Le tue modifiche sono state salvate. Il tuo eBook rigenerato ti verrà inviato via email.',
    conversationValidateModificationsBackToList: 'Torna alle mie conversazioni',
    conversationSelectThread: 'Seleziona una chat',
    conversationShareCancelButton: 'Non ora',
    conversationShareConfirmButton: 'Vedi i miei momenti',
    conversationShareConfirmTitle: 'Guarda cosa abbiamo trovato...',
    conversationShareConfirmText: 'Nella tua conversazione ci sono numeri che vale la pena condividere. Li abbiamo messi in immagini.',
    conversationStatusConfigured: 'In attesa di generazione',
    conversationStatusDone: 'Terminato',
    conversationStatusOngeneration: 'Generazione in corso',
    conversationStatusOnproduction: 'In produzione',
    conversationStatusOnvalidation: 'In attesa di stampa',
    conversationStatusPending: 'In attesa',
    conversationTypeAndroidDownloadAlt: 'Oppure copia e incolla il link nel tuo browser preferito',
    conversationTypeAndroidDownloadButton: 'Scarica l\'applicazione',
    conversationTypeAndroidIntroText1: 'Per stampare il tuo Libro SMS da un telefono Android, è necessario utilizzare il tuo smartphone (Samsung, Xiaomi, Pixel, ecc.).',
    conversationTypeAndroidIntroText2: 'Installa l\'applicazione MonLivreSMS sul tuo cellulare Android cliccando sul seguente link (l\'app non è disponibile su Google Play):',
    conversationTypeAndroidIntroText3: 'Scegli il coautore del tuo libro SMS dei ricordi, oltre alle date di inizio e fine della vostra storia.',
    conversationTypeAndroidIntroText4: 'Scegli i nomi dei protagonisti della tua storia, scrivi la tua dedica e personalizza la tua copertina.',
    conversationTypeAndroidIntroText5: 'Per finalizzare la creazione del tuo libro, crea un account e completa l\'acquisto tramite il nostro server di pagamento sicuro.',
    conversationTypeInstagramFileText1: 'Instagram ti invierà un\'email per poter scaricare il file.',
    conversationTypeInstagramFileText2: 'Scaricalo sul tuo dispositivo.',
    conversationTypeInstagramFileText3: 'Clicca sul pulsante qui sotto e seleziona l\'archivio nei tuoi download senza aprirlo, lasciandolo in formato .zip (esempio: *tuonome*_*data*.zip). Solo la conversazione che sceglierai verrà inviata ai nostri servizi di stampa.',
    conversationTypeInstagramProviderText1: 'Recupera una copia dei tuoi dati di Instagram accedendo alle impostazioni generali del tuo account.',
    conversationTypeInstagramProviderText2: 'Inserisci l\'email associata al tuo account Instagram e scegli il formato JSON.',
    conversationTypeInstagramProviderText3: 'Quindi inserisci la tua password e clicca su <strong>Richiedi download</strong> per avviare la generazione del tuo backup su Instagram.',
    conversationTypeIosIntroText1: 'Collega il tuo iPhone al COMPUTER ed esegui un backup su iTunes senza crittografia. (seleziona "Questo computer", DESELEZIONA "Codifica backup locale" e clicca su "Effettua backup adesso").',
    conversationTypeIosIntroText2: 'Scarica il software MonLivreSMS cliccando sul link corrispondente al sistema operativo del tuo computer:',
    conversationTypeIosIntroText3: '<strong>ATTENZIONE, se il software non rileva alcun backup:</strong><br></br> - Per MAC:<br></br>Vai in Preferenze di Sistema > Sicurezza e Privacy > Accesso completo al disco e aggiungi l\'applicazione MonLivreSMS sbloccando il lucchetto in basso a sinistra.<br></br> - Per PC:<br></br>Per la tua sicurezza, Apple impedisce la lettura del tuo backup senza la tua autorizzazione.',
    conversationTypeMessengerFileText1: 'Facebook ti invierà un\'email per scaricare l\'archivio delle tue chat.',
    conversationTypeMessengerFileText2: 'Scaricalo sul tuo dispositivo.',
    conversationTypeMessengerFileText3: 'Clicca sul pulsante qui sotto e seleziona l\'archivio nei tuoi download lasciandolo in formato .zip (esempio: facebook-*tuonome*.zip). Verrà elaborata solo la conversazione che sceglierai.',
    conversationTypeMessengerProviderText1: 'Recupera una copia dei tuoi dati di Facebook accedendo alle impostazioni del tuo account.',
    conversationTypeMessengerProviderText2: 'Clicca su "Scarica le tue informazioni".',
    conversationTypeMessengerProviderText3: `Quindi, imposta le seguenti opzioni:<br></br>
              <strong>Intervallo di date</strong>: (quello che preferisci)<br></br>
              <strong>Formato</strong>: JSON<br></br>
              <strong>Qualità dei file multimediali</strong>: Bassa (è sufficiente per la stampa e molto più veloce da trasferire)<br></br>
              <strong>Le tue informazioni</strong>: Seleziona solo "Messaggi" (deseleziona il resto).`,
    'conversationTypeMessengerProviderText4': 'Attenzione: Assicurati di selezionare il formato dei dati in JSON (e non in HTML)!',
    'conversationTypeSnapchatProviderText1.1': 'Apri l\'applicazione Snapchat sul tuo dispositivo.',
    'conversationTypeSnapchatProviderText1.2': 'Tocca il tuo avatar (o Bitmoji) in alto a sinistra per accedere al tuo profilo.',
    'conversationTypeSnapchatProviderText1.3': 'Tocca l\'icona dell\'ingranaggio in alto a destra per aprire le Impostazioni.',
    'conversationTypeSnapchatProviderText2.1': 'Scorri verso il basso fino alla sezione "Controlli privacy".',
    'conversationTypeSnapchatProviderText2.2': 'Seleziona "I miei dati".',
    'conversationTypeSnapchatProviderText3.1': 'Potrebbe esserti richiesto di effettuare l\'accesso per verificare la tua identità.',
    'conversationTypeSnapchatProviderText4.1': 'Nella pagina "I miei dati", troverai un elenco con i dati che puoi scaricare, inclusi i tuoi messaggi.',
    'conversationTypeSnapchatProviderText4.2': 'Clicca su "Invia richiesta" in fondo alla pagina.',
    'conversationTypeSnapchatProviderText5.1': 'Una volta inviata la richiesta, Snapchat preparerà il download dei tuoi dati.',
    'conversationTypeSnapchatProviderText5.2': 'Questo potrebbe richiedere un po\' di tempo, in genere da qualche ora a un giorno.',
    'conversationTypeSnapchatProviderText5.3': 'Riceverai un\'email da Snapchat con un link per scaricare i tuoi dati quando il file sarà pronto.',
    'conversationTypeSnapchatProviderText6.1': 'Clicca sul link nell\'email per accedere alla pagina di download.',
    'conversationTypeSnapchatProviderText6.2': 'Scarica il file ZIP contenente i tuoi dati.',
    'conversationTypeSnapchatProviderText7.1': 'Una volta scaricato il file ZIP, non aprirlo.',
    'conversationTypeSnapchatProviderText7.2': 'Carica il file ZIP completo, così com\'è, nella sezione indicata sul nostro sito.',
    'conversationTypeSnapchatProviderText7.3': 'In seguito potrai scegliere la chat che preferisci per creare il tuo libro.',
    conversationTypeSnapchatProviderTitle1: '1. Accedi alle Impostazioni di Snapchat:',
    conversationTypeSnapchatProviderTitle2: '2. Richiedi i tuoi Dati:',
    conversationTypeSnapchatProviderTitle3: '3. Autenticazione:',
    conversationTypeSnapchatProviderTitle4: '4. Download dei tuoi Dati:',
    conversationTypeSnapchatProviderTitle5: '5. Attendi l\'Email:',
    conversationTypeSnapchatProviderTitle6: '6. Scarica l\'Archivio:',
    conversationTypeSnapchatProviderTitle7: '7. Caricamento su MonLivreSMS:',
    'conversationTypeTelegramProviderText1.1': 'Installa l\'applicazione Telegram Desktop sul tuo PC o Mac da https://desktop.telegram.org/.',
    'conversationTypeTelegramProviderText1.2': 'Apri l\'applicazione Telegram sul tuo computer.',
    'conversationTypeTelegramProviderText2.1': 'Nell\'app, apri la chat che desideri trasformare in libro cliccando sul nome del tuo contatto.',
    'conversationTypeTelegramProviderText3.1': 'Clicca sui tre puntini nell\'angolo in alto a destra della chat.',
    'conversationTypeTelegramProviderText3.2': 'Scegli "Esporta cronologia chat".',
    'conversationTypeTelegramProviderText4.1': 'Nella finestra delle impostazioni, seleziona tutti i tipi di file che desideri includere (foto, video, messaggi vocali, ecc.).',
    'conversationTypeTelegramProviderText4.2': 'Imposta il limite di dimensione al massimo consentito per l\'esportazione.',
    'conversationTypeTelegramProviderText4.3': 'Clicca su "Esporta" in fondo alla finestra.',
    'conversationTypeTelegramProviderText5.1': 'Individua la cartella con i dati esportati e comprimila in un file ZIP (Tasto destro > Invia a > Cartella compressa).',
    'conversationTypeTelegramProviderText6.1': 'Carica il file ZIP completo sul nostro sito.',
    conversationTypeTelegramProviderTitle1: '1. Installa Telegram Desktop:',
    conversationTypeTelegramProviderTitle2: '2. Seleziona la Chat:',
    conversationTypeTelegramProviderTitle3: '3. Esporta la Cronologia:',
    conversationTypeTelegramProviderTitle4: '4. Impostazioni di Esportazione:',
    conversationTypeTelegramProviderTitle5: '5. Comprimi in un File ZIP:',
    conversationTypeTelegramProviderTitle6: '6. Carica il file su MonLivreSMS:',
    conversationTypeTitle: 'Crea un libro dalla chat con {name}',
    conversationTypeWhatsappFileText1: 'Recupera la tua chat di WhatsApp',
    conversationTypeWhatsappFileText2: 'Clicca su "Allega un file"',
    conversationTypeWhatsappFileText3: 'Carica la tua conversazione',
    conversationTypeWhatsappFileText4: 'Se il file non è in formato ".zip", comprimilo prima.',
    conversationTypeWhatsappFileText5: 'Se desideri solo il testo della tua conversazione (senza foto), carica unicamente il file .txt',
    conversationTypeWhatsappProviderText1: 'Esporta una copia della tua chat di WhatsApp',
    conversationTypeWhatsappProviderText2: '<strong>Da un Android:</strong><br></br>Apri l\'applicazione di WhatsApp<br></br>Entra nella chat desiderata<br></br>Tocca "Opzioni" (i tre puntini in alto a destra)',
    conversationTypeWhatsappProviderText3: '<strong>Da iOS (iPhone):</strong><br></br>Apri l\'applicazione di WhatsApp<br></br>Entra nella chat desiderata<br></br>Tocca il nome del contatto o del gruppo in alto<br></br>Scorri fino in fondo e seleziona "Esporta chat"',
    conversations: 'Chat',
    conversationsMy: 'Le mie chat',
    conversationsLuxEyebrow: 'Le tue storie',
    conversationsLuxHint: 'Ritrova le tue conversazioni e trasformale in un bel libro.',
    ordersLuxEyebrow: 'Il laboratorio',
    ordersLuxHint: 'Segui i tuoi libri, dal laboratorio a casa.',
    ordersLuxDetailTitle: 'Il tuo libro',
    ordersLuxDetailHint: 'Segui il tuo libro, dal laboratorio alla porta.',
    ordersLuxViewFollow: 'Segui il mio libro',
    ordersLuxEmptyTitle: 'La tua prima storia ti sta aspettando.',
    ordersLuxEmptyHint: 'Trasforma una conversazione in un libro che vorrai aprire ancora e ancora.',
    ordersLuxStepReceived: 'Ricevuto',
    ordersLuxStepAtelier: 'Laboratorio',
    ordersLuxStepPrint: 'Stampa',
    ordersLuxStepShipped: 'In viaggio',
    ordersLuxStepHome: 'Da te',
    ordersLuxStoryPendingpayment: 'Appena paghi, il libro entra in laboratorio.',
    ordersLuxStoryPending: 'Abbiamo ricevuto l\'ordine. Il laboratorio è già al lavoro.',
    ordersLuxStoryOnpreparation: 'Il tuo libro prende forma. Ogni pagina è preparata con cura.',
    ordersLuxStoryOnfabrication: 'Il tuo libro è in stampa. Presto lascerà il laboratorio.',
    ordersLuxStoryShipped: 'Il tuo libro è in viaggio. Sta arrivando a casa tua.',
    ordersLuxStoryComplete: 'Il tuo libro è arrivato. Aspetta solo le tue mani.',
    ordersLuxStoryCanceled: 'Questo ordine è stato annullato. I tuoi ricordi restano al sicuro da noi.',
    userProfileLuxEyebrow: 'Il tuo spazio',
    userProfileLuxHint: 'Gestisci i tuoi dati, i metodi di accesso e le preferenze.',
    userProfileValueEmpty: 'Non indicato',
    userProfileNotLinked: 'Non collegato',
    userProfileNewsletterOn: 'Ricevi già le nostre novità e le nostre offerte.',
    userProfilePasswordOn: 'Impostata',
    addressesLuxEyebrow: 'Il tuo spazio',
    addressesLuxHint: 'Trova i tuoi indirizzi di consegna e fatturazione.',
    addressesLuxEditHint: 'Questo indirizzo può servire per la consegna o la fatturazione.',
    conversationsNewApp: 'Nuove chat nell\'applicazione',
    conversationsOldApp: 'Vecchie chat nell\'applicazione',
    dashboardTitle: 'Bacheca',
    date: 'Data',
    dateActivated: 'Data di attivazione',
    dateCreated: 'Data di creazione',
    dateLastCguAccept: 'Data di ultima accettazione dei T&C',
    dateLastEdit: 'Data di ultima modifica',
    dateLastLogin: 'Data di ultimo accesso',
    dateSelect: 'Seleziona una data',
    dateSelectPlaceholder: 'Clicca qui per selezionare una data...',
    days: 'Giorno(i)',
    daysCount: `{count} {count, plural,
        =0 {giorno}
        =1 {giorno}
        other {giorni}
    }`,
    delete: 'Elimina',
    deleteRequestError: 'Errore durante l\'eliminazione!',
    deleteRequestSuccess: 'Eliminato con successo!',
    description: 'Descrizione',
    detailsInformation: 'Dettagli',
    domain: 'Dominio',
    download: 'Scarica',
    edit: 'Modifica',
    editViewAdvanced: 'Modifica avanzata',
    editViewSimplified: 'Modifica semplificata',
    elementNoItems: 'Nessun elemento',
    elementsCount: `{count} {count, plural,
              =0 {elemento}
              =1 {elemento}
              other {elementi}
          }`,
    example: 'Esempio',
    examples: 'Esempi',
    file: 'File',
    fileDeleteError: 'Impossibile eliminare questo file',
    fileDeleteSuccess: 'File eliminato!',
    fileSelected: 'File selezionato: {file}',
    fileSwitch: 'Cambia file',
    fileUploadError: 'Impossibile caricare questo file!',
    fileUploadProcessStartOnSave: 'Il caricamento del file inizierà al momento del salvataggio.',
    fileUploadRestrictionTypeError: 'Formato di file non valido! Consentiti: {types}',
    fileUploadSuccess: 'File caricato correttamente!',
    files: 'File',
    filtersTitle: 'Filtri',
    finish: 'Termina',
    flags: 'Bandiere',
    free: 'Gratis',
    generalInformation: 'Informazioni generali',
    help: 'Aiuto',
    hours: 'Ore',
    hoursCount: `{count} {count, plural,
        =0 {ora}
        =1 {ora}
        other {ore}
    }`,
    imageDeleteError: 'Impossibile eliminare questa immagine!',
    imageDeleteSuccess: 'Immagine eliminata!',
    imageUploadError: 'Impossibile caricare questa immagine',
    imageUploadRestrictionSize: 'L\'immagine deve avere una dimensione massima di {format}',
    imageUploadRestrictionType: 'L\'immagine deve essere in formato {types}',
    imageUploadRestrictionTypeError: 'Formato immagine non accettato! Consentiti: {types}',
    import: 'Importa',
    importModelDownloadButton: 'Scarica il modello',
    importRequestError: 'Si è verificato un errore durante l\'importazione!',
    importRequestSomeFailAlert: 'Uno o più elementi non sono stati importati!',
    importRequestSuccess: 'Dati importati con successo!',
    importerFileButton: 'Importa i dati',
    importerFileHelp: 'Puoi generare un file CSV utilizzando il tuo foglio di calcolo (Excel, OpenOffice, ...)',
    importerFileInfo: 'Seleziona un file CSV (Valori separati da virgole)',
    importerNoItemsAlert: 'Nessun elemento da importare',
    importerTitle: 'Importazione dei dati',
    information: 'Informazioni',
    informationsDetails: 'Dettagli',
    informationsGeneral: 'Informazioni generali',
    invoicePrint: 'Stampa la fattura',
    invoicesPrint: 'Stampa le fatture',
    isActive: 'Attivo?',
    isPublic: 'È pubblico?',
    isUnlimited: 'Illimitato?',
    label: 'Nome/Etichetta',
    language: 'Lingua',
    languageAR: 'Arabo',
    languageBN: 'Bengalese',
    languageDE: 'Tedesco',
    languageEN: 'Inglese',
    languageES: 'Spagnolo',
    languageFR: 'Francese',
    languageHI: 'Hindi',
    languageIT: 'Italiano',
    languageJA: 'Giapponese',
    languagePT: 'Portoghese',
    languageRU: 'Russo',
    languageZH: 'Cinese',
    learnMoreButton: 'Scopri di più',
    limitLabel: 'Tipo di limite',
    limitTextForm1: 'deve avere un',
    listTitle: 'Lista',
    loading: 'Caricamento...',
    logo: 'Logo',
    minutes: 'Minuto(i)',
    name: 'Nome',
    next: 'Avanti',
    no: 'No',
    of: 'di',
    options: 'Opzioni',
    order: 'Ordine',
    orderAdd: 'Aggiungi un ordine',
    orderAddTitle: 'Crea un ordine',
    orderAddressPrivacyInfo: ' Il tuo indirizzo non sarà reso pubblico! Solo gli altri partecipanti a questo ordine potranno vederlo.',
    orderAddressShippingValid: 'Conferma l\'indirizzo di spedizione',
    orderBilling: 'Fatturazione',
    orderConfirmationPaymentError: 'Si è verificato un errore... Per favore, contattaci!',
    orderConfirmationPaymentWaiting: 'Attendi... Stiamo elaborando il tuo pagamento per confermare il tuo ordine.',
    orderConfirmationPendingText: 'Il tuo ordine è in attesa di pagamento per poter essere completato! Clicca sul link qui sotto per finalizzare il tuo acquisto effettuando il pagamento.',
    orderConfirmationPendingText2: 'ATTENZIONE: Se paghi con carta di credito, la convalida del pagamento potrebbe richiedere alcuni minuti. Ti preghiamo di attendere i controlli di sicurezza.',
    orderConfirmationPendingTitle: 'Ordine in attesa di pagamento!',
    orderConfirmationSocialText: 'Seguici sui tuoi social network preferiti per non perderti le nostre novità, nuovi prodotti e promozioni esclusive...',
    orderConfirmationSocialTitle: 'Restiamo in contatto!',
    orderConfirmationText: ' Il tuo ordine è stato registrato correttamente e passerà in preparazione. Riceverai un\'email non appena verrà spedito.',
    orderConfirmationTitle: 'Ordine ricevuto!',
    orderContent: 'Contenuto dell\'ordine',
    orderDetails: 'Dettagli',
    orderId: 'Identificativo',
    orderInfoCommentAlertTitle: 'Messaggio importante',
    orderInvoice: 'Fattura',
    orderInvoicePrintButton: 'Stampa la fattura',
    orderItemsEmpty: 'Non c\'è alcun articolo nel tuo ordine',
    orderItemViewBook: 'Vedi il mio libro',
    orderItemsTotal: 'Totale articoli:',
    orderMassStatusConfirmMessage: 'Aggiornare lo stato di {count} ordine/i?',
    orderNoItems: 'Non hai ancora effettuato alcun ordine!',
    orderNoteCustomer: 'Nota del cliente',
    orderPaymentChooseMethodLabel: 'Scegli un metodo di pagamento',
    orderPaymentFinishTitle: 'Finalizza il tuo pagamento',
    orderPaymentValidButton: 'Conferma il pagamento',
    orderPayments: 'Pagamenti',
    orderProcessInvitationText: 'Invita i tuoi amici a riempire la casella',
    orderProcessInvitationTextBefore1: 'Directos.eu è un servizio di acquisto di gruppo tra privati che ti permette di acquistare prodotti direttamente dai produttori. Risparmierai sia sul prezzo dei prodotti CHE sulle spese di spedizione!',
    orderProcessInvitationTextBefore2: 'Non preoccuparti! Abbiamo la soluzione:',
    orderProductAdd: 'Aggiungi un prodotto ',
    orderRefunds: 'Rimborsi',
    orderShipping: 'Spedizione',
    orderShippingAdd: 'Aggiungi la spedizione',
    orderShippingFee: 'Spese di spedizione',
    orderShippingRemoveConfirmMessage: 'Vuoi davvero rimuovere questa spedizione dall\'ordine?',
    orderShippingTrackingTitle: 'Segui il tuo ordine',
    orderShippingTrackingButton: 'Segui il mio pacco',
    orderShippingTrackingHint: 'Il tracking può impiegare alcune ore per comparire presso il corriere.',
    orderShippings: 'Spedizioni',
    orderStatus: 'Stato',
    orderStatusCanceled: 'Annullato',
    orderStatusComplete: 'Completato',
    orderStatusOnpreparation: 'In preparazione',
    orderStatusOnprogress: 'In corso',
    orderStatusPending: 'In attesa',
    orderStatusPendingpayment: 'In attesa di pagamento',
    orderStatusShipped: 'Spedito',
    orderSubtotalDiscount: 'Sconto',
    orderSubtotalExclTax: 'Subtotale (IVA escl.)',
    orderSubtotalInclTax: 'Subtotale (IVA incl.)',
    orderTax: 'IVA',
    orderThanks: 'Grazie per il tuo ordine',
    attributionPaidLine: 'Il pagamento è andato a buon fine',
    attributionSkip: 'Vedi il mio ordine',
    attributionSourceTitle: 'Cosa ti ha fatto venire voglia di questo libro?',
    attributionSourceLead: 'Il tuo ordine c\'è già. Una risposta ci dice cosa ti ha colpito.',
    attributionSearchTitle: 'Prima di cercare, conoscevi già MonLivreSMS?',
    attributionSearchLead: 'Un nome che avevi già sentito, oppure una scoperta.',
    attributionOccasionTitle: 'Per quale occasione è questo libro?',
    attributionOccasionLead: 'Quella a cui stai pensando.',
    attributionOtherPlaceholder: 'Qualche parola, se vuoi',
    attributionOtherContinue: 'Continua',
    attributionSaveError: 'Non siamo riusciti a salvare questa risposta. Riprova.',
    attributionOpt_bouche_a_oreille: 'Una persona vicina me ne ha parlato',
    attributionOpt_vu_objet: 'Ho visto il libro a casa di qualcuno',
    attributionOpt_receveur_devenu_client: 'Me ne hanno regalato uno, ora tocca a me',
    attributionOpt_recherche: 'Cercando su Google',
    attributionOpt_instagram: 'Instagram',
    attributionOpt_tiktok: 'TikTok',
    attributionOpt_facebook: 'Facebook',
    attributionOpt_pinterest: 'Pinterest',
    attributionOpt_qvema: 'Qui veut être mon associé',
    attributionOpt_medias: 'Un articolo, una trasmissione o un podcast',
    attributionOpt_client_existant: 'Avevo già ordinato qui',
    attributionOpt_autre: 'Altro',
    attributionOpt_decouverte_pure: 'Piuttosto un caso',
    attributionOpt_pre_bao: 'Una persona vicina me ne aveva parlato',
    attributionOpt_pre_tv: 'L\'avevo visto in tv',
    attributionOpt_pre_social: 'L\'avevo visto sui social',
    attributionOpt_pre_inconnu: 'Non ricordo bene',
    attributionOpt_anniv_couple: 'L\'anniversario di quando ci siamo conosciuti',
    attributionOpt_noel: 'Natale',
    attributionOpt_saint_valentin: 'San Valentino',
    attributionOpt_anniversaire: 'Un compleanno',
    attributionOpt_deuil: 'I messaggi di qualcuno che ho perso',
    attributionOpt_naissance: 'Una nascita',
    attributionOpt_distance: 'Qualcuno che parte, o che vive lontano',
    attributionOpt_pour_soi: 'Per me, non per regalarlo',
    attributionOpt_autre_occasion: 'Un altro momento',
    bookIntentTitle: 'Questo libro è per...',
    bookIntentLead: 'Una risposta, e si comincia.',
    bookIntentSkip: 'Non ora',
    bookIntentOpt_anniv_couple: 'L\'anniversario di quando ci siamo conosciuti',
    bookIntentOpt_anniversaire: 'Il compleanno di qualcuno',
    bookIntentOpt_noel: 'Natale',
    bookIntentOpt_saint_valentin: 'San Valentino',
    bookIntentOpt_souvenir: 'Qualcuno che non c\'è più',
    bookIntentOpt_plus_tard: 'Più avanti',
    bookIntentOpt_autre: 'Altro',
    bookIntentDate_anniv_couple: 'Qual è la data?',
    bookIntentDateLead_anniv_couple: 'Il giorno in cui vi siete conosciuti, o quello che festeggiate insieme.',
    bookIntentDate_anniversaire: 'Quand\'è il compleanno?',
    bookIntentDateLead_anniversaire: 'Il compleanno della persona a cui lo regali.',
    bookIntentDate_plus_tard: 'Verso quale data?',
    bookIntentDateLead_plus_tard: 'Il giorno che hai in mente.',
    bookIntentDateDefer: 'La data, più avanti',
    bookIntentDateBack: 'Indietro',
    bookIntentDateContinue: 'Continua',
    bookIntentSaveError: 'Non siamo riusciti a salvare la risposta. Riprova.',
    inboxPromptTitle: 'Per il tuo libro',
    inboxPromptSignup: 'Ti abbiamo appena scritto, « {subject} ». È l\'inizio del tuo libro, non una pubblicità. A volte {provider} lo mette da parte. Segnala come « {mark} ». Con questo gesto, il seguito ti arriva come si deve, con quello che serve per farlo davvero bene.',
    inboxPromptTransfer: 'Ti abbiamo appena scritto, « {subject} ». È il link alla tua conversazione, non una pubblicità. A volte {provider} lo mette da parte. Segnala come « {mark} ». Con questo gesto, hai tutto sotto mano per farne il libro che vuoi.',
    inboxPromptMarkGmail: 'Non è spam',
    inboxPromptMarkYahoo: 'Non è spam',
    inboxPromptButton: 'La confermo in {provider}',
    inboxPromptClose: 'Chiudi',
    inboxPromptConfirm: 'Ti abbiamo appena scritto, « {subject} ». Apre il tuo account. A volte {provider} lo mette da parte. Segnala come « {mark} ». Con questo gesto, il seguito ti arriva.',
    emailConfirmPageTitle: 'Conferma il tuo indirizzo',
    emailConfirmTitle: 'Guarda la tua posta',
    emailConfirmLead: 'Ti abbiamo appena scritto per aprire il tuo account. Il pulsante dentro conferma il tuo indirizzo.',
    emailConfirmResend: 'Invia di nuovo la mail',
    emailConfirmResent: 'La mail è ripartita.',
    emailConfirmExpired: 'Questo link è scaduto. Chiedine uno nuovo dal tuo account.',
    emailConfirmInvalid: 'Questo link non corrisponde a nessun account.',
    emailConfirmWorking: 'Apertura dell\'account…',
    orderTotal: 'TOTALE',
    orderTotalTTC: 'Totale (IVA incl.)',
    orderTotalTax: 'I.V.A. {rate}%',
    orderTotalToPay: 'Importo totale da pagare: {total}€',
    orderTotals: 'Totali',
    orderUserRegisterAlert: 'Devi fornirci la tua email affinché possiamo contattarti in caso di problemi con il tuo ordine.',
    orderView: 'Vedi l\'ordine',
    orderWeight: 'Peso',
    orderitemAddProductTitle: 'Modifica i dati dell\'articolo',
    orders: 'Ordini',
    ordersContactTitle: 'Contatta in merito a un ordine',
    ordersMy: 'I miei ordini',
    ordersMyViewButton: 'Vedi i miei ordini',
    packingInformation: 'Informazioni di imballaggio',
    parcelGroupInfo: ' Raggruppa la spedizione per numero di pacchi',
    parcelGroupLabel: 'Gruppo di pacchi',
    parcelGroupWeightInfo: 'Kg per pacco',
    parcelGroupWeightLabel: 'Raggruppa la spedizione per peso',
    paymentCardInputLabel: 'Inserisci i dati della tua carta per confermare il tuo ordine.',
    paymentMethodCreditbalanceDescription1: 'Scalato automaticamente dal totale',
    paymentMethodCreditbalanceDescription2: 'Resta da pagare',
    paymentMethodCreditbalancePay: 'Conferma con il mio credito',
    paymentMethodCreditbalanceTitle: 'Credito già applicato',
    paymentFailError: 'Il tuo pagamento non è andato a buon fine! Per favore, riprova.',
    paymentMethod: 'Metodo di pagamento',
    paymentMethodBancontactLabel: 'Bancontact',
    paymentMethodBankcheckLabel: 'Assegno bancario',
    paymentMethodBanktransferLabel: 'Bonifico bancario',
    paymentMethodCardLabel: 'Carta bancaria',
    paymentMethodCreditcardLabel: 'Carta bancaria',
    paymentMethodCreditDescription1: 'Questo importo verrà scalato automaticamente dall\'importo in sospeso del tuo carrello.',
    paymentMethodGiropayLabel: 'Giropay',
    paymentMethodIdealLabel: 'iDEAL',
    paymentMethodPhoneLabel: 'Telefono',
    paymentMethodCreditPay: 'Paga con i miei crediti',
    paymentMethodCreditTitle: 'Hai già pagato una parte del tuo ordine:',
    paymentValidButton: 'Conferma il mio pagamento',
    previous: 'Precedente',
    priceInformation: 'Informazioni sui prezzi',
    priceRoundAlertTooltip: 'Questo prezzo potrebbe subire un leggero arrotondamento a causa della conversione di valuta.',
    printButton: 'Stampa',
    process: 'Processo',
    productAnnexes: 'Allegati',
    productAnnexesNewProductError: 'Per favore, salva il tuo nuovo prodotto prima di aggiungere allegati!',
    productAttributes: 'Attributi',
    productConversationTypeMissingAlert: 'Non c\'è alcun prodotto associato al tipo selezionato. Contattaci per risolvere il problema!',
    productCostHT: 'Costo (senza IVA)',
    productDescription: 'Descrizione',
    productEdit: 'Modifica il prodotto',
    productImages: 'Immagini',
    productImagesNewProductError: 'Per favore, salva il tuo nuovo prodotto prima di aggiungere immagini!',
    productIsActive: 'Attivo?',
    productName: ' Nome',
    productPictureDelete: 'Elimina l\'immagine',
    productPriceHT: 'Prezzo (senza IVA)',
    productPriceTTC: 'Prezzo (IVA incl.)',
    productReference: 'Riferimento',
    productSlug: 'Slug',
    productSpecialPriceQuantityDiscountInfo: 'Risparmia il {percent}% sul tuo acquisto aggiungendo {quantity} copie!',
    productTaxCalculate: 'Calcola',
    productTaxRate: 'Tipo di IVA',
    productTaxRateFormHelp: 'Per un\'IVA del 22%, inserisci 0.22',
    productUseForConversationBook: 'Disponibile per i libri cartacei?',
    productUseForConversationEBook: 'Disponibile per gli eBook (digitale)?',
    productUseForCredit: 'Utilizzare per i crediti utente?',
    products: 'Prodotti',
    productsView: 'Vedi i prodotti',
    quantity: 'Quantità',
    refresh: 'Aggiorna',
    refundCreateTitle: 'Crea un rimborso',
    refundCreateConfirmMessage: 'Confermi la creazione di questo rimborso?',
    remove: 'Elimina',
    retry: 'Riprova',
    save: 'Salva',
    saveBeforeAlert: 'Per favore, salva prima le modifiche...',
    saveRequestError: 'Errore durante il salvataggio!',
    saveRequestSuccess: 'Salvato correttamente!',
    saving: 'Salvataggio in corso...',
    searchFor: 'Cerca',
    seconds: 'Secondo(i)',
    select: 'Seleziona',
    selectAll: 'Seleziona tutto',
    selectFile: 'Seleziona un file',
    selectImage: 'Seleziona un\'immagine',
    selectOptions: 'Seleziona un\'opzione',
    selectUnAll: 'Deseleziona tutto',
    seoTitle: 'Stampa i tuoi SMS e le tue chat in un libro',
    shippingAddressEdit: 'Modifica l\'indirizzo di spedizione',
    shippingAddressMissingError: 'Non hai inserito alcun indirizzo di spedizione.',
    shippingCalculation: 'Calcolo',
    shippingCalculationInfo: 'Se il calcolo va in loop, è preferibile utilizzare il limite massimo inclusivo.',
    shippingCarrier: 'Corriere',
    shippingChronopostPickupError: 'Non siamo riusciti a caricare i Punti di Ritiro! Controlla il paese e il codice postale prima di riprovare.',
    shippingChronopostPickupNoResult: 'Non abbiamo trovato alcun punto di ritiro nelle vicinanze. Cerca con un indirizzo o codice postale diverso.',
    shippingChronopostPickupOpeningHours: 'Orari di apertura',
    shippingChronopostPickupOpeningHoursView: 'Vedi gli orari',
    shippingChronopostPickupViewList: 'Vedi in formato lista',
    shippingChronopostPickupViewMap: 'Vedi sulla mappa',
	shippingPickupError: 'Impossibile aprire il selettore dei punti di ritiro. Riprova più tardi.',
	shippingPickupChange: 'Cambia punto di ritiro',
	shippingPickupChoose: 'Scegli un punto di ritiro',
    shippingCountrySelect: 'Paese di spedizione',
    shippingDeleteConfirmMessage: 'Vuoi davvero eliminare questo metodo di spedizione?',
    shippingDeliveryEstimationDate1: 'Data di consegna stimata: {date}',
    shippingDeliveryEstimationDate2: 'Data di consegna stimata: tra il {date1} e il {date2}',
    shippingDeliveryEstimationText: 'Questa è solo una stima delle spese di spedizione. Potrai scegliere il tuo punto di consegna esatto nel passaggio successivo.',
    shippingSurchargeCorsica: 'Questa tariffa include un supplemento Corsica di {price}.',
    shippingSurchargeOverseas: 'Questa tariffa include un supplemento territori d\'oltremare di {price}.',
    shippingSurchargeRemote: 'Questa tariffa include un supplemento zone difficili da raggiungere di {price}.',
    shippingDeliveryTime: 'Tempi di consegna (in giorni)',
    shippingDeliveryTimeInfo: 'Consegna in {days} giorni lavorativi',
    shippingDescription: 'Descrizione',
    shippingExcludeDepartmentInfo: 'Separa i codici postali da escludere con una virgola (,). Puoi usare "*" come jolly.',
    shippingExcludeDepartmentLabel: 'Escludi codici postali',
    shippingExtraFeeCalculation: 'Calcolo delle spese di spedizione aggiuntive',
    shippingExtraFeeLabel: 'Etichetta delle spese di spedizione aggiuntive',
    shippingExtraFees: 'Spese aggiuntive',
    shippingFeeCalculatorTitle: 'Calcola le tue spese di spedizione',
    shippingFeeFreeDelivery: 'Spedizione gratuita!',
    shippingFeeNotFoundError: '',
    shippingFeeWithBookResult: 'Effettua subito l\'ordine per ricevere il tuo eBook all\'istante, e i tuoi libri cartacei in {countryName} tra il {deliveryDateFrom} e il {deliveryDateTo}.',
    shippingFeeWithoutBookResult: 'Effettua subito l\'ordine e ricevi il tuo eBook all\'istante via email.',
    shippingFreeStep: 'Soglia per la spedizione gratuita',
    shippingFreeTreshold: 'Importo per la spedizione gratuita',
    shippingFreeInfo: 'Spedizione gratuita a partire da {value}',
    shippingIdentifier: 'Identificativo di spedizione',
    shippingIsPriceTTC: 'Il prezzo della spedizione include l\'IVA?',
    shippingLabelGenerateButton: 'Genera l\'etichetta',
    shippingLabelGenerateButton2: 'Rigenera l\'etichetta',
    packingCheckTitle: 'I libri di quest\'ordine',
    packingCheckHint: 'Avvicina un libro alla volta, con il retro verso la camera. Quando il conteggio avanza, mettilo fuori dall\'inquadratura e passa al successivo.',
    packingCheckProgress: '{seen} / {expected}',
    packingCheckForeign: 'Questo libro è dell\'ordine {code}. Toglilo dal pacco.',
    packingCheckReady: 'Va bene, sono i libri di quest\'ordine. Puoi stampare l\'etichetta.',
    packingCheckOverflow: 'Hai letto troppi libri. Ricomincia.',
    packingCheckRestart: 'Ricomincia',
    packingCheckCameraStart: 'Apri la camera',
    packingCheckCameraDenied: 'La camera è bloccata. Consentila, oppure leggi il QR con lo scanner.',
    packingCheckLocked: 'Scansiona tutti i libri prima di stampare l\'etichetta.',
    packingCheckWedgeLabel: 'Oppure leggi il QR con lo scanner',
    packingCheckLoading: 'Stiamo caricando i libri di quest\'ordine.',
    prepBooksCardTitle: 'Libri',
    prepBooksCount: '{count, plural, one {# libro} other {# libri}}',
    prepBooksPageEyebrow: 'Preparazione',
    prepBooksPageTitle: 'Ordine {code}',
    prepBooksPageHint: 'I libri che vanno in questo pacco.',
    prepModeClient: 'Vista cliente',
    prepModePreparation: 'Vista preparazione',
    shippingLegacyChronopostPaused: 'Questo ordine è ancora sul Chronopost di prima. Cambia il metodo di spedizione su un\'offerta Sendcloud con Modifica, poi genera l\'etichetta.',
    shippingMethodCalculating: 'Calcolo delle opzioni di spedizione...',
    shippingMethodConditions: 'Condizioni di spedizione',
    shippingMethodMissingAlert: 'Non troviamo alcun corriere disponibile per il tuo carrello. Modifica l\'indirizzo o scegli un altro corriere.',
    shippingMethodNotAvailable: 'Non ci sono opzioni di consegna disponibili per il tuo indirizzo...',
    shippingRatesError: 'Il calcolo delle spese di spedizione si è interrotto. Riprova tra un attimo e, se succede di nuovo, scrivici: lo verifichiamo insieme.',
    shippingMethodPricing: 'Tariffa',
    shippingMethodPricingSystem: 'Sistema di tariffazione',
    shippingMethodSearch: 'Ricerca opzioni di spedizione...',
    shippingMethodSelectTitle: 'Seleziona il tuo metodo di spedizione',
    shippingGroupRelay: 'Punto di ritiro',
    shippingGroupHome: 'A domicilio',
    shippingTierClassic: 'Consegna standard',
    shippingTierExpress: 'Consegna express',
    shippingTierClassicDesc: 'Tempi standard',
    shippingTierExpressDesc: 'L\'opzione più rapida',
    shippingTierPriceRelayFree: 'Gratis in punto di ritiro',
    shippingTierPriceRelayFrom: 'Da {price} in punto di ritiro',
    shippingTierPriceHomeFrom: '{price} a domicilio',
    shippingChangeTier: 'Cambia velocità di consegna',
    shippingTierModeTitle: 'Scegli la modalità di consegna',
    shippingStepOf: 'Passo {current} di {total}',
    shippingStepSpeedTitle: 'Quando vuoi ricevere il tuo ordine?',
    shippingStepModeTitle: 'Dove vuoi ricevere il tuo ordine?',
    shippingMethodTrackingInfo: 'Informazioni di tracciamento',
    shippingMethods: 'Metodi di spedizione',
    shippingOrder: 'Ordine di spedizione',
    shippingProvider: 'Fornitore logistico',
    shippingStep: 'Passaggio',
    shippingStepInfo: 'Questo passaggio DEVE essere il parametro di sinistra! Il parametro superiore è il codice postale predefinito.',
    shippingStepLimitInfo: 'La condizione di sinistra è il minimo/massimo?',
    shippingTaxRate: 'Tipo di IVA della spedizione',
    shippingTitle: 'Consegna',
    shippingTrackingNumber: 'Numero di tracciamento',
    shippingTrackingParcelUrl: 'URL di tracciamento del pacco',
    status: 'Stato',
    stepTitle: 'Passaggio {step}',
    submit: 'Invia',
    suborderitemAddProductTitle: 'Aggiungi un prodotto',
    switchLanguage: 'Cambia lingua',
    tableMassActions: 'Azioni in blocco',
    tableRefreshSuccessAlert: 'Sincronizzato correttamente!',
    tableRefreshSuccessError: 'Errore di sincronizzazione!',
    tableSelection: `{count} {count, plural,
			  =0 {selezionato}
			  =1 {selezionato}
			  other {selezionati}
		  }`,
    tag: 'Etichetta',
    tagFillPlaceholder: 'Inserisci una parola chiave...',
    tags: 'Etichette',
    taskDescription: 'Descrizione',
    taskEditTitle: 'Modifica l\'attività',
    taskPriority: 'Priorità',
    taxRate: 'IVA',
    the: 'il/la',
    time: 'Ora',
    timezone: 'Fuso orario',
    title: 'Titolo',
    toleranceLabel: 'Tolleranza',
    total: 'Totale',
    type: 'Tipo',
    unit: 'Unità',
    user: 'Utente',
    userAccountCreditsTitle: 'Il mio saldo crediti',
    userAccountDataProtection: 'Protezione dei dati',
    userAccountDataProtectionText1: 'Prendiamo molto sul serio la protezione dei tuoi dati personali. Per questo ci impegniamo a mantenerli al sicuro e li conserviamo solo per il tempo strettamente necessario a fornirti il nostro servizio.',
    userAccountDataProtectionText2: 'Ti chiediamo solo le informazioni strettamente necessarie. Non condivideremo mai i tuoi dati con terze parti né li utilizzeremo a fini commerciali senza il tuo esplicito consenso.',
    userAccountDataProtectionText3: 'Se desideri scaricare i tuoi dati o esercitare il tuo diritto all\'oblio, contattaci all\'indirizzo {email}.',
    userAccountDelete: 'Elimina il mio account',
    userAccountDeleteActiveSuborder: 'Non puoi eliminare il tuo account mentre hai ordini in corso!',
    userAccountDeleteBlockText: 'Non puoi eliminare il tuo account in questo momento!',
    userAccountDeleteButton: 'Elimina il mio account definitivamente',
    userAccountDeleteConfirmMessage: 'Vuoi davvero eliminare il tuo account per sempre?',
    userAccountDeleteConfirmTitle: 'Elimina il mio account',
    userAccountDeleteError: 'Non siamo riusciti a eliminare il tuo account!',
    userAccountDeleteSuccess: 'Il tuo account è stato eliminato! Speriamo di rivederti presto!',
    userAccountDeleteText: 'Eliminando il tuo account, perderai l\'accesso a tutta la tua cronologia e ai tuoi libri salvati. Cancelleremo tutti i tuoi dati personali dai nostri server in modo sicuro. Questa azione è irreversibile!',
    userAccountEdit: 'Modifica i miei dati',
    userAccountEditSuccess: 'Profilo aggiornato correttamente',
    userAccountExistError: 'Non esiste alcun account associato a questo indirizzo email!',
    userAccountExistTitle: 'Hai già un account con noi?',
    userAccountGeneral: 'Generale',
    userAccountHistory: 'Cronologia',
    userAccountInfo: 'I tuoi dati sono protetti e rimarranno strettamente riservati.',
    userAccountInfoMyTitle: 'I miei dati personali',
    userAccountMy: 'Il mio account',
    userAccountPersonnalInformation: 'Le mie informazioni personali',
    userAccountPreferencesInformation: 'Le mie preferenze',
    userAccountResetError: 'Errore durante il tentativo di ripristino dell\'account!',
    userAccountResetSuccess: 'Account ripristinato con successo!',
    userActivityOnLine: 'Online',
    userAdd: 'Aggiungi un utente',
    userAddNew: 'Aggiungi un nuovo utente',
    userBridgeError: 'Accesso dall\'applicazione non riuscito. Riprova.',
    userBridgeInvalid: 'Questo link di accesso non è più valido. Riavvia l\'accesso dall\'applicazione.',
    userBridgePending: 'Accesso in corso…',
    userBridgeSuccess: 'Accesso effettuato! Ora puoi tornare all\'applicazione.',
    userChangePasswordSuccess: 'Password aggiornata!',
    userConfirmationCode: 'Codice di conferma ricevuto via email',
    userConfirmationCodeCheckButton: 'Ho già il codice per ripristinare la mia password',
    userConfirmationCodeError: 'Per favore, inserisci il codice di conferma che ti abbiamo inviato via email!',
    userConnectionInfo: 'Accedi per confermare il tuo ordine e salvare il tuo libro!',
    userCredits: 'Crediti',
        userCreditsBalancePositive: 'Hai {amount} di credito disponibile: verrà applicato automaticamente al passaggio successivo.',
    userCreditsPrepaymentInviteTitle: 'Pagamento anticipato del tuo libro',
    userDeleteConfirmTitle: 'Elimina l\'utente',
    userDeleteConfirmMessage: 'Vuoi davvero eliminare questo utente?',
    userDeleteConfirmation: 'L\'utente {user} è stato eliminato!',
    userEdit: 'Modifica {user}',
    userEdit2: 'Modifica l\'utente',
    userEditPassword: 'Cambia la mia password',
    userEmail: 'Indirizzo email',
    userEmailError: 'L\'indirizzo email non è valido!',
    userEmailFillInfo: 'Inserisci la tua email',
    userEmailFormInfo: 'Scrivi la tua email per continuare',
    userEmailFormInfo2: 'Utilizzeremo la tua email per creare il tuo account in modo sicuro e inviarti il tracking del tuo ordine.',
    userLoginCodeTitle: 'Hai già un account',
    userLoginCodeIntro: 'Ti abbiamo appena inviato un codice di 6 cifre a {email}. Inseriscilo qui per continuare.',
    userLoginCodeLabel: 'Codice ricevuto via email',
    userLoginCodeSubmit: 'Conferma',
    userLoginCodeInvalid: 'Questo codice non corrisponde. Controlla l\'ultima email ricevuta.',
    userLoginCodeExpired: 'Questo codice non è più valido. Richiedine uno nuovo qui sotto.',
    userLoginCodeError: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
    userLoginCodeLinkHint: 'La stessa email contiene anche un link di accesso.',
    userLoginCodeResend: 'Invia un nuovo codice',
    userLoginCodeResendIn: 'Invia un nuovo codice tra {seconds} s',
    userLoginCodeResent: 'Inviato di nuovo. Controlla anche la cartella spam.',
    userLoginCodeChangeEmail: 'Usa un\'altra email',
    userLoginCodeCartSuccess: 'Accesso effettuato. Puoi completare il tuo ordine.',
    userEnvironmentTestNoTest: 'Questo utente non ha effettuato alcun test d\'ambiente!',
    userFillPlaceholder: 'Inserisci il nome di un utente...',
    userFirstName: 'Nome',
    userForgotPassword: 'Hai dimenticato la password?',
    userForgotPasswordRetryDateError: 'Non puoi ancora richiedere un nuovo codice. Controlla la tua casella di posta (e la cartella spam) per trovarlo.',
    userFormInfo: 'Completa il tuo profilo',
    userGenderLabel: 'Genere',
    userIsActive: 'Attivo?',
    userLastName: 'Cognome',
    userLogin: 'Accedi',
    userLoginAction: 'Entra',
    userLoginEmailSelected: 'Accesso in corso con l\'email: {email}',
    userLoginError: 'Dati errati! Riprova, per favore...',
    userLoginFirstButton: 'È la tua prima volta qui?',
    userLoginFirstText: 'Controlla la tua casella di posta: ti abbiamo inviato una password temporanea. Usala per il tuo primo accesso. Potrai cambiarla facilmente dal tuo profilo.',
    userLoginBenefit1: 'Il tuo libro foto SMS in pochi clic',
    userLoginBenefit2: 'Consegna rapida a domicilio',
    userLoginBenefit3: 'Pagamento 100% sicuro',
    userLoginIntro: 'Per favore, identificati per accedere ai tuoi libri e al tuo spazio personale.',
    userLoginWelcomeSubtitle: 'Trasforma i tuoi SMS in un bel libro fotografico stampato.',
    userLoginWelcomeTitle: 'Benvenuto!',
    userLoginNoConnexion: 'Nessuna connessione',
    userLoginTitle: 'Accedi',
    userLogout: 'Esci',
    userName: 'Nome',
    userNewPassword: 'Nuova password',
    userNewsletterSubscribeButton: 'Iscrivimi alla newsletter',
    userNewsletterText1: 'Ricevi idee regalo, sconti esclusivi e le nostre ultime novità direttamente via email.',
    userOldPassword: 'La tua password attuale',
    userOptions: 'Opzioni utente',
    userPassword: 'Password',
    userPasswordConfirmation: 'Conferma la tua password',
    userPasswordConfirmationError: 'Le password non coincidono! Riprova.',
    userPasswordConfirmationRestriction: 'Entrambe le password devono essere esattamente identiche.',
    userPasswordEdit: 'Modifica la mia password',
    userPasswordSet: 'Imposta una password',
    userPasswordSetSuccess: 'Password salvata.',
    userSocialConnectionsTitle: 'Connessioni',
    userSocialContinueApple: 'Continua con Apple',
    userSocialContinueGoogle: 'Continua con Google',
    userSocialDivider: 'o',
    userSocialError: 'Accesso non riuscito. Riprova.',
    userSocialErrorNoEmail: 'Il tuo account Apple non ha fornito un indirizzo email. Usa un altro metodo.',
    userSocialErrorUnavailable: 'Questo accesso non è ancora disponibile.',
    userSocialLinkApple: 'Collega Apple',
    userSocialLinkGoogle: 'Collega Google',
    userSocialLinkSuccess: 'Account collegato.',
    userSocialLinked: 'Collegato',
    userSocialUnlinkApple: 'Scollega Apple',
    userSocialUnlinkConfirm: 'Scollegare questo accesso dal tuo account?',
    userSocialUnlinkGoogle: 'Scollega Google',
    userSocialUnlinkLastError: 'Aggiungi una password prima di scollegare il tuo ultimo accesso.',
    userSocialUnlinkSuccess: 'Account scollegato.',
    userPasswordError: 'Inserisci una password corretta, per favore!',
    userPasswordResetText: 'Inserisci la tua nuova password. Conferma e clicca sul pulsante qui sotto per salvarla.',
    userPasswordRestriction: 'Per sicurezza, la tua password deve avere almeno 6 caratteri e contenere 1 numero e 1 carattere speciale (@&!()$*€%)!',
    userPasswordRestrictionAlt: 'La tua password deve avere almeno 6 caratteri!',
    userPasswordTemporaryCheckButton: 'Ho già ricevuto la mia password temporanea',
    userPhone: 'Telefono cellulare',
    userPhoneError: 'Il numero di telefono non è valido!',
    userProfileMy: 'Il mio profilo',
    userReInitPassword: 'Reimposta la mia password',
    userRecoverFromOldAppCheckButton: 'Ho ricevuto l\'email per recuperare la mia password',
    userRecoverFromOldAppText: 'Abbiamo appena migrato il tuo account sulla nostra nuova piattaforma! Controlla la tua email per recuperare la tua password e attivare il tuo nuovo spazio personale.',
    userRegister: 'Crea il mio account',
    userRegisterError: 'Non siamo riusciti a creare il tuo account! Controlla la tua email e riprova...',
    userRegisterSuccess: 'Congratulazioni! Abbiamo creato il tuo account in modo sicuro. Hai appena ricevuto un\'email con la tua password temporanea!',
    userRegisterSuccessEmailNotice: 'Ti abbiamo appena inviato un\'email di conferma a {email}.',
    userRegisterSuccessEyebrow: 'Benvenuto',
    userRegisterSuccessPageTitle: 'Benvenuto!',
    userRegisterSuccessSourcesHint: 'Scegli l\'app in cui si trovano i tuoi messaggi.',
    userRegisterSuccessSourcesTitle: 'Da dove iniziamo?',
    userRegisterSuccessStep1Desc: 'Troverai lì il riepilogo della tua registrazione.',
    userRegisterSuccessStep1Title: 'Controlla la tua casella di posta',
    userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS o Android: scegli la tua fonte.',
    userRegisterSuccessStep2Title: 'Importa i tuoi messaggi',
    userRegisterSuccessStep3Desc: 'Copertina, colori, foto: personalizza ogni dettaglio.',
    userRegisterSuccessStep3Title: 'Crea il tuo libro',
    userRegisterSuccessStepsEyebrow: 'Il tuo percorso',
    userRegisterSuccessText: 'Il tuo account è pronto. In pochi passi, trasforma i tuoi messaggi in un libro da custodire.',
    userRegisterSuccessTitle: 'La tua storia inizia qui',
    userRegisterSuccessTitleNamed: 'Benvenuto, {firstName}!',
    userResetPasswordAccountButton: 'Reimposta la password dell\'account',
    userResetPasswordAskSuccess: 'Controlla la tua casella di posta! Ti abbiamo inviato un link per creare la tua nuova password.',
    userResetPasswordButton: 'Reimposta la mia password',
    userResetPasswordError: 'Non siamo riusciti a reimpostare la tua password! Riprova più tardi...',
    userResetPasswordInfo: 'Riceverai un link sicuro via email per reimpostare la tua password.',
    userResetPasswordInfo2: 'Crea la tua nuova password compilando i campi qui sotto:',
    userResetPasswordSuccess: 'La tua password è stata aggiornata con successo!',
    userRole: 'Ruolo',
    userRoleAdmin: 'Amministratore',
    userRoleCustomer: 'Cliente',
    userSearchLabel: 'Scrivi un\'email o il nome di un utente',
    userSendNewAccountEmail: 'Invia email di "Nuovo account" a questo utente',
    userSendNewAccountEmailSuccess: 'L\'utente è stato notificato!',
    userSwitch: 'Cambia utente',
    userValidForgotPasswordError: 'Non siamo riusciti a inviarti il codice di recupero!',
    userValidForgotPasswordSuccess: 'Controlla la tua email! Usa il codice di conferma che ti abbiamo inviato per creare la tua nuova password.',
    users: 'Utenti',
    usersList: 'Lista degli utenti',
    valid: 'Conferma',
    view: 'Vedi',
    voucher: 'Codice sconto',
    voucherApplyButton: 'Applica lo sconto',
    voucherApplyComplete: 'Non puoi accumulare altri codici sconto in questo ordine!',
    voucherApplyFormLabel: 'Codice promozionale',
    voucherApplyValidError: 'Ops! Questo codice non è valido per il tuo ordine attuale.',
    voucherCode: 'Codice',
    voucherCodePlaceholder: 'Scrivi qui il tuo codice promozionale',
    voucherDeleteConfirmMessage: 'Vuoi davvero eliminare questo buono sconto?',
    voucherEdit: 'Modifica il codice',
    voucherIsAuto: 'È automatico?',
    voucherIsCumulative: 'È cumulabile?',
    voucherIsPublic: 'È pubblico?',
    voucherNotExistsError: 'Questo codice sconto non esiste o è scaduto!',
    voucherPriority: 'Priorità',
    voucherProductOffer: 'Offerti',
    voucherRemoveAllButton: 'Rimuovi tutti gli sconti',
    vouchers: 'Codici sconto',
    weight: 'Peso',
    yes: 'Sì',
    you: 'Tu',
    yourself: 'Tu',
    userNewsletterTitle: 'Newsletter',
    userNewsletterSubscribeText: 'Ti invieremo le nostre novità, promozioni esclusive e i nostri libri preferiti.',
    userNewsletterUnSubscribeButton: 'Cancellami dalla newsletter',
    'userOrdersView': 'Vedi gli ordini di questo utente',
    'userCanCustomizeMessages': 'Può personalizzare i messaggi?',
    'userLogAsUser': 'Accedi come questo utente',
    'shippingMethodProviderData': 'Informazioni sul corriere',
    'productUseForCustomization': 'Utilizzare per la personalizzazione?',
    'conversationBookFormat': 'Formato del libro',
    'conversationMessageSelect': 'Seleziona questo messaggio',
    'conversationMessagesEditTitle': 'Il laboratorio: Personalizza i tuoi messaggi',
    'conversationMessageSelectorDateFrom': 'Seleziona i messaggi inviati dopo il',
    'conversationMessageSelectorDateTo': 'Seleziona i messaggi inviati prima del',
    'conversationTextSearch': 'Cerca una parola nella chat',
    'conversationOnlyMedias': 'Mostra solo foto/video',
    'conversationMessagesSelectVisible': 'Seleziona questa pagina',
    'conversationMessagesSelectAllFiltered': 'Seleziona tutto ({count, number})',
    'unselect': 'Deseleziona',
    'conversationMessagesEditHideSelected': 'Nascondi i messaggi selezionati dal libro',
    'conversationMessagesEditShowSelected': 'Mostra di nuovo i messaggi selezionati',
    'conversationMessagesEditTooManySelected': 'Hai selezionato troppi messaggi tutti in una volta!',
    'conversationNoMessages': 'Nessun messaggio',
    'conversationMessageEdit': 'Modifica il testo del messaggio',
    'conversationMessageAdd': 'Aggiungi un messaggio',
    'conversationMessageInsert': 'Inserisci un messaggio qui',
    'conversationMessageEditSelect': 'Seleziona questo messaggio',
    'conversationMessageEditUnselect': 'Deseleziona questo messaggio',
    'conversationMessageSetUnVisibleButton': 'Nascondi questo messaggio dal libro stampato',
    'conversationMessageHiddenAlert': 'Questo messaggio è stato nascosto e non apparirà nel tuo libro stampato.',
    'conversationMessageSetVisibleButton': 'Mostra di nuovo il messaggio',
    'conversationMessagesEditEnableButton': 'Attiva la personalizzazione dei messaggi',
    'conversationMessagesEditEnableButton2': 'Sblocca la personalizzazione per {price}',
    'conversationMessagesEditDisableAlert': 'Per poter modificare, nascondere o editare il contenuto esatto dei tuoi messaggi, devi attivare questa opzione premium (pagamento una tantum).',
    'conversationMessageDateHint': 'Modifica data e ora per posizionare questo messaggio dove vuoi nella conversazione.',
    'conversationMessageSender': 'Mittente',
    'conversationMessageSenderPlaceholder': 'Scegli il mittente',
    'conversationMessageSenderRequiredHint': 'Scegli chi invia questo messaggio per poterlo salvare.',
    'conversationMessageAnnotation': 'Annotazione',
    'conversationMessageAnnotationNoMedia': 'Un\'annotazione non può includere foto, video o audio.',
    'conversationMessageText': 'Testo',
    'conversationMessageTextPlaceholder': 'Scrivi il tuo testo',
    'conversationMessageAttachments': 'Allegati (Foto/Video)',
    'conversationMessageMediaLabel': 'Foto, video o audio',
    'conversationMessageMediaDragDrop': 'Trascina qui una foto, un video o un audio',
    'conversationMessageMediaTapSelect': 'Tocca per scegliere una foto, un video o un audio',
    'conversationMessageMediaOpenFinder': 'Scegli un file',
    'conversationMessageMediaPickSenderFirst': 'Scegli prima un mittente per aggiungere una foto, un video o un audio.',
    'conversationMessageHiddenLabel': 'Vuoi nascondere questo messaggio dal libro?',
    'conversationGenerate': 'Genera le anteprime dei libri',
    'conversationVerify': 'Forza la verifica',
    'conversationLaunchButton': 'Invia in stampa',
    'conversationViewButton': 'Vedi la mia chat',
    'reset': 'Ripristina',
    'cms': 'CMS',
    'cmsLinkColor': 'Colore del pulsante',
    'cmsLinkNeedObfuscate': 'Necessita di offuscamento?',
    'cmsImageUseForMobile': 'Utilizzato per la versione mobile?',
    'contentEditPage': 'Modifica la pagina',
    'cmsRedirectionAdd': 'Aggiungi un reindirizzamento',
    'cmsContentEdit': 'Modifica il contenuto',
    'cmsPageIsActive': 'Pagina attiva?',
    'cmsContentTypeLabel': 'Tipo di contenuto',
    'cmsContentModelLabel': 'Modello di design',
    'cmsContentTitle': 'Titolo della pagina',
    'cmsContentSlug': 'Slug (URL)',
    'cmsPanelIsTemplate': 'Incluso nel template globale?',
    'cmsPageSeoTitle': 'Titolo SEO (Google)',
    'cmsPageSeoDescription': 'Meta Descrizione SEO',
    'cmsPageSeoKeywords': 'Parole chiave SEO',
    'cmsPageSeoHideOnSitemap': 'Nascondi dai motori di ricerca (Sitemap)',
    'cmsPageSeoUseCustomTitleSuffix': 'Utilizza un suffisso per il titolo personalizzato',
    'cmsPageSeoTitleSuffix': 'Suffisso del titolo',
    'affiliation': 'Programma di affiliazione',
    'affiliationInvoiceTotalAdminTitle': 'Totale da pagare (IVA inclusa)',

    conversationImportLuxEyebrow: 'La tua storia',
    conversationImportLuxTagline: 'Un regalo unico, pensato da te: che nessun altro potrà offrire.',
    conversationImportLuxPrivacy: 'I tuoi messaggi restano privati: viene usata solo la conversazione che scegli.',
    conversationImportProgressExport: 'Esportare',
    conversationImportProgressUpload: 'Caricare',
    conversationImportProgressCustomize: 'Personalizzare',
    conversationImportUploadSuccess: 'Archivio ricevuto: scegli la conversazione al passo successivo',
    conversationImportUploadSuccessSingle: 'File ricevuto: continua per personalizzare il tuo libro',
    conversationImportContinueSingle: 'Continua',
    conversationImportSelectionTitleSingle: 'La tua conversazione',
    conversationImportSelectionHintSingle: 'Una sola conversazione trovata nel tuo file.',
    conversationImportSelectionHintMultiple: 'Scegli la conversazione per il tuo libro: usa la ricerca per filtrare l\'elenco.',
    conversationImportSelectionListCount: '{shown} di {total} conversazioni',
    conversationImportSelectionNoMatch: 'Nessuna conversazione corrisponde alla tua ricerca.',
    conversationImportStepPickThread: 'Scegli conversazione',
    conversationImportStepMedia: 'Opzioni foto',
    conversationImportStepTerms: 'Accetta condizioni',
    conversationImportExtrasLockedHint: 'Scegli una conversazione sopra per sbloccare queste opzioni.',
    conversationImportPickThreadBeforeTerms: 'Devi ancora scegliere una conversazione sopra prima di continuare.',
    conversationImportChangeThread: 'Cambia conversazione',
    conversationImportSelectionConfirmedHint: 'Perfetto: ora puoi personalizzare il tuo libro qui sotto.',

    conversationImportOptionsTitle: 'Foto e ricordi',
    conversationImportOptionsHint: 'Tutto è selezionato per impostazione predefinita: deseleziona solo ciò che non vuoi includere.',
    conversationImportOptionsImagesLabel: 'Foto e immagini',
    conversationImportOptionsImagesDesc: 'Le foto della tua conversazione saranno stampate nel libro.',
    conversationImportOptionsMediasLabel: 'Video, audio e GIF',
    conversationImportOptionsMediasDesc: 'Accessibili tramite codici QR stampati nel libro (archiviazione di 10 anni inclusa).',
    conversationImportOptionsTransferNote: 'Il trasferimento può richiedere alcuni minuti a seconda del numero di foto: resta su questa pagina.',
    conversationImportOptionsNoMedia: 'Il tuo file non contiene foto o media: il libro includerà solo i messaggi.',
    conversationImportAgreementRead: 'Consulta le condizioni generali di vendita',
    conversationImportCreateBook: 'Crea il mio libro',
    conversationImportSelectToContinue: 'Seleziona una conversazione per continuare.',
    conversationImportAcceptTermsToContinue: 'Spunta la casella delle condizioni generali per continuare.',
    conversationImportTransferEyebrow: 'Ci siamo quasi',
    conversationImportTransferTitle: 'Stiamo preparando il tuo libro',
    conversationImportTransferSubtitle: 'Un attimo di pazienza: la tua storia sta prendendo forma.',
    conversationImportTransferStay: 'Resta su questa pagina fino al completamento del trasferimento.',
    conversationImportStepMedias: 'Trasferimento video e audio',
    conversationImportTransferStatMessages: 'Messaggi',
    conversationImportTransferStatPhotos: 'Foto',
    conversationImportTransferStatMedias: 'Video e audio',
    conversationImportTransferEyebrow: 'Ci siamo quasi',
    conversationImportTransferTitle: 'Stiamo preparando il tuo libro',
    conversationImportTransferSubtitle: 'Un attimo di pazienza: la tua storia sta prendendo forma.',
    conversationImportTransferStay: 'Resta su questa pagina fino al completamento del trasferimento.',
    conversationImportResumeTitle: 'Un trasferimento precedente è stato interrotto.',
    conversationImportResumeTextFile: 'Riseleziona lo stesso file ({name}) per riprendere da dove si è interrotto.',
    conversationImportResumeText: 'Riseleziona lo stesso file per riprendere da dove si è interrotto.',
    conversationImportResumeButton: 'Riprendi il trasferimento',
    conversationImportResumeDiscard: 'Ricomincia',
    conversationImportDuplicateTitle: 'Questa conversazione è già sul tuo account',
    conversationImportDuplicateEyebrow: 'Conversazione identica',
    conversationImportDuplicateLead: 'Abbiamo trovato una conversazione identica. Puoi aprire quella già presente per evitare un trasferimento duplicato.',
    conversationImportDuplicateQuestion: 'Cosa vuoi fare?',
    conversationImportDuplicateUseExisting: 'Usa quella già presente',
    conversationImportDuplicateImportAnyway: 'Importa di nuovo',
    conversationImportDropHint: 'Carica il tuo file .zip qui, o',
    conversationImportDropFormats: '.zip completo consigliato: non aprirlo (foto e media inclusi)',
    conversationImportJsonOnlyHint: 'Solo file .json: foto e media non saranno inclusi. Per un libro illustrato, carica il .zip completo senza aprirlo. Se il browser ha già estratto l\'archivio, comprimi la cartella « messages » in .zip.',

    conversationInstagramImportIntro: 'Esporta i tuoi messaggi Instagram in 3 passaggi:',
    conversationInstagramImportDemoTitle: 'Esporta i messaggi Instagram',
    conversationInstagramImportDemoExportMeta: 'Esporta su dispositivo · JSON',
    conversationInstagramImportDemoDownloadsAvailable: 'Download disponibili',
    conversationInstagramImportDemoStartExport: 'Avvia esportazione',
    conversationInstagramImportDemoCustomizeMessages: 'Solo messaggi',
    conversationInstagramImportDemoCustomize: 'Personalizza informazioni',
    conversationInstagramImportDemoConfirmTitle: 'Conferma esportazione',
    conversationInstagramImportDemoSave: 'Salva',
    conversationInstagramImportDemoMessagesTip: 'Facoltativo ma più veloce: cancella tutto, poi solo Messaggi.',
    conversationInstagramImportDemoDataPayments: 'Pagamenti',
    conversationInstagramImportDemoDataComments: 'Commenti',
    conversationInstagramImportDemoClearAll: 'Cancella tutto',
    conversationInstagramImportDemoActivitySection: 'La tua attività su Instagram',
    conversationInstagramImportDemoPickSpecific: 'Scegli informazioni specifiche da esportare',
    conversationInstagramImportDemoExportExternal: 'Esporta su servizio esterno',
    conversationInstagramImportDemoExportDevice: 'Esporta sul dispositivo',
    conversationInstagramImportDemoChooseDestination: 'Scegli dove esportare',
    conversationInstagramImportDemoProfileAccount: 'Il tuo account · Instagram',
    conversationInstagramImportDemoProfileName: 'Il nome del tuo account',
    conversationInstagramImportDemoAccountShort: 'Il tuo account',
    conversationInstagramImportDemoProfiles: 'Profili',
    conversationInstagramImportDemoChooseProfile: 'Scegli un profilo',
    conversationInstagramImportDemoPastActivity: 'Attività passate',
    conversationInstagramImportDemoCurrentActivity: 'Attività in corso',
    conversationInstagramImportDemoCreateExport: 'Crea esportazione',
    conversationInstagramImportDemoExportIntro: 'Crea una copia delle tue informazioni da scaricare sul dispositivo.',
    conversationInstagramImportDemoExportTitle: 'Esporta le tue informazioni',
    conversationInstagramImportDemoCaptionStart: 'Tocca Avvia esportazione',
    conversationInstagramImportDemoCaptionDevice: 'Tocca Esporta sul dispositivo',
    conversationInstagramImportDemoCaptionProfile: 'Scegli il tuo profilo Instagram',
    conversationInstagramImportDemoCaptionCreate: 'Tocca Crea esportazione',
    conversationInstagramImportDemoCaptionMessages: 'Suggerimento: Cancella tutto, poi solo Messaggi (più veloce)',
    conversationInstagramImportDemoCaptionJson: 'Scegli formato JSON, poi Salva',
    conversationInstagramImportDemoCaptionDrop: 'Scarica il file .zip quando pronto, poi caricalo qui sotto',
    conversationInstagramImportDemoPlatform: 'Instagram',
    conversationInstagramImportDemoDataMessages: 'Messaggi',
    conversationInstagramImportDemoFormat: 'Formato',
    conversationInstagramImportDemoMediaQuality: 'Qualità media',
    conversationInstagramImportDemoQualityLow: 'Bassa',
    conversationInstagramImportDemoJsonNotice: 'JSON obbligatorio per il libro. HTML non funziona.',
    conversationInstagramImportDemoReadyHint: 'Carica il file .zip completo qui sotto senza aprirlo. Sceglierai la conversazione dopo.',
    conversationInstagramImportCta: 'Aprire le impostazioni Instagram',
    conversationInstagramImportStep1: 'Tocca <b>Crea esportazione</b>, scegli il profilo <b>Instagram</b>, poi <b>Esporta sul dispositivo</b>.',
    conversationInstagramImportStep2: 'Suggerimento per andare più veloce: <b>Cancella tutto</b>, seleziona solo <b>Messaggi</b>. Scegli formato <b>JSON</b> e qualità <b>Bassa</b>.',
    conversationInstagramImportStep3: 'Tocca <b>Avvia esportazione</b>, attendi l\'email (10 min - 24 h), scarica il file <b>.zip</b> e caricalo qui sotto <b>senza aprirlo</b>: sceglierai la conversazione <b>dopo</b>.',
    conversationInstagramImportAlert: 'Formato <b>JSON</b> obbligatorio (non HTML). Suggerimento: esportare solo <b>Messaggi</b> è più veloce, ma non obbligatorio.',
    conversationInstagramImportDetailTitle: 'Esportazione Instagram: guida dettagliata',
    conversationInstagramImportDetailIntro: 'Segui ogni passaggio con gli screenshot sotto. Il pulsante sopra apre direttamente la pagina di esportazione.',
    conversationInstagramImportDetailSkipApp: 'Ho aperto la pagina con il pulsante: vai al passaggio 5',
    conversationInstagramImportDetailStep1: 'Apri l\'app <b>Instagram</b>, poi accedi alle <b>Impostazioni</b> tramite i tre puntini in alto a destra.',
    conversationInstagramImportDetailStep2: 'Seleziona <b>Centro account</b>.',
    conversationInstagramImportDetailStep3: 'Tocca <b>Le tue informazioni e autorizzazioni</b>.',
    conversationInstagramImportDetailStep4: 'Scegli <b>Esporta le tue informazioni</b>.',
    conversationInstagramImportDetailStep5: 'Vai su <b>Scarica o trasferisci informazioni</b>. Se hai usato il pulsante sopra, sei già su questa pagina.',
    conversationInstagramImportDetailStep6: 'Seleziona <b>Instagram</b>. Questo passaggio potrebbe non apparire su alcuni account.',
    conversationInstagramImportDetailStep7: 'Scegli <b>Alcune delle tue informazioni</b>.',
    conversationInstagramImportDetailStep8: 'Scorri fino a <b>Messaggi</b>, selezionalo e tocca <b>Avanti</b>.',
    conversationInstagramImportDetailStep9: 'Tocca <b>Scarica sul dispositivo</b>.',
    conversationInstagramImportDetailStep10: 'Scegli il periodo desiderato, il formato <b>JSON</b> e una qualità multimediale <b>bassa</b> per un download più rapido.',
    conversationInstagramImportDetailStep11: 'Il tuo archivio sarà pronto entro <b>10 minuti – 24 ore</b>. Riceverai un\'email quando sarà disponibile: puoi anche trovarlo nella pagina del Centro account.',
    conversationInstagramImportDetailStep12: 'Scarica il file <b>.zip</b> completo sul dispositivo e caricalo qui sotto <b>senza aprirlo</b>. Solo la conversazione che sceglierai dopo verrà usata per il tuo libro.',

    conversationKakaotalkImportIntro: 'Si comincia dal telefono. Sei su iPhone o Android?',
    conversationKakaotalkImportPlatformIphone: 'iPhone',
    conversationKakaotalkImportPlatformAndroid: 'Android',
    conversationKakaotalkImportIphoneStep1: 'Sul tuo iPhone, apri <b>KakaoTalk</b> e la conversazione che vuoi nel libro.',
    conversationKakaotalkImportIphoneStep2: 'Tocca il <b>menu</b> (☰) in alto a destra, poi l\'icona <b>impostazioni</b> in fondo al pannello.',
    conversationKakaotalkImportIphoneStep3: 'Tocca <b>Esporta la conversazione</b> e scegli <b>Invia solo i messaggi di testo</b>.',
    conversationKakaotalkImportIphoneStep4: 'Salva il file <b>.txt</b> (File, email, AirDrop), poi caricalo qui sotto <b>senza modificarlo</b>.',
    conversationKakaotalkImportAndroidStep1: 'Sul tuo telefono, apri <b>KakaoTalk</b> e la conversazione che vuoi nel libro.',
    conversationKakaotalkImportAndroidStep2: 'Tocca il <b>menu</b> (☰) in alto a destra, poi l\'icona <b>impostazioni</b> in fondo al pannello.',
    conversationKakaotalkImportAndroidStep3: 'Tocca <b>Esporta la conversazione</b> e scegli <b>Invia solo il testo</b>.',
    conversationKakaotalkImportAndroidStep4: 'Salva il file <b>.txt</b> (File, Google Drive, email), poi caricalo qui sotto <b>senza modificarlo</b>.',
    conversationKakaotalkImportAlert: 'Una conversazione per esportazione. L\'altra opzione salva anche le tue foto, ma KakaoTalk non le collega ai messaggi: scegli solo il testo, le foto appariranno come una semplice parola.',
    conversationKakaotalkImportDesktopNote: 'Sul computer (Windows o Mac): apri il menu della conversazione, poi <b>Salva la conversazione</b>. Il file <b>.txt</b> ottenuto funziona anche qui.',
    conversationLineImportIntro: 'Si comincia dal telefono. Sei su iPhone o Android?',
    conversationLineImportPlatformIphone: 'iPhone',
    conversationLineImportPlatformAndroid: 'Android',
    conversationLineImportIphoneStep1: 'Sul tuo iPhone, apri <b>LINE</b> e la conversazione che vuoi nel libro.',
    conversationLineImportIphoneStep2: 'In alto nella chat, tocca il <b>menu</b> (☰) → <b>Impostazioni</b>.',
    conversationLineImportIphoneStep3: 'Tocca <b>Esporta cronologia chat</b> e scegli come inviare il file (File, email, AirDrop).',
    conversationLineImportIphoneStep4: 'Salva il file <b>.txt</b>, poi caricalo qui sotto <b>senza modificarlo</b>.',
    conversationLineImportAndroidStep1: 'Sul tuo telefono, apri <b>LINE</b> e la conversazione che vuoi nel libro.',
    conversationLineImportAndroidStep2: 'In alto nella chat, tocca il <b>menu</b> (☰) → <b>Impostazioni</b>.',
    conversationLineImportAndroidStep3: 'Tocca <b>Esporta cronologia chat</b> e scegli come inviare il file (File, Google Drive, email).',
    conversationLineImportAndroidStep4: 'Salva il file <b>.txt</b>, poi caricalo qui sotto <b>senza modificarlo</b>.',
    conversationLineImportAlert: 'Una conversazione per esportazione. Vengono salvati solo i messaggi attualmente visibili nella chat e LINE non esporta foto o sticker come immagini.',
    conversationLineImportDesktopNote: 'Sul computer (Windows o Mac): apri <b>Chat</b>, fai doppio clic sulla conversazione, poi usa il <b>menu</b> in alto → <b>Salva chat</b>. Questa esportazione non esiste su LINE per Chrome.',

    conversationLinkedinImportIntro: '3 passaggi per esportare le tue conversazioni LinkedIn:',
    conversationLinkedinImportCta: 'Apri la pagina di esportazione LinkedIn',
    conversationLinkedinImportStep1: 'Da un <b>browser web</b> (computer o telefono), apri la pagina qui sopra. Altrimenti: <b>Tu</b> → <b>Impostazioni e privacy</b> → <b>Privacy dei dati</b> → <b>Ottieni una copia dei tuoi dati</b>.',
    conversationLinkedinImportStep2: 'Richiedi un archivio che contenga i tuoi <b>Messaggi</b>: seleziona il file <b>Messaggi</b>, oppure scegli l\'archivio completo, poi clicca su <b>Richiedi archivio</b>.',
    conversationLinkedinImportStep3: 'Scarica il <b>.zip</b> dall\'email di LinkedIn (da 10 min a 24 h), poi caricalo qui sotto <b>senza aprirlo</b>: sceglierai la conversazione <b>dopo</b> il caricamento.',
    conversationLinkedinImportAlert: 'Questa esportazione non esiste nell\'app mobile LinkedIn: usa un browser. L\'archivio deve contenere il file <b>messages.csv</b> (LinkedIn non esporta né foto né allegati).',

    conversationSnapchatImportIntro: '3 passaggi per esportare le tue conversazioni Snapchat:',
    conversationSnapchatImportCta: 'Apri I miei dati Snapchat',
    conversationSnapchatImportStep1: 'Nell\'app: avatar → impostazioni (ingranaggio) → <b>Privacy</b> → <b>I miei dati</b>. Puoi anche usare il link sopra.',
    conversationSnapchatImportStep2: 'Accedi se richiesto, poi tocca <b>Invia una richiesta</b> in fondo: Snapchat ti invierà un\'email quando l\'archivio è pronto (da qualche ora a 1 giorno).',
    conversationSnapchatImportStep3: 'Scarica il <b>.zip</b> dall\'email, poi caricalo qui sotto <b>senza aprirlo</b>: sceglierai la conversazione <b>dopo</b> il caricamento.',
    conversationSnapchatImportAlert: 'Archivio <b>.zip</b> completo obbligatorio: non aprirlo. I tuoi messaggi saranno stampati nel libro (l\'export Snapchat non include foto stampabili).',
    conversationSnapchatPlaceholderMedia: '[Media]',
    conversationSnapchatPlaceholderNote: '[Nota vocale]',
    conversationSnapchatPlaceholderSticker: '[Sticker]',
    conversationSnapchatPlaceholderSnap: '[Snap]',
    conversationSnapchatPlaceholderAudio: '[Audio]',
    conversationSnapchatStatusParticipantAdded: 'Un membro è stato aggiunto al gruppo',
    conversationSnapchatStatusNameChanged: 'Il nome del gruppo è cambiato',
    conversationSnapchatStatusConversationCreated: 'Conversazione creata',
    conversationSnapchatStatusGeneric: 'Notifica Snapchat',
    conversationSnapchatImportPartialContent: '{withText} messaggi con testo su {total}. Snapchat non esporta il contenuto dei messaggi non salvati.',
    conversationSnapchatImportDetailTitle: 'Export Snapchat: guida dettagliata',
    conversationSnapchatImportDetailIntro: 'Segui ogni passaggio con gli screenshot qui sotto. Puoi anche usare il pulsante sopra per aprire I miei dati direttamente e passare al passo 4.',
    conversationSnapchatImportDetailSkipApp: 'Ho aperto la pagina con il pulsante: vai al passaggio 4',
    conversationSnapchatImportDetailStep1: 'Apri <b>Snapchat</b> e tocca la tua foto profilo.',
    conversationSnapchatImportDetailStep2: 'Tocca l\'icona <b>ingranaggio</b> per aprire le impostazioni.',
    conversationSnapchatImportDetailStep3: 'Scorri fino a <b>Azioni sull\'account</b>, poi tocca <b>I miei dati</b>. Puoi anche usare il pulsante sopra.',
    conversationSnapchatImportDetailStep4: 'Seleziona <b>Cronologia chat</b>, scegli i formati <b>JSON</b> e <b>HTML</b>, poi tocca <b>Avanti</b>.',
    conversationSnapchatImportDetailStep5: 'Scegli il periodo desiderato, conferma il tuo indirizzo email e tocca <b>Invia</b>.',
    conversationSnapchatImportDetailStep6: 'Snapchat ti invierà un\'email quando l\'export sarà pronto: possono servire da qualche ora a diversi giorni.',
    conversationSnapchatImportDetailStep7: 'Quando ricevi l\'email, clicca sul link per accedere ai tuoi dati.',
    conversationSnapchatImportDetailStep8: 'Su Snapchat, tocca <b>Visualizza export</b>, poi <b>Scarica</b>.',
    conversationSnapchatImportDetailStep9: 'Scarica il file <b>.zip</b> completo sul dispositivo e caricalo qui sotto <b>senza aprirlo</b>. Solo la conversazione che sceglierai dopo verrà usata per il tuo libro.',

    conversationTelegramImportIntro: '4 passaggi per esportare una conversazione Telegram:',
    conversationTelegramImportCta: 'Scarica Telegram Desktop',
    conversationTelegramImportStep1: 'Su PC, installa <b>Telegram Desktop</b>. Su Mac, non usare l\'app « Telegram » dell\'App Store: scarica <b>Telegram Desktop</b> dal link sopra (sull\'App Store si chiama Telegram Lite). Poi apri la conversazione da trasformare in libro.',
    conversationTelegramImportStep2: 'Clicca sui <b>tre puntini</b> in alto a destra → <b>Esporta cronologia chat</b>.',
    conversationTelegramImportStep3: 'Seleziona <b>foto, video e file</b>, scegli il formato <b>JSON</b> (va bene anche l\'HTML), poi clicca <b>Esporta</b> e attendi il completamento del download.',
    conversationTelegramImportStep4: 'Comprimi la cartella esportata in <b>.zip</b> (tasto destro → comprimi), poi caricala qui sotto <b>senza aprirla</b>: confermerai le opzioni <b>dopo</b> il caricamento.',
    conversationTelegramImportAlert: 'Una conversazione alla volta. Includi i <b>media</b> nell\'export per un libro illustrato: carica il <b>.zip</b> completo così com\'è.',
    conversationTelegramImportDetailTitle: 'Export Telegram: guida dettagliata',
    conversationTelegramImportDetailIntro: 'Segui ogni passaggio con gli screenshot qui sotto. Usa il pulsante sopra per scaricare Telegram Desktop, oppure passa al passo 2 se è già installato.',
    conversationTelegramImportDetailSkipApp: 'Ho già Telegram Desktop: vai al passaggio 2',
    conversationTelegramImportDetailStep1: 'Su PC, <b>Telegram Desktop</b> è l\'app giusta. Su Mac, scarica <b>Telegram Desktop</b> dal link sopra: l\'app « Telegram » dell\'App Store non esporta le chat. Sull\'App Store, il programma giusto si chiama <b>Telegram Lite</b>.',
    conversationTelegramImportDetailStep2: 'Apri la <b>conversazione</b> che vuoi trasformare in libro.',
    conversationTelegramImportDetailStep3: 'Clicca sui <b>tre puntini</b> in alto a destra, poi su <b>Esporta cronologia chat</b>.',
    conversationTelegramImportDetailStep4: 'Seleziona <b>tutti i tipi di file</b> (foto, video, messaggi vocali, ecc.), imposta la dimensione massima a <b>1500 MB</b> e scegli il formato <b>JSON</b>. Se non compare la scelta del formato, funziona anche l\'HTML.',
    conversationTelegramImportDetailStep5: 'Clicca su <b>Esporta</b> in basso a destra per avviare l\'export.',
    conversationTelegramImportDetailStep6: 'Sul telefono, tocca <b>Consenti</b> se richiesto. Comprimi la cartella esportata in <b>.zip</b> e caricala qui sotto <b>senza aprirla</b>: confermerai le opzioni dopo il caricamento.',

    conversationImportDetectedPlatform: 'Questi passaggi sono per {platform}. Le altre scelte restano disponibili.',
    conversationWhatsappImportIntro: 'Si comincia dal telefono. Sei su iPhone o Android?',
    conversationWhatsappImportPlatformIphone: 'iPhone',
    conversationWhatsappImportPlatformAndroid: 'Android',
    conversationWhatsappImportIphoneStep1: 'Apri la chat, tocca il <b>nome in alto</b>, poi <b>Esporta chat</b>.',
    conversationWhatsappImportIphoneStep2: 'Scegli <b>Allega file</b> per le foto nel libro (o <b>Senza file</b> solo testo).',
    conversationWhatsappImportIphoneStep3: 'Salva in <b>File</b>, poi carica il file <b>.zip</b> qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportIphoneStep4: '<b>Allega media</b> per le foto nel libro, <b>senza media</b> solo messaggi: salva il file su computer o telefono e caricalo qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportAndroidStep1: 'Apri la chat, tocca <b>⋮</b> → <b>Altro</b> → <b>Esporta chat</b>.',
    conversationWhatsappImportAndroidStep2: 'Scegli <b>Includi media</b> per le foto nel libro (o <b>Senza media</b> solo testo).',
    conversationWhatsappImportAndroidStep3: 'Salva o condividi il file, poi carica il file <b>.zip</b> qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportAndroidStep4: 'Salva il file (File, Google Drive o email), portalo su computer o telefono e caricalo qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportAlert: 'Una chat per export. Preferisci <b>Allega file</b> per un libro illustrato. Resta su questa pagina fino alla fine.',
    conversationWhatsappImportAlertAndroid: 'Una chat per export. Preferisci <b>Includi media</b>. Su alcuni telefoni funziona solo l\'email: usa allora <b>Senza media</b>. Resta su questa pagina fino alla fine.',
    conversationWhatsappImportIphoneDetailTitle: 'Export WhatsApp su iPhone: guida dettagliata',
    conversationWhatsappImportIphoneDetailIntro: 'Segui ogni passaggio sul tuo iPhone con gli screenshot qui sotto, poi trasferisci il file su computer o telefono prima di caricarlo qui.',
    conversationWhatsappImportIphoneDetailStep1: 'Apri <b>WhatsApp</b> e la conversazione che vuoi trasformare in libro.',
    conversationWhatsappImportIphoneDetailStep2: 'Tocca il <b>nome del contatto</b> o del gruppo in alto.',
    conversationWhatsappImportIphoneDetailStep3: 'Scorri fino in fondo alla pagina fino a <b>Esporta chat</b>.',
    conversationWhatsappImportIphoneDetailStep4: 'Tocca <b>Esporta chat</b>.',
    conversationWhatsappImportIphoneDetailStep5: 'Scegli <b>Allega media</b> per un libro illustrato, o <b>Senza media</b> solo per i messaggi.',
    conversationWhatsappImportIphoneDetailStep6: 'Salva il file su computer o telefono (es. in File), poi caricalo qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportAndroidDetailTitle: 'Export WhatsApp su Android: guida dettagliata',
    conversationWhatsappImportAndroidDetailIntro: 'Segui ogni passaggio sul tuo Android con gli screenshot qui sotto, poi trasferisci il file su computer o telefono prima di caricarlo qui.',
    conversationWhatsappImportAndroidDetailStep1: 'Apri <b>WhatsApp</b> e la conversazione da trasformare in libro.',
    conversationWhatsappImportAndroidDetailStep2: 'Tocca <b>⋮</b> (in alto a destra) → <b>Altro</b> → <b>Esporta chat</b>.',
    conversationWhatsappImportAndroidDetailStep3: 'Scegli <b>Includi media</b> per le foto, o <b>Senza media</b> solo per i messaggi.',
    conversationWhatsappImportAndroidDetailStep4: 'Salva il file (File, Google Drive o email), portalo su computer o telefono e caricalo qui sotto <b>senza aprirlo</b>.',
    conversationWhatsappImportDemoTitle: 'Esporta la conversazione WhatsApp',
    conversationWhatsappImportDemoIndividual: 'Chat individuale',
    conversationWhatsappImportDemoGroup: 'Chat di gruppo',
    conversationWhatsappImportDemoCaptionOpen: 'Apri la chat in WhatsApp',
    conversationWhatsappImportDemoCaptionTapName: 'Tocca il nome in alto',
    conversationWhatsappImportDemoCaptionExport: 'Scorri e tocca Esporta chat',
    conversationWhatsappImportDemoCaptionMedia: 'Scegli Allega file per le foto nel libro',
    conversationWhatsappImportDemoCaptionSave: 'Salva in File e caricalo qui sotto',
    conversationWhatsappImportDemoExportLabel: 'Esporta chat',
    conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
    conversationWhatsappImportDemoAttachMedia: 'Allega file',
    conversationWhatsappImportDemoWithoutMedia: 'Senza file',
    conversationWhatsappImportDemoSaveFiles: 'Salva in File',
    conversationWhatsappImportDemoA11y: 'Guida animata: apri la chat, tocca il nome, esporta, scegli Allega file, poi salva in File.',
    conversationWhatsappImportDemoCaptionExportGroup: 'Apri il menu ⋯ e tocca Esporta chat',
    conversationWhatsappImportDemoContactName: 'Léa',
    conversationWhatsappImportDemoContactMom: 'Mamma',
    conversationWhatsappImportDemoGroupName: 'Weekend amici',
    conversationWhatsappImportDemoGroupWork: 'Work: design',
    conversationWhatsappImportDemoChats: 'Chat',
    conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
    conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
    conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
    conversationWhatsappImportDemoSeeAll: 'See all ›',
    conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
    conversationWhatsappImportDemoAddList: 'Add to a list',
    conversationWhatsappImportDemoClearChat: 'Svuota chat',
    conversationWhatsappImportDemoBlock: 'Block',
    conversationWhatsappImportDemoParticipants: '{count} participants',
    conversationWhatsappImportDemoAudio: 'Audio',
    conversationWhatsappImportDemoVideo: 'Video',
    conversationWhatsappImportDemoAdd: 'Add',
    conversationWhatsappImportDemoSearch: 'Search',
    conversationWhatsappImportDemoMemberYou: 'You',
    conversationWhatsappImportDemoMemberAlex: 'Alex',
    conversationWhatsappImportDemoMemberCamille: 'Camille',
    conversationWhatsappImportDemoEditGroup: 'Edit group info',
    conversationWhatsappImportDemoEditDescription: 'Edit description',
    conversationWhatsappImportAndroidDemoIncludeMedia: 'Includi media',
    conversationWhatsappImportAndroidDemoWithoutMedia: 'Senza media',
    conversationWhatsappImportAndroidDemoMediaNotice: 'Includi media per un libro illustrato. Senza media è più leggero.',
    conversationWhatsappImportAndroidDemoClear: 'Svuota chat',
    conversationWhatsappImportAndroidDemoExport: 'Esporta chat',
    conversationWhatsappImportAndroidDemoReport: 'Segnala',
    conversationWhatsappImportAndroidDemoMore: 'Altro',
    conversationWhatsappImportAndroidDemoWallpaper: 'Sfondo',
    conversationWhatsappImportAndroidDemoMute: 'Silenzia notifiche',
    conversationWhatsappImportAndroidDemoOnline: 'online',
    conversationWhatsappImportAndroidDemoCaptionSave: 'Salva o condividi il file, poi caricalo qui sotto',
    conversationWhatsappImportAndroidDemoCaptionMedia: 'Scegli Includi media per le foto nel libro',
    conversationWhatsappImportAndroidDemoCaptionExport: 'Tocca Altro, poi Esporta chat',
    conversationWhatsappImportAndroidDemoCaptionMenu: 'Tocca il menu in alto a destra',
    conversationWhatsappImportAndroidDemoCaptionOpen: 'Apri la chat in WhatsApp',
    conversationWhatsappImportAndroidDemoTitle: 'Esporta la conversazione WhatsApp su Android',
    conversationWhatsappImportAndroidDemoShareHint: 'Poi carica il file .zip qui sotto senza aprirlo.',
    conversationWhatsappImportAndroidDemoFiles: 'File',
    conversationWhatsappImportAndroidDemoShareVia: 'Invia a…',

    conversationMessengerImportIntro: 'Inizia da <b>Dopo il 2023</b>: chat cifrate, su Messenger.com. Passa a <b>Prima del 2023</b> se la tua non c\'è.',
    conversationMessengerImportContext: 'Una chat iniziata prima del 2023 può continuare dopo l\'attivazione della crittografia. Messenger la divide allora in due archivi. Importali entrambi, poi uniscili dalla lista delle conversazioni.',
    conversationMessengerImportPlatformClassic: 'Prima del 2023',
    conversationMessengerImportPlatformEncrypted: 'Dopo il 2023',
    conversationMessengerImportClassicCta: 'Apri Meta per esportare',
    conversationMessengerClassicImportDemoReadyHint: 'Carica il file .zip completo qui sotto senza aprirlo. Sceglierai la conversazione dopo.',
    conversationMessengerClassicImportDemoExportMeta: 'Esporta su dispositivo · JSON',
    conversationMessengerClassicImportDemoDownloadsAvailable: 'Download disponibili',
    conversationMessengerClassicImportDemoStartExport: 'Avvia esportazione',
    conversationMessengerClassicImportDemoQualityLow: 'Bassa',
    conversationMessengerClassicImportDemoMediaQuality: 'Qualità media',
    conversationMessengerClassicImportDemoCustomizeMessages: 'Solo messaggi',
    conversationMessengerClassicImportDemoCustomize: 'Personalizza informazioni',
    conversationMessengerClassicImportDemoConfirmTitle: 'Conferma esportazione',
    conversationMessengerClassicImportDemoJsonNotice: 'JSON obbligatorio per il libro. HTML non funziona.',
    conversationMessengerClassicImportDemoFormat: 'Formato',
    conversationMessengerClassicImportDemoSave: 'Salva',
    conversationMessengerClassicImportDemoMessagesTip: 'Facoltativo ma più veloce: cancella tutto, poi solo Messaggi.',
    conversationMessengerClassicImportDemoDataMessages: 'Messaggi',
    conversationMessengerClassicImportDemoDataPayments: 'Pagamenti',
    conversationMessengerClassicImportDemoDataComments: 'Commenti',
    conversationMessengerClassicImportDemoClearAll: 'Cancella tutto',
    conversationMessengerClassicImportDemoPickSpecific: 'Scegli informazioni specifiche da esportare',
    conversationMessengerClassicImportDemoExportExternal: 'Esporta su servizio esterno',
    conversationMessengerClassicImportDemoExportDevice: 'Esporta sul dispositivo',
    conversationMessengerClassicImportDemoChooseDestination: 'Scegli dove esportare',
    conversationMessengerClassicImportDemoAccountShort: 'Il tuo account',
    conversationMessengerClassicImportDemoProfileName: 'Il nome del tuo account',
    conversationMessengerClassicImportDemoProfiles: 'Profili',
    conversationMessengerClassicImportDemoChooseProfile: 'Scegli un profilo',
    conversationMessengerClassicImportDemoPastActivity: 'Attività passate',
    conversationMessengerClassicImportDemoCurrentActivity: 'Attività in corso',
    conversationMessengerClassicImportDemoCreateExport: 'Crea esportazione',
    conversationMessengerClassicImportDemoExportIntro: 'Crea una copia delle tue informazioni da scaricare sul dispositivo.',
    conversationMessengerClassicImportDemoExportTitle: 'Esporta le tue informazioni',
    conversationMessengerClassicImportDemoCaptionDrop: 'Scarica il file .zip quando pronto, poi caricalo qui sotto',
    conversationMessengerClassicImportDemoCaptionStart: 'Tocca Avvia esportazione',
    conversationMessengerClassicImportDemoCaptionJson: 'Scegli formato JSON, poi Salva',
    conversationMessengerClassicImportDemoCaptionMessages: 'Suggerimento: Cancella tutto, poi solo Messaggi (più veloce)',
    conversationMessengerClassicImportDemoCaptionDevice: 'Tocca Esporta sul dispositivo',
    conversationMessengerClassicImportDemoCaptionCreate: 'Tocca Crea esportazione',
    conversationMessengerClassicImportDemoActivitySection: 'La tua attività su Facebook',
    conversationMessengerClassicImportDemoProfileAccount: 'Il tuo account · Facebook',
    conversationMessengerClassicImportDemoPlatform: 'Facebook',
    conversationMessengerClassicImportDemoCaptionProfile: 'Scegli il tuo profilo Facebook',
    conversationMessengerClassicImportDemoTitle: 'Esporta le conversazioni Messenger di prima del 2023',
    conversationMessengerEncryptedImportDemoTitle: 'Esporta le conversazioni Messenger di dopo il 2023',
    conversationImportDemoBadgeMeta: 'Esempio: fallo su Meta, con il pulsante sopra',
    conversationMessengerEncryptedImportDemoBadge: 'Esempio: fallo su Messenger.com, con il pulsante sopra',
    conversationMessengerEncryptedImportDemoCaptionLogin: 'Su computer, apri Messenger.com e accedi',
    conversationMessengerEncryptedImportDemoCaptionSettings: 'Clicca sull’ingranaggio in basso a sinistra',
    conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Apri Privacy e sicurezza',
    conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Scegli Chat crittografate end-to-end',
    conversationMessengerEncryptedImportDemoCaptionStorage: 'Apri Archivio dei messaggi',
    conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Clicca su Scarica i dati dell’archivio dei messaggi',
    conversationMessengerEncryptedImportDemoCaptionRange: 'Lascia Media selezionato, poi scegli il periodo All time',
    conversationMessengerEncryptedImportDemoCaptionDrop: 'Clicca su Scarica il file, poi rilascia il file .zip qui sotto',
    conversationMessengerEncryptedImportDemoLandingTitle: 'Uno spazio per conversazioni interessanti',
    conversationMessengerEncryptedImportDemoLandingText: 'Messenger ti permette di restare in contatto con le persone a cui tieni.',
    conversationMessengerEncryptedImportDemoContinueAs: 'Continua come Il tuo nome',
    conversationMessengerEncryptedImportDemoSwitchAccount: 'Cambia account',
    conversationMessengerEncryptedImportDemoChats: 'Chat',
    conversationMessengerEncryptedImportDemoSearch: 'Cerca su Messenger',
    conversationMessengerEncryptedImportDemoContactName: 'Il tuo contatto',
    conversationMessengerEncryptedImportDemoContactStatus: 'Attivo ora',
    conversationMessengerEncryptedImportDemoLockBadge: 'Crittografato end-to-end',
    conversationMessengerEncryptedImportDemoMenuPreferences: 'Preferenze',
    conversationMessengerEncryptedImportDemoMenuProfileName: 'Modifica il nome del profilo',
    conversationMessengerEncryptedImportDemoMenuRestricted: 'Account con restrizioni',
    conversationMessengerEncryptedImportDemoMenuAccessibility: 'Accessibilità',
    conversationMessengerEncryptedImportDemoMenuHelp: 'Aiuto',
    conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privacy e sicurezza',
    conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Conferme di lettura',
    conversationMessengerEncryptedImportDemoPrivacyReported: 'Chat segnalate',
    conversationMessengerEncryptedImportDemoPrivacyKeys: 'Verifica le chiavi nella chat',
    conversationMessengerEncryptedImportDemoEncryptedTitle: 'Chat crittografate end-to-end',
    conversationMessengerEncryptedImportDemoEncryptedHint: 'Gestisci le impostazioni delle tue chat crittografate end-to-end',
    conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Avvisi di sicurezza',
    conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Anteprime',
    conversationMessengerEncryptedImportDemoStorageTitle: 'Archivio dei messaggi',
    conversationMessengerEncryptedImportDemoStorageHint: 'Gestisci come archivi e accedi alla cronologia delle tue chat',
    conversationMessengerEncryptedImportDemoStorageIntro: 'I tuoi messaggi crittografati end-to-end sono archiviati in modo sicuro nel tuo backup.',
    conversationMessengerEncryptedImportDemoStoragePin: 'Reimposta il codice PIN',
    conversationMessengerEncryptedImportDemoStorageMethods: 'Gestisci i metodi di sicurezza',
    conversationMessengerEncryptedImportDemoStorageRemember: 'Ricorda questo browser',
    conversationMessengerEncryptedImportDemoStorageDownload: 'Scarica i dati dell’archivio dei messaggi',
    conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Scarica tutti i tuoi messaggi e allegati crittografati end-to-end.',
    conversationMessengerEncryptedImportDemoStorageAutoImport: 'Disattiva le importazioni automatiche',
    conversationMessengerEncryptedImportDemoDownloadTitle: 'Scarica i tuoi dati',
    conversationMessengerEncryptedImportDemoDownloadIntro: 'Puoi scaricare in qualsiasi momento una copia di tutti i tuoi messaggi e allegati crittografati end-to-end.',
    conversationMessengerEncryptedImportDemoMediaTip: 'Lascia Media selezionato, altrimenti il tuo libro non avrà nessuna foto.',
    conversationMessengerEncryptedImportDemoFileNotice: 'La preparazione del file può richiedere alcuni minuti.',
    conversationMessengerEncryptedImportDemoDownloadFile: 'Scarica il file',
    conversationMessengerEncryptedImportDemoReadyHint: 'Rilascia il file .zip completo qui sotto senza aprirlo. Sceglierai la conversazione dopo.',
    conversationMessengerImportEncryptedCta: 'Apri Messenger.com per esportare',
    conversationMessengerImportClassicStep1: 'Tocca <b>Crea esportazione</b>, scegli il profilo <b>Facebook</b>, poi <b>Esporta sul dispositivo</b>.',
    conversationMessengerImportClassicStep2: 'Suggerimento per andare più veloce: <b>Cancella tutto</b>, seleziona solo <b>Messaggi</b>. Scegli formato <b>JSON</b> e qualità <b>Bassa</b>.',
    conversationMessengerImportClassicStep3: 'Tocca <b>Avvia esportazione</b>, attendi l\'email (10 min - 24 h), scarica il file <b>.zip</b> e caricalo qui sotto <b>senza aprirlo</b>: sceglierai la conversazione <b>dopo</b>.',
    conversationMessengerImportClassicAlert: 'Conversazione assente? Passa a <b>Dopo il 2023</b>. Formato <b>JSON</b> obbligatorio (non HTML). Suggerimento: esportare solo <b>Messaggi</b> è più veloce, ma non obbligatorio.',
    conversationMessengerImportEncryptedStep1: 'Su computer, apri <b>Messenger.com</b>, accedi, poi clicca sull’<b>ingranaggio</b> in basso a sinistra.',
    conversationMessengerImportEncryptedStep2: 'Vai su <b>Privacy e sicurezza</b>, poi <b>Chat crittografate end-to-end</b>, poi <b>Archivio dei messaggi</b>.',
    conversationMessengerImportEncryptedStep3: 'Clicca su <b>Scarica i dati dell’archivio dei messaggi</b>. Lascia <b>Media</b> selezionato e scegli il periodo <b>All time</b>.',
    conversationMessengerImportEncryptedStep4: 'Clicca su <b>Scarica il file</b>, poi rilascia il file <b>.zip</b> qui sotto <b>senza aprirlo</b>: sceglierai la conversazione <b>dopo</b> il caricamento.',
    conversationMessengerImportEncryptedAlert: 'Lascia <b>Media</b> selezionato, altrimenti il tuo libro non avrà nessuna foto. Conversazione assente? Passa a <b>Prima del 2023</b>.',
    conversationMessengerImportClassicDetailTitle: 'Export prima del 2023: guida dettagliata',
    conversationMessengerImportClassicDetailIntro: 'Segui ogni passaggio con gli screenshot sotto. Il pulsante sopra apre direttamente la pagina di esportazione.',
    conversationMessengerImportClassicDetailSkipApp: 'Ho aperto la pagina con il pulsante: vai al passaggio 5',
    conversationMessengerImportClassicDetailStep1: 'Apri l\'app <b>Messenger</b>, poi accedi alle <b>Impostazioni</b> tramite i tre puntini.',
    conversationMessengerImportClassicDetailStep2: 'Tocca l\'icona <b>ingranaggio</b>.',
    conversationMessengerImportClassicDetailStep3: 'Seleziona <b>Centro account</b>.',
    conversationMessengerImportClassicDetailStep4: 'Tocca <b>Le tue informazioni e autorizzazioni</b>.',
    conversationMessengerImportClassicDetailStep5: 'Scegli <b>Scarica le tue informazioni</b>.',
    conversationMessengerImportClassicDetailStep6: 'Vai su <b>Scarica o trasferisci informazioni</b>. Se hai usato il pulsante sopra, sei già su questa pagina.',
    conversationMessengerImportClassicDetailStep7: 'Seleziona <b>Facebook</b>. Questo passaggio potrebbe non apparire su alcuni account.',
    conversationMessengerImportClassicDetailStep8: 'Scegli <b>Alcune delle tue informazioni</b>.',
    conversationMessengerImportClassicDetailStep9: 'Seleziona solo <b>Messaggi</b>, poi tocca <b>Avanti</b>.',
    conversationMessengerImportClassicDetailStep10: 'Tocca <b>Scarica sul dispositivo</b>.',
    conversationMessengerImportClassicDetailStep11: 'Scegli il periodo desiderato, il formato <b>JSON</b> e una qualità <b>bassa</b>. Il tuo archivio sarà pronto entro <b>10 minuti – 24 ore</b>: riceverai un\'email.',
    conversationMessengerImportClassicDetailStep12: 'Scarica il file <b>.zip</b> completo sul dispositivo e caricalo qui sotto <b>senza aprirlo</b>. Solo la conversazione che sceglierai dopo verrà usata per il tuo libro.',
    conversationMessengerImportEncryptedDetailTitle: 'Export dopo il 2023: guida dettagliata',
    conversationMessengerImportEncryptedDetailIntro: 'Segui ogni passaggio con gli screenshot qui sotto. Puoi anche usare il pulsante sopra per aprire Messenger.com e passare al passo 2.',
    conversationMessengerImportEncryptedDetailSkipApp: 'Sono già su Messenger.com: vai al passaggio 2',
    conversationMessengerImportEncryptedDetailStep1: 'Su computer, apri <b>Messenger.com</b> e clicca sulla tua foto profilo in basso a sinistra.',
    conversationMessengerImportEncryptedDetailStep2: 'Clicca su <b>Privacy e sicurezza</b>.',
    conversationMessengerImportEncryptedDetailStep3: 'Clicca su <b>Chat con crittografia end-to-end</b>.',
    conversationMessengerImportEncryptedDetailStep4: 'Clicca su <b>Archiviazione sicura</b>.',
    conversationMessengerImportEncryptedDetailStep5: 'Clicca su <b>Scarica dati dall\'archiviazione sicura</b>.',
    conversationMessengerImportEncryptedDetailStep6: 'Clicca su <b>Scarica file</b>.',
    conversationMessengerImportEncryptedDetailStep7: 'Inserisci la password Facebook e clicca su <b>Conferma</b>.',
    conversationMessengerImportEncryptedDetailStep8: 'Clicca su <b>Scarica</b>. La preparazione del file può richiedere alcuni minuti.',
    conversationMessengerImportEncryptedDetailStep9: 'Scarica il file <b>.zip</b> completo sul computer e caricalo qui sotto <b>senza aprirlo</b>. Solo la conversazione che sceglierai dopo verrà usata per il tuo libro.',
    conversationMessengerImportMissingTip: 'Chat assente dall\'elenco? Torna indietro e prova l\'export <b>Dopo il 2023</b>.',
    conversationMessengerImportEmptyTitle: 'Nessuna conversazione trovata in questo archivio',

    conversationSmsImportTagline: 'Nessun file da caricare qui: tutto avviene dal nostro software o app.',
    conversationSmsImportIntro: 'Nessun upload su questa pagina. Tutto avviene dal nostro software (iPhone) o dalla nostra app (Android). Scegli la tua configurazione:',
    conversationSmsImportContext: 'La nostra app Android <b>non è su Google Play</b>: l\'accesso agli SMS è limitato lì. Per aprirla, Android e Play Protect chiedono una conferma.',
    conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
    conversationSmsImportPlatformIphonePc: 'iPhone + PC',
    conversationSmsImportPlatformAndroid: 'Android',
    conversationSmsImportMacCta: 'Scarica software Mac',
    conversationSmsImportPcCta: 'Scarica software PC',
    conversationSmsImportAndroidCta: 'Scarica app Android',
    conversationSmsImportMacStep1: 'Scarica il software Mac.',
    conversationSmsImportMacStep2: 'Installalo e <b>lasciati guidare</b>: il software ti indica i passi da seguire.',
    conversationSmsImportMacStep3: 'Scegli la <b>conversazione</b> da inviare al tuo account e resta sullo schermo fino alla fine del trasferimento.',
    conversationSmsImportMacStep4: 'Installa il software sotto, concedi <b>accesso completo al disco</b> in Impostazioni di sistema → Privacy, poi scegli la conversazione da inviare al tuo account.',
    conversationSmsImportMacHelp: 'Se il software non trova il backup: Impostazioni di sistema → Privacy e sicurezza → <b>Accesso completo al disco</b> → aggiungi MonLivreSMS (sblocca il lucchetto in basso a sinistra).',
    conversationSmsImportMacAlert: 'Nessun upload qui: il trasferimento parte dal software, che ti guida a schermo.',
    conversationSmsImportPcStep1: 'Scarica il software PC.',
    conversationSmsImportPcHelp: 'In iTunes, verifica che <b>Crittografa backup locale</b> sia deselezionato prima di cliccare <b>Esegui backup adesso</b>. Guida visiva sopra.',
    conversationSmsImportHelpToggle: 'Serve un aiuto più dettagliato?',
    conversationSmsImportPcStep2: 'Installalo e <b>lasciati guidare</b>: il software ti indica i passi da seguire.',
    conversationSmsImportPcStep3: 'Scegli la <b>conversazione</b> da inviare al tuo account e resta sullo schermo fino alla fine del trasferimento.',
    conversationSmsImportPcStep4: 'Installa il software sotto, avvialo (autorizza se Windows avvisa), poi scegli la conversazione da inviare al tuo account.',
    conversationSmsImportPcAlert: 'Nessun upload qui: il trasferimento parte dal software, che ti guida a schermo.',
    conversationSmsImportAndroidStep1: 'Sul tuo Android, scarica la nostra <b>app fuori store</b> sotto: l\'accesso SMS non è consentito su Google Play.',
    conversationSmsImportAndroidStep2: 'Apri il file scaricato. Se Android non consente l\'installazione, tocca <b>Impostazioni</b>, attiva <b>Consenti da questa origine</b>, poi torna indietro.',
    conversationSmsImportAndroidStep3: 'Se compare <b>Play Protect</b>, tocca <b>Altri dettagli</b>, poi <b>Installa comunque</b>. Poi tocca <b>Installa</b> e <b>Apri</b>.',
    conversationSmsImportAndroidStep4: 'Nell\'app, accetta l\'accesso a <b>SMS</b> e <b>contatti</b>.',
    conversationSmsImportAndroidStep5: 'Scegli la <b>conversazione</b> e conferma. Resta sullo schermo fino alla fine: i messaggi vanno direttamente al tuo account.',
    conversationSmsImportAndroidAlert: 'Nessun file da caricare qui. Resta sulla schermata di trasferimento nell\'app per includere tutte le foto.',
    conversationSmsImportFooter: 'Trasferimento completato? Personalizza il libro su questo sito: l\'app ti reindirizzerà automaticamente.',
	conversationSmsImportAndroidDetailIntro: 'Segui ogni passaggio sul telefono Android. L\'app <b>non è su Google Play</b>. Android, poi Play Protect, chiedono una conferma prima di aprirla: è normale.',
	conversationSmsImportAndroidDetailSkipApp: 'Ho già scaricato l\'app: vai al passaggio 2',
	conversationSmsImportAndroidDetailStep1: 'Scarica la nostra app di export SMS fuori da Google Play (pulsante sotto): l\'accesso SMS non è consentito sul Play Store.',
	conversationSmsImportAndroidDetailStep2: 'Dopo il download, tocca <b>Apri</b>.',
	conversationSmsImportAndroidDetailStep3: 'Tocca <b>Impostazioni</b> per autorizzare l\'installazione.',
	conversationSmsImportAndroidDetailStep4: 'Attiva <b>Consenti da questa fonte</b>, poi torna indietro per ritrovare l\'installazione.',
	conversationSmsImportAndroidDetailStep5: 'Se compare <b>Play Protect</b>, tocca <b>Altri dettagli</b>, poi <b>Installa comunque</b>. Installa, apri l\'app e accetta l\'accesso a SMS e contatti.',
	conversationSmsImportAndroidDetailStep6: 'Seleziona la <b>conversazione</b> desiderata.',
	conversationSmsImportAndroidDetailStep7: 'Conferma e valida: resta sulla schermata di trasferimento fino alla fine per includere tutte le foto. Sarai reindirizzato automaticamente per personalizzare il libro.',
	conversationSmsImportAndroidDetailTitle: 'Export SMS Android: guida dettagliata',
	conversationSmsImportMacDetailIntro: 'Scarica il software e lasciati guidare a schermo. Le schermate qui sotto aiutano soprattutto per l\'installazione.',
	conversationSmsImportMacDetailSkipSoftware: 'Ho già scaricato il programma: vai al passaggio 8',
	conversationSmsImportMacDetailStep1: 'Collega il tuo iPhone al Mac con un cavo USB.',
	conversationSmsImportMacDetailStep10: 'Apri <b>Impostazioni di sistema</b> → <b>Privacy e sicurezza</b>.',
	conversationSmsImportMacDetailStep11: 'Scorri in basso e clicca su <b>Apri comunque</b>.',
	conversationSmsImportMacDetailStep12: 'Nell\'avviso di sicurezza, clicca su <b>Consenti</b>.',
	conversationSmsImportMacDetailStep13: 'Clicca su <b>Apri</b>.',
	conversationSmsImportMacDetailStep14: 'Clicca su <b>Continua</b>.',
	conversationSmsImportMacDetailStep15: 'Clicca di nuovo su <b>Continua</b>.',
	conversationSmsImportMacDetailStep16: 'Clicca su <b>Installa</b>.',
	conversationSmsImportMacDetailStep17: 'Nell\'avviso di sicurezza, clicca di nuovo su <b>Consenti</b>.',
	conversationSmsImportMacDetailStep18: 'Clicca su <b>Chiudi</b> per uscire dall\'assistente.',
	conversationSmsImportMacDetailStep19: 'Apri <b>Finder</b> → <b>Applicazioni</b> e avvia <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Per le foto nel libro: apri <b>Messaggi</b>, seleziona la conversazione e tocca il <b>nome del contatto</b>.',
	conversationSmsImportMacDetailStep20: 'Clicca sul <b>menu Apple</b> in alto a sinistra → <b>Impostazioni di sistema</b>.',
	conversationSmsImportMacDetailStep21: 'Apri <b>Privacy e sicurezza</b> → <b>Accesso completo al disco</b>.',
	conversationSmsImportMacDetailStep22: 'Trascina l\'icona MonLivreSMS nell\'elenco (clic prolungato) e spunta <b>Accesso completo al disco</b>.',
	conversationSmsImportMacDetailStep23: 'Clicca su <b>Apri</b> per confermare.',
	conversationSmsImportMacDetailStep24: 'Clicca di nuovo su <b>Apri</b> se appare una seconda conferma.',
	conversationSmsImportMacDetailStep25: 'Scegli la <b>conversazione</b> da esportare: testi e foto saranno inviati al tuo account. Resta sulla schermata di trasferimento fino alla fine, con connessione stabile.',
	conversationSmsImportMacDetailStep3: 'Scorri fino in fondo alla scheda contatto.',
	conversationSmsImportMacDetailStep4: 'Tocca <b>Scarica</b> per importare tutte le foto iCloud sull\'iPhone.',
	conversationSmsImportMacDetailStep5: 'Apri il <b>Finder</b>, seleziona l\'iPhone nella barra laterale, deseleziona <b>Cifra backup locale</b> e attiva <b>Esegui backup di tutti i dati su questo Mac</b>.',
	conversationSmsImportMacDetailStep6: 'Clicca su <b>Esegui backup adesso</b> e attendi il completamento.',
	conversationSmsImportMacDetailStep7: 'Scarica il software MonLivreSMS per Mac (pulsante sotto in questa pagina).',
	conversationSmsImportMacDetailStep8: 'Fai doppio clic sulla cartella <b>MonLivreSMS</b> scaricata.',
	conversationSmsImportMacDetailStep9: 'Clicca su <b>OK</b> per avviare l\'installazione.',
	conversationSmsImportMacDetailTitle: 'Export SMS iPhone + Mac: guida dettagliata',
	conversationSmsImportPcDetailIntro: 'Scarica il software e lasciati guidare a schermo. Le schermate qui sotto aiutano soprattutto per l\'installazione.',
	conversationSmsImportPcDetailSkipSoftware: 'Ho già scaricato il programma: vai al passaggio 3',
	conversationSmsImportPcDetailStep1: 'Collega il tuo iPhone al PC con un cavo USB.',
	conversationSmsImportPcDetailStep2: 'Scarica il software MonLivreSMS per PC (pulsante sotto in questa pagina).',
	conversationSmsImportPcDetailStep3: 'Installa <link>iTunes</link> se non lo hai già.',
	conversationSmsImportPcDetailStep4: 'Avvia iTunes.',
	conversationSmsImportPcDetailStep5: 'Accedi con il tuo <b>ID Apple</b> e approva sull\'iPhone se richiesto.',
	conversationSmsImportPcDetailStep6: 'Quando l\'iPhone è riconosciuto, clicca su <b>Continua</b>.',
	conversationSmsImportPcDetailStep7: 'In <b>Riepilogo</b>, deseleziona <b>Cifra backup locale</b> e clicca su <b>Esegui backup adesso</b> (su questo computer, non iCloud).',
	conversationSmsImportPcDetailStep8: 'Al termine del backup, apri la cartella MonLivreSMS. Se Windows mostra un avviso, clicca su <b>Ulteriori informazioni</b> poi <b>Esegui comunque</b>. Scegli la conversazione da inviare al tuo account.',
	conversationSmsImportPcDetailTitle: 'Export SMS iPhone + PC: guida dettagliata',
    /* --- sync 2026-06-29 --- */
    autocompleteSearch: 'Digita per cercare…',
    cmsAdminListHint: 'Modifica pagine, pannelli e traduzioni. Le bandiere indicano lo stato di traduzione per lingua.',
    cmsContentDuplicateSuccess: 'Contenuto CMS duplicato!',
    cmsPageAdd: 'Aggiungi una pagina',
    code: 'Codice',
    configAdminHint: 'Impostazioni app, affiliazioni, processi in background e chiavi di configurazione.',
    console: 'Console',
    conversationAdminListHint: 'Sfoglia, filtra e gestisci tutte le conversazioni. Usa le schede stato per ogni fase.',
    conversationBackToList: 'Torna alle mie conversazioni',
    conversationCreationDate: 'Data di creazione',
    conversationCustomImportUpload: 'Importa file generato',
    conversationDownloadBackPreview: "Torna all'anteprima",
    conversationDownloadEyebrow: 'Il tuo libro è pronto',
    conversationDownloadHint: 'Scarica il PDF e conserva una copia digitale della conversazione.',
    conversationDownloadLoading: 'Preparazione dei file…',
    conversationFlags: 'Bandiere',
    conversationHighlightShareImageButton: 'Invia l\'immagine',
    conversationHighlightsEmpty: 'Servono ancora alcuni messaggi per tirarne fuori i numeri.',
    conversationHighlightsLoading: 'Stiamo raccogliendo i numeri.',
    conversationImages: 'Immagini',
    conversationMedias: 'Media',
    conversationMergeSelect: 'Seleziona questa conversazione',
    conversationMergeUnselect: 'Deseleziona questa conversazione',
    conversationOrders: 'Ordini',
    conversationPreviewCoverEditButton: 'Modifica copertina',
    conversationPreviewCoverOpenLabel: 'Apri il libro',
    conversationPreviewCustomizeClose: 'Chiudi personalizzazione',
    conversationPreviewCustomizeDone: 'Termina personalizzazione',
    conversationPreviewEditionBelowHint: 'Scegli la tua edizione più sotto',
    conversationPreviewEditionScrollLabel: 'Vai alla sezione edizione',
    conversationPrinterMode: 'Modalità stampatore',
    copiedToClipboard: 'Copiato!',
    country: 'Paese',
    dateStatus: 'Data di stato',
    dateValidation: 'Data di convalida',
    dates: 'Date',
    identifier: 'Identificativo',
    loadMore: 'Carica altro…',
    orderAdminListHint: 'Gestisci ordini per stato. Filtra per paese, prodotto o data di convalida.',
    orderConfirmationGuestTitle: 'Resta informato',
    orderConfirmationHomeCta: 'Torna alla home',
    orderConfirmationNextStepsTitle: 'E adesso?',
    orderConfirmationOrderNumber: 'Ordine n. {code}',
    orderConfirmationPaymentWaitingHint: 'Di solito bastano pochi secondi.',
    orderConfirmationStepEmail: 'Conferma via email',
    orderConfirmationStepEmailDesc: 'Un riepilogo è stato inviato a {email}',
    orderConfirmationStepEmailDescNoEmail: 'Riceverai un riepilogo via email',
    orderConfirmationStepPreparation: 'Preparazione del tuo libro',
    orderConfirmationStepPreparationDesc: 'Stampiamo e rilegiamo il tuo libro con cura',
    orderConfirmationStepShipping: 'Spedizione',
    orderConfirmationStepShippingDesc: "Riceverai un'email appena il pacco sarà spedito",
    orderConfirmationSummaryTitle: 'Il tuo ordine',
    orderConfirmationViewOrderCta: 'Segui il mio ordine',
    orderFlags: 'Bandiere',
    orderMassExportInvoiceDetails: 'Esporta dettaglio fatture',
    orderMassSendEmail: 'Invia email',
    orderMassUpdateStatus: 'Aggiorna stato',
    orderNote: 'Nota',
    orderNoteAdmin: 'Nota interna (admin)',
    orderNoteAdminAdd: 'Aggiungi una nota',
    orderNoteAdminEmpty: 'Nessuna nota interna per questo ordine.',
    orderNoteAdminPlaceholder: 'Nota interna visibile solo al team (spedizione, supporto…)',
    orderPaymentMethod: 'Metodo di pagamento',
    orderPublicAccess: 'Accesso pubblico',
    orderSendStatusNotificationEmail: 'Invia email di notifica',
    orderViewShort: 'Ordine',
    ordersEditSuccess: 'Ordini aggiornati!',
    product: 'Prodotto',
    productAdd: 'Aggiungi un prodotto',
    productAdminListHint: 'Gestisci catalogo, prezzi e disponibilità del negozio.',
    seoOrderViewTitle: 'Ordine n. {code}',
    shippingAdd: 'Aggiungi un metodo',
    shippingAdminListHint: 'Configura corrieri, paesi e regole tariffarie per le spedizioni.',
    shippingMethod: 'Metodo di spedizione',
    tableDownloadNoElementError: 'Niente da scaricare!',
    tablePageSize: 'Per pagina',
    taskAddTitle: "Aggiungi un'attività",
    taskAssignSelf: 'Assegnami',
    taskCountdownDate: 'Data promemoria',
    userAccountNote: 'Nota account utente',
    userAdminListHint: 'Cerca account, consulta attività e apri profilo o ordini di un utente.',
    vatExempt: 'ESENTE IVA',
    voucherAdd: 'Aggiungi un buono',
    voucherAdminListHint: "Crea e gestisci codici promo, condizioni e limiti d'uso.",

	offerErrorRequired: 'Compila i campi obbligatori, per favore.',
	offerErrorEmail: 'Controlla il tuo indirizzo email.',
	offerErrorGiftEmail: 'Controlla l\'email della persona a cui lo regali.',
	offerErrorGiftSameEmail: 'L\'email di chi riceve il regalo deve essere diversa dalla tua.',
	offerErrorGeneric: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
	offerStepWhoEyebrow: 'Cominciamo',
	offerStepWhoTitle: 'Chi creerà il libro?',
	offerStepWhoHint: 'Lo componi tu, per te o per regalarlo. La carta regalo è se lo crea l\'altra persona.',
	offerWhoSelf: 'Lo creerò io',
	offerWhoSelfHint: 'Per me, o da regalare una volta stampato',
	offerWhoGift: 'Offro una carta regalo',
	offerWhoGiftHint: 'La persona riceve un link e crea il suo libro',
	offerStepOccasionEyebrow: 'L\'occasione',
	offerStepOccasionHint: 'Il momento a cui stai pensando.',
	offerStepGiftEyebrow: 'Il tuo regalo',
	offerStepGiftTitle: 'A chi lo regali?',
	offerStepGiftHint: 'Inviamo il regalo via email, con un link per creare il libro. Niente da stampare, niente da incartare.',
	offerGiftName: 'Il suo nome',
	offerGiftEmail: 'La sua email',
	offerGiftEmailHelp: 'Il regalo arriva in questa casella email subito dopo il pagamento.',
	offerGiftFromName: 'Il tuo nome',
	offerGiftFromNameHelp: 'Così saprà da chi arriva il regalo.',
	offerGiftMessage: 'Un pensiero (facoltativo)',
	offerGiftMessagePlaceholder: 'Perché questi messaggi ti restino sempre vicini.',
	offerContinue: 'Continua',
	offerStepMessengerEyebrow: 'I tuoi messaggi',
	offerStepMessengerTitleGift: 'Dove sono i messaggi del libro di {name}?',
	offerStepMessengerTitle: 'Dove sono i tuoi messaggi più belli?',
	offerStepMessengerHint: 'Scegline una. Potrai cambiarla in seguito.',
	offerStepMessengerHintGift: 'La tua conversazione con {name}, o la sua con una persona cara. Non sai quale app? {name} potrà sceglierne un\'altra.',
	offerStepEmailEyebrow: 'Ci siamo quasi',
	offerStepEmailTitle: 'Il tuo account',
	offerStepEmailHintGift: 'Google, Apple o la tua email. Ti inviamo una conferma, poi paghi la carta regalo.',
	offerStepEmailHint: 'Google, Apple o la tua email. Ti inviamo una conferma, poi importi la conversazione.',
	offerStepEmailHintPay: 'Google, Apple o la tua email. Ti inviamo una conferma, poi paghi il libro.',
	offerEmailLabel: 'Indirizzo email',
	offerEmailPlaceholder: 'tu@esempio.it',
	offerEmailSubmit: 'Vai al pagamento',
	offerEmailSubmitAccount: 'Crea il mio account',
	offerEmailPrivacy: 'Solo il tuo libro. Controlla anche la cartella spam.',
	offerStepSentEyebrow: 'Che bello rivederti',
	offerStepSentTitle: 'Hai già un account',
	offerStepSentCodeHint: 'Ti abbiamo appena inviato un codice di 6 cifre a {email}. Inseriscilo qui: il tuo ordine ti aspetta, pronto per il pagamento. Controlla anche la cartella spam.',
	offerStepSentCodeHintAccount: 'Ti abbiamo appena inviato un codice di 6 cifre a {email}. Inseriscilo qui per aprire il tuo account e iniziare il libro. Controlla anche la cartella spam.',
	offerStepPayEyebrow: 'Ultimo passaggio',
	offerStepPayTitleGift: 'Il libro per {name}',
	offerStepPayTitle: 'Il tuo libro stampato',
	offerLoggedAs: 'Accesso effettuato come {email}',
	offerSwitchAccount: 'Non sei tu?',
	offerTrustReviews: 'Oltre {count} recensioni su Trustpilot',
	offerTrustGuarantee: 'Soddisfatti o rimborsati',
	offerTrustShipping: 'Spedizione gratuita',
	offerPageTitle: 'Il tuo libro di messaggi',
	offerBack: 'Indietro',
	offerItemName: 'Libro stampato da personalizzare',
	offerPayBenefitBook: 'Il tuo libro stampato, impaginato con i tuoi messaggi e le tue foto',
	offerPayBenefitBookGift: 'Un vero libro stampato, con i messaggi e le foto che preferisce',
	offerPayBenefitMedia: 'Anche i vocali e i video, da rivivere grazie ai codici QR stampati',
	offerPayBenefitCustom: 'Copertina, foto, titolo, colori, prefazione: tutto si personalizza',
	offerPayBenefitPdf: 'Il PDF in omaggio con il libro',
	offerPayBenefitShipping: 'Spedizione gratuita',
	offerPayTotal: 'Totale',
	offerPayNextGift: 'Subito dopo il pagamento, {name} riceve il tuo regalo via email.',
	offerPayNextSelf: 'Subito dopo il pagamento, importi la conversazione. Qualche minuto.',
	offerPayDreamSelf: 'Quei messaggi che rileggi sul telefono, presto tra le tue mani. Per sempre.',
	offerPayDreamGift: 'Il giorno in cui {name} lo aprirà, tutti quei messaggi prenderanno vita tra le sue mani.',
	offerPayButton: 'Paga {price}',
	offerPaySecure: 'Pagamento sicuro. Nessun abbonamento.',
	offerConfirmStepsTitle: 'Come funziona',
	offerConfirmGiftStep1: '{name} apre l\'email e clicca sul link',
	offerConfirmGiftStep2: '{name} importa la conversazione in pochi minuti',
	offerConfirmGiftStep3: 'Stampiamo il libro e lo spediamo',
	offerConfirmGiftTitle: 'Inviato a {name}!',
	offerConfirmGiftLead: '{name} ha appena ricevuto il tuo regalo su {email}, con un link per creare il libro. È già pagato, spedizione inclusa.',
	offerConfirmViewOrder: 'Vedi il mio ordine',
	offerConfirmGiftNote: 'Non è arrivato? Fai controllare la cartella spam oppure scrivici.',
	offerConfirmStep1: 'Esporta la tua conversazione da {messenger}',
	offerConfirmStep1Generic: 'Esporta la tua conversazione dalla tua app di messaggistica',
	offerConfirmStep2: 'Importala qui: all\'impaginazione pensiamo noi',
	offerConfirmStep3: 'Conferma il tuo libro: lo stampiamo e te lo spediamo',
	offerConfirmTitle: 'Fatto, il tuo libro è pagato!',
	offerConfirmLead: 'Ti resta solo una cosa da fare: importare la tua conversazione {messenger}. Ti guidiamo passo dopo passo, bastano pochi minuti.',
	offerConfirmLeadGeneric: 'Ti resta solo una cosa da fare: importare la tua conversazione. Ti guidiamo passo dopo passo, bastano pochi minuti.',
	offerConfirmCta: 'Importa la mia conversazione {messenger}',
	offerConfirmCtaGeneric: 'Importa la mia conversazione',
	offerConfirmChangeMessenger: 'I miei messaggi sono su un\'altra app',
	offerConfirmEmailNote: 'Ti abbiamo inviato la ricevuta e il link di accesso a {email}.',
	userMagicTitle: 'Accedi',
	userMagicWorking: 'Accesso in corso…',
	userMagicExpired: 'Questo link è scaduto. Richiedine uno nuovo con un clic.',
	userMagicInvalid: 'Questo link non è più valido. Richiedine uno nuovo con un clic.',
	userMagicSent: 'Se esiste un account con questo indirizzo, un nuovo link è in arrivo. Controlla anche la cartella spam.',
	userMagicEmailLabel: 'Il tuo indirizzo email',
	userMagicSend: 'Ricevi un nuovo link',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Incluso',
	conversationPreviewCollectionPrepaidNote: '{count} tomi · {paid, plural, one {# già pagato} other {# già pagati}}',
	conversationPreviewBookCreditBannerBestof: 'Il tuo libro è già pagato: il Best Of è incluso. Preferisci la collezione completa? Paghi solo la differenza.',
	conversationPreviewBookCreditBanner: 'Il tuo libro è già pagato, spedizione standard inclusa. Personalizzalo e poi completa il tuo ordine.',
	conversationOrderButtonBookCreditRemaining: 'Completa il mio libro · restano {price}',
	conversationOrderButtonBookCreditIncluded: 'Completa il mio libro · Incluso',
	conversationPreviewBookCreditOrderHint: '{credit} già pagati · prezzo di listino {fullPrice}',
	conversationOrderButtonBookCredit: 'Completa il mio libro',
	conversationPreviewStickyBookCredit: 'Libro già pagato',
	paymentMethodBookCreditHint: 'Il tuo libro è già pagato',
	cartTotalsBookCredit: 'Libro già pagato',
	paymentMethodBookcredit: 'Libro pagato in anticipo',
  },
};
